import {Urls} from '../constants'
import 'styles/base.scss'
import { tableLabels } from "../utils/formatFormTables.js";
import { waitForElem } from "../utils/waitForElem.js";
import { createPop } from "../utils/createPop.js";
import { userType } from "../utils/userType.js";

(function(){

	/* global $ */
	'use strict';

	const userInfo = userType(Urls);

	const pagePath = window.location.pathname;
	const pageUrl = window.location.href;

	let currentState = {
		summaryParameters : {},
		displayHeroMenu: true
	}

	const authSettings = $.sc.authSettings;

	// Function to remove the loading screen
	function hideLoadingScreen() {
		let loadingOverlay = document.getElementById("loading-overlay");
		if (loadingOverlay) {
			loadingOverlay.style.opacity = "0"; // Fade out
			loadingOverlay.style.transition = "opacity 0.2s ease-out"; // Smooth transition
	
			// Remove the overlay from DOM after the fade-out effect
			setTimeout(() => loadingOverlay.remove(), 200); // Wait for transition to complete
		}
	}

	function scrollToMain() {
		const mainElement = document.querySelector('main');
		if (mainElement) {
			window.scrollTo({
				top: mainElement.offsetTop,
				behavior: 'smooth'
			});
		}
	}

	function summaryParameters(callback) {
		fetch("/s4s/api/PPLDashboard/SummaryParameters", {
            "headers": {
                "content-type": "application/json",
            },
            // "body": JSON.stringify(dataObj),
            "method": "POST",
            "mode": "cors",
            "credentials": "include"
        })
        .then(function(data){ 
            return data.json();
        })
        .then(function(data){ 
            console.log(data)

			// Error
            // if ( data.Errors.length > 0) {
            //     createModel('Unable to create payee', `<p> ${data.Errors[0].Description === null ? '' : data.Errors[0].Description} ${data.Errors[0].MessageResource === null ? '' : data.Errors[0].MessageResource} </p>`)
			// }

            callback(data);
        })
	}

	async function getUserEndpoint(userId) {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/PPLUser/Get/${userId}`);
		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}

	function observeCreationOfElement(tagName, callback, targetNode = document.body) {
		// Options for the observer (which mutations to observe)
		const config = { childList: true, subtree: true };
	
		// Mutation observer callback function
		const mutationCallback = function(mutationsList, observer) {
			for (const mutation of mutationsList) {
				if (mutation.type === 'childList') {
					mutation.addedNodes.forEach(node => {
						// Check if the added node is the desired element
						if (node.nodeName === tagName.toUpperCase()) {
							console.log(`${tagName} has been added to the page!`);
							callback(node); // Execute callback function with the node as an argument
						}
					});
				}
			}
		};
	
		// Create an instance of the observer with the callback function
		const observer = new MutationObserver(mutationCallback);
	
		// Start observing the target node for configured mutations
		observer.observe(targetNode, config);
	
		// Return the observer instance in case it needs to be disconnected later
		return observer;
	}

	function observeCreationOfClass(className, callback, targetNode = document.body) {
		// Options for the observer (which mutations to observe)
		const config = { childList: true, subtree: true };
	
		// Mutation observer callback function
		const mutationCallback = function(mutationsList, observer) {
			for (const mutation of mutationsList) {
				if (mutation.type === 'childList') {
					mutation.addedNodes.forEach(node => {
						// Check if the added node has the desired class
						if (node.classList && node.classList.contains(className)) {
							console.log(`${className} class element has been added to the page!`);
							callback(node); // Execute callback function with the node as an argument
						}
					});
				}
			}
		};
	
		// Create an instance of the observer with the callback function
		const observer = new MutationObserver(mutationCallback);
	
		// Start observing the target node for configured mutations
		observer.observe(targetNode, config);
	
		// Return the observer instance in case it needs to be disconnected later
		return observer;
	}

	

	function postOrganisationType(callback) {
		if(authSettings.login !== null){
			callback(authSettings);

		} else {
			callback('');
		}
	}

	function createBlueBtns() {
		// Add class to action btns and remove icons/images
		$('.action-btns-section a').addClass('blue-btn');
		$('.action-btns-section i').remove();
		$('.action-btns-section img').remove();
	}

	function editButtons(element) {
		// Edit product item buttons
		$(element + ' li').removeClass();
		$(element + ' a').addClass('blue-btn');
		$(element + ' img').remove();
	}

	postOrganisationType(function(currentUser) {
	
		function uuidv4() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		}

		function showLoginLogout() {
			if(authSettings.login === null){

				$('.js-header-nav_bottom-container-mobile__credentials').append(
					`
					<div class="header-nav_auth-workas-container-mobile">
						<a class="" href="/s4s/auth/signinoidc">
							<span class="header-nav_main-item-title"><i class="header-nav_item-icon-left fas fa-sign-in-alt"></i>Log in</span>
						</a>
					</div>
					`
				);
		
				$('.js-header-nav_top-nav-container-desktop').append(
					`
					<li class="header-nav_top-nav-item-container">
						<a class="" href="/s4s/auth/signinoidc">
							<p class="header-nav_top-nav-item-title">Log in <i class="header-nav_top-nav-item-icon fas fa-sign-in-alt"></i></p>
						</a>
					</li>
					`
				);
		
			} else {

				// Show log out button
				$('.js-header-nav_bottom-container-mobile__credentials').append(
					`
					<div class="header-nav_auth-workas-container-mobile">
						<a class="" href="/s4s/Auth/Logout">
							<span class="header-nav_main-item-title"><i class="header-nav_item-icon-left fas fa-sign-out-alt"></i>Log out</span>
						</a>
					</div>
					`
				);
				$('.js-header-nav_top-nav-container-desktop').append(
					`
					<li class="header-nav_top-nav-item-container">
						<a class="" href="/s4s/Auth/Logout">
							<p class="header-nav_top-nav-item-title">Log out <i class="header-nav_top-nav-item-icon fas fa-sign-out-alt"></i></p>
						</a>
					</li>
					`
				);
			}
		}
	
		function checkAuth() {
	
			// SAG pplRoleId
			if (currentUser.PplRoleId === '22a21fd3-9b01-4c07-a8a9-e70d17fbb4da' ) {

				//console.log('SAG id is firing')
				createWorkAsLink('/s4s/UserManagement/Users');

			} else {

				let mods = [];

				$(currentUser.availableModules).each(function(i , el){
					mods.push(el);
				});
				mods = mods.toString();

				// Work as page
				// work_as = true && user_management = true OR work_as = true && user_management = false
				if(mods.indexOf('work_as') > -1){

					//console.log('userjson work as is firing')

					// Added on 20th May 2024 for Lincolnshire as they are not using OE fully 
					// CORE-950 update AR work as settings for Lincolnshire OE
					if ($.sc.authSettings.pplId !== null && $.sc.authSettings.organisationId !== '4904d5d2-482a-41a9-9153-9e360154daa2' && $.sc.authSettings.isAuthorizedRepresentative === true ) {
						createWorkAsLink("/s4s/CustomPage/Index/" + Urls.myParticipants);
					} else {
						createWorkAsLink('/s4s/WorkAs');
					}
				};
				
				// User management page
				// work_as module = false && user_management = true
				if(mods.indexOf('work_as') <= -1){

					if(mods.includes('user_management')) {

						//console.log('user management as page is firing')
						createWorkAsLink('/s4s/UserManagement/Users');
					};
				};
			};

			// Log in / Logout
			showLoginLogout();

			//checkMessages(data.PplRoleId);
			virtualWalletNav();
		};


		function createWorkAsLink(url) {
			$('.js-header-nav_bottom-container-mobile__credentials').append(
				`
				<div class="header-nav_auth-workas-container-mobile js-workas-btn">
					<a class="" href="${url}">
						<span class="header-nav_main-item-title"><i class="header_nav-work-as-icon fas fa-users"></i>Work as</span>
					</a>
				</div>
				`
			);
			$('.js-header-nav_top-nav-container-desktop').append(
				`
				<li class="header-nav_top-nav-item-container js-workas-btn">
					<a class="" href="${url}">
						<p class="header-nav_top-nav-item-title"><i class="header_nav-work-as-icon fas fa-users"></i>Work as</p>
					</a>
				</li>
				`
			);
		}

		
		// Admin pannel /////////////////////////////////////////////////////

		// Creates the page structure
		function adminbarPageStructure(){

			// HTML display flex
			$('html').css('display', 'flex');


			// Body margin left
			$('body').css('margin-left', '50px');


			// Remove fixed position from the header
			$('.header-nav_section').css('position', 'static');


			// Remove margin-top from page
			$('#maincontent').css('margin-top', '0px');


			// Insert adminbar into body to appear as sibling of page content div
			$('body').prepend(
				`
				<div class='adminbar_container'>
				<i class="adminbar_icon adminbar_toggle-icon fas fa-arrow-right"></i>
				<div class="adminbar_back-step-container js-adminbar_back-step-container">
						<i class="adminbar_icon adminbar_back-icon fas fa-chevron-left adminbar_hide-el"></i>
						<p class="adminbar_item-heading adminbar_back-heading adminbar_hide-el">Administration</p>
					</div>
					<div class="adminbar_dropdown-section-heading-container adminbar_hide-el">
						<p class="adminbar_dropdown-section-heading"></p>
					</div>
					<div class="adminbar_nav-items-container"></div>
					<div class="adminbar_dropdown-items-container adminbar_hide-el"></div>
					</div>
				</div>
				`
			);
			
		}


		// Creates a main nav item
		function createNavItem(name, icon, url){
			return `
				<a href="${url}" class="adminbar_main-nav-item-container js-adminbar_item-link">
					<div class="adminbar_icon adminbar_nav-item-icon">
						<i class="adminbar_item-icon fas ${icon}"></i>
						<p class="adminbar_tooltip adminbar_hide-el">${name}</p>
					</div>
					<p class="adminbar_item-heading adminbar_nav-item-heading adminbar_hide-el">${name}</p>
				</a>
			`
		}

		// Adminbar functionality
		// Call the user modules
		if(authSettings.login !== null){
			if ( currentUser.availableModules ) {
				currentUser.availableModules.map((adminModule) => {
			
					// Check if admin module is available
					if(adminModule === 'administration'){

						var cmsElement = '';
						var directoriesElement = '';
						var formsElement = '';
						var adminElement = '';
						var librariesElement = '';
						var notificationsElement = '';
						var bulkOrdersElement = '';
						var providerManagementElement = '';
						var intergrationElement = '';
						var manageUserElement = '';
						var financeManagerElement = '';
						var fileImport = '';
						var templatesElement = '';
						var groupsElement = '';

						// Creates the page structure
						adminbarPageStructure();

						currentUser.availableModules.map((module) => {

							if(module === 'content_management'){
								cmsElement = createNavItem("CMS", "fa-pencil-alt", "/s4s/CmsContexts/Summary");
							};
							if(module === 'event_management_administration'){
								directoriesElement = createNavItem("Directories", "fa-address-book", "/s4s/EventsAdministration/Events");
							};
							if(module === 'form_management_administration'){
								formsElement = createNavItem("Forms", "fa-check-square", "/s4s/FormsAdministration");
							};
							if(module === 'content_management_administration'){
								adminElement = createNavItem("Admin (CMS, Directories, Forms)", "fa-cogs", "/s4s/CmsAdministrationSummary");
							};
							if(module === 'library_management_administration'){
								librariesElement = createNavItem("Libraries", "fa-book", "/s4s/LibraryAdministration");
							};
							if(module === 'notifications'){
								notificationsElement = createNavItem("Notifications", "fa-bell", "/s4s/NotificationsAdministration");
							};
							if(module === 'bulk_orders_administration'){
								bulkOrdersElement = createNavItem("Bulk orders", "fa-archive", "/s4s/BulkOrderAdministration");
							};
							if(module === 'provider_management_administration'){
								providerManagementElement = createNavItem("Provider Management", "fa-address-card", "/s4s/ProviderManagementAdministration");
							};
							if(module === 'integration'){
								intergrationElement = createNavItem("Integration", "fa-handshake", "/s4s/IntegrationAdministration");
							};
							if(module === 'user_management'){
								manageUserElement = createNavItem("Manage User", "fa-user", "/s4s/UserManagement");
							};
							if(module === 'finance_management_administration'){
								financeManagerElement = createNavItem("Finance Manager", "fa-balance-scale", "/s4s/FinanceManagementAdministration");
							};
							if(module === 'file_import'){
								fileImport = createNavItem("File Import", "fa-file-upload", "/s4s/FileImport");
							};
							// This has removed from the module check as there is currently no module for the templates section. Added manually below, based on isSag === true
							// if(module === ''){
							// 	templatesElement = createNavItem("Templates", "fa-clone", "/s4s/DocumentTemplatesManagement");
							// };
							if(module === 'group_management'){
								groupsElement = createNavItem("Groups", "fa-users", "/s4s/GroupsAdministration/Summary");
							};

						});

						if(authSettings.isSag === true){

							templatesElement = createNavItem("Templates", "fa-clone", "/s4s/DocumentTemplatesManagement");

						};

						
						// Adds individual adminbar nav item container
						$('.adminbar_nav-items-container').append(
							`
							${cmsElement}
							${directoriesElement}
							${formsElement}
							${
								// Hide 'Admin (CMS, Directories, Forms)' from nav on PeoplePlus
								pagePath.includes('peopleplus') === -1 && authSettings.login.indexOf('@peopleplus.co.uk') === -1
								? ``
								: adminElement
							}
							${librariesElement}
							${notificationsElement}
							${bulkOrdersElement}
							${providerManagementElement}
							${intergrationElement}
							${manageUserElement}
							${financeManagerElement}
							${fileImport}
							${templatesElement}
							${groupsElement}
							`
						);

					
						// Expand admin section when adminbar is clicked
						$('.adminbar_container').on('click', function(){
							
							if(!$('.adminbar_container').hasClass('adminbar_expand')) {

								localStorage.setItem("adminbar", "open");

								// When on main nav items section. Expand the adminbar, add the headings and change toggle arrow to left facing
								$('.adminbar_container').addClass('adminbar_expand');
								$('.adminbar_container').removeClass('adminbar_hover');
								$('.adminbar_item-heading').removeClass('adminbar_hide-el');
								$('.adminbar_back-heading').removeClass('adminbar_hide-el');
								$('.adminbar_toggle-icon').removeClass('fa-arrow-right');
								$('.adminbar_toggle-icon').addClass('fa-arrow-left');
								$('.adminbar_back-step-container').removeClass('adminbar_hide-el');
								$('body').addClass('body-left-margin');

								// When on sub nav items section
								$('.adminbar_dropdown-section-heading').removeClass('adminbar_hide-el');
								$('.adminbar_dropdown-item-link').removeClass('adminbar_hide-el');
				
							}
						});


						// When admibar main item icon is clicked
						$('.adminbar_main-nav-item-container').on('click', function(e){
							e.stopPropagation();
						});


						// When adminbar toggle arrow icon is clicked, 
						$('.adminbar_toggle-icon').on('click', function(e){
							e.stopPropagation();

							// If the adminbar is not expanded
							if(!$('.adminbar_container').hasClass('adminbar_expand')) {
								localStorage.setItem("adminbar", "open");

								// When on main nav items section. Expand the adminbar, add the headings and change toggle arrow to left facing
								$('.adminbar_container').addClass('adminbar_expand');
								$('.adminbar_container').removeClass('adminbar_hover');
								$('.adminbar_item-heading').removeClass('adminbar_hide-el');
								$('.adminbar_toggle-icon').removeClass('fa-arrow-right');
								$('.adminbar_toggle-icon').addClass('fa-arrow-left');
								$('.adminbar_back-step-container').removeClass('adminbar_hide-el');
								$('body').addClass('body-left-margin');

								// When on sub nav items section
								$('.adminbar_dropdown-section-heading').removeClass('adminbar_hide-el');
								$('.adminbar_dropdown-item-link').removeClass('adminbar_hide-el');

								
							} else {
								localStorage.setItem("adminbar", "closed");
								
								// If the adminbar is already expanded
								// When on main nav items section. Shrink the adminbar, hide the headings and change toggle arrow to right facing
								$('.adminbar_container').removeClass('adminbar_expand');
								$('.adminbar_item-heading').addClass('adminbar_hide-el');
								$('.adminbar_toggle-icon').removeClass('fa-arrow-left');
								$('.adminbar_toggle-icon').addClass('fa-arrow-right');
								$('.adminbar_back-step-container').addClass('adminbar_hide-el');
								$('body').removeClass('body-left-margin');
								
								// When on sub nav items section
								$('.adminbar_dropdown-section-heading').addClass('adminbar_hide-el');
								$('.adminbar_dropdown-item-link').addClass('adminbar_hide-el');
							}
						})


						// Loop through hidden CMS dropdown nav items and insert them into new dropdown items container
						$('#tree > li').each(function() {

							var dropdownItem = $(this).addClass('adminbar_dropdown-item');
							dropdownItem.appendTo('.adminbar_dropdown-items-container');

							var pageHeading = $('#administrationExcerpt h1').html();
								
							// Unhide dropdown section heading. Insert page section name
							$('.adminbar_dropdown-section-heading-container').removeClass('adminbar_hide-el');
							$('.adminbar_dropdown-section-heading').html(pageHeading);
							
							// Edits adminbar toggle heading
							$('.adminbar_back-heading').html('Back to Administration');
							
							// Unhide left side toggle arrow that takes you back. Hide right toggle arrow
							$('.adminbar_back-icon').removeClass('adminbar_hide-el');
							
							// Hide the container containing the main nav items
							$('.adminbar_nav-items-container').addClass('adminbar_hide-el');
							
							// Unhide dropdown nav items container
							$('.adminbar_dropdown-items-container').removeClass('adminbar_hide-el');
						});


						// Apply element and styling changes to each dropdown item
						$('.adminbar_dropdown-item a').each(function(i, item){

							// Remove the trigger element
							$('.trigger').remove();

							// Add a class to all dropdown item anchor tags
							$(item).addClass('adminbar_dropdown-item-link js-adminbar_item-link');
							
							// Remove classes to all dropdown item anchor tags
							$(item).removeClass('highlight roundb');

							// Remove old classes from dropdown items secondary dropdown and add new classes to them
							$('.adminbar_dropdown-item ul').removeClass('panel');
							$('.adminbar_dropdown-item ul').removeAttr('style');
							$('.adminbar_dropdown-item ul').addClass('adminbar_inner-dropdown-container adminbar_hide-el');

							// Add right chevron icon to dropdown items with inner dropdowns
							if($(item).attr('href') === '#'){
								$(item).append(
									`
									<i class="adminbar_dropdown-item-chevron fas fa-chevron-right"></i>
									`
								)
							}
						});
						
						
						// When clicking a dropdown item with an inner dropdown, toggle the inner dropdown container
						$('.adminbar_dropdown-item a').on('click', function(e){
							e.stopPropagation()

							if($(this).attr('href') === '#'){
								
								// Toggle the innder dropdown container
								$(this).siblings('.adminbar_inner-dropdown-container').toggleClass('adminbar_hide-el');
								$(this).siblings('.adminbar_inner-dropdown-container').toggleClass('adminbar_show-el');

								// Toggle the main dorpdown items chevron icon
								if($(this).children('.adminbar_dropdown-item-chevron').hasClass('fa-chevron-right')) {
									$(this).children('.adminbar_dropdown-item-chevron').removeClass('fa-chevron-right');
									$(this).children('.adminbar_dropdown-item-chevron').addClass('fa-chevron-down');
								} else {
									$(this).children('.adminbar_dropdown-item-chevron').removeClass('fa-chevron-down');
									$(this).children('.adminbar_dropdown-item-chevron').addClass('fa-chevron-right');
								}
							}
						})
						
						
						// Navigation from dropdown items section to main nav items section
						$('.js-adminbar_back-step-container').on('click', function(e){
							e.stopPropagation();

							$('.adminbar_nav-item-heading').removeClass('adminbar_hide-el');

							// Edits adminbar toggle heading
							$('.adminbar_back-heading').html('Administration');

							// Hide left side toggle arrow that takes you back. Unide right toggle arrow
							$('.adminbar_back-icon').addClass('adminbar_hide-el');

							// Hide dropdown section heading
							$('.adminbar_dropdown-section-heading-container').addClass('adminbar_hide-el');

							// Hide dropdown nav items container
							$('.adminbar_dropdown-items-container').addClass('adminbar_hide-el');

							// Unhide main nav items container
							$('.adminbar_nav-items-container').removeClass('adminbar_hide-el');
						});


						// Allows you to go forward and return to the nav sub items without refreshing the page
						// Loop thorugh main admin nav items
						$('.adminbar_nav-items-container a').each(function(i, el){

							var urlPath = $(el).attr('href');
							
							// Check if any of the main nav items href mathces the page url
							if(pagePath.includes(urlPath)) {
								// Remove the href from the matching main nav item
								$(el).removeAttr('href');

								$(el).on('click', function(e){
									e.stopPropagation();

									// $('.adminbar_container').addClass('adminbar_expand');
									$('.adminbar_back-step-container').removeClass('adminbar_hide-el');
									$('.adminbar_back-heading').removeClass('adminbar_hide-el');
									$('.adminbar_dropdown-section-heading').removeClass('adminbar_hide-el');
									$('.adminbar_dropdown-item-link').removeClass('adminbar_hide-el');
									$('.adminbar_toggle-icon').removeClass('fa-arrow-right');
									$('.adminbar_toggle-icon').addClass('fa-arrow-left');

									// Hide main nav items container
									$('.adminbar_nav-items-container').addClass('adminbar_hide-el');

									// Edits adminbar toggle heading
									$('.adminbar_back-heading').html('Back to Administration');
					
									// Unhide dropdown section heading
									$('.adminbar_dropdown-section-heading-container').removeClass('adminbar_hide-el');
									
									// Unhide back icon
									$('.adminbar_back-icon').removeClass('adminbar_hide-el');
					
									// Unhide dropdown nav items container
									$('.adminbar_dropdown-items-container').removeClass('adminbar_hide-el');
								})
							}
						});


						// If local storage item is set to open on page load
						if(localStorage.getItem("adminbar") === "open"){

							$('.adminbar_container').addClass('adminbar_expand');
							$('.adminbar_item-heading').removeClass('adminbar_hide-el');
							$('.adminbar_toggle-icon').removeClass('fa-arrow-right');
							$('.adminbar_toggle-icon').addClass('fa-arrow-left');
							$('.adminbar_back-step-container').removeClass('adminbar_hide-el');
							$('body').addClass('body-left-margin');
							
							// When on sub nav items section
							$('.adminbar_dropdown-section-heading').removeClass('adminbar_hide-el');
							$('.adminbar_dropdown-item-link').removeClass('adminbar_hide-el');
						}
						
						
						// If local storage item is set to closed on page load
						if(localStorage.getItem("adminbar") === "closed"){
							
							$('.adminbar_container').removeClass('adminbar_expand');
							$('.adminbar_item-heading').addClass('adminbar_hide-el');
							$('.adminbar_back-step-container').addClass('adminbar_hide-el');
							$('body').removeClass('body-left-margin');

							// When on sub nav items section
							$('.adminbar_dropdown-section-heading').addClass('adminbar_hide-el');
							$('.adminbar_dropdown-item-link').addClass('adminbar_hide-el');
						}


						// Adminbar mousenter functionality
						$('.adminbar_container').on('mouseenter', function(){

							if(localStorage.getItem("adminbar") === "closed"){

								$('.adminbar_container').addClass('adminbar_hover');
								$('.adminbar_item-heading').removeClass('adminbar_hide-el');
								$('.adminbar_back-step-container').removeClass('adminbar_hide-el');
								$('body').addClass('body-left-margin');
								
								// When on sub nav items section
								$('.adminbar_dropdown-section-heading').removeClass('adminbar_hide-el');
								$('.adminbar_dropdown-item-link').removeClass('adminbar_hide-el');
							}
						})
						
						// Adminbar mouseleave functionality
						$('.adminbar_container').on('mouseleave', function(){
							
							if(localStorage.getItem("adminbar") === "closed"){
								
								$('.adminbar_container').removeClass('adminbar_hover');
								$('.adminbar_item-heading').addClass('adminbar_hide-el');
								$('.adminbar_toggle-icon').removeClass('fa-arrow-left');
								$('.adminbar_toggle-icon').addClass('fa-arrow-right');
								$('.adminbar_back-step-container').addClass('adminbar_hide-el');
								$('body').removeClass('body-left-margin');

								// When on sub nav items section
								$('.adminbar_dropdown-section-heading').addClass('adminbar_hide-el');
								$('.adminbar_dropdown-item-link').addClass('adminbar_hide-el');
							}
						})


						// Add Id to every adminbar nav item and dropdown item icons
						$('.js-adminbar_item-link').each(function(i, el){
							
							$(el).attr('id', `adminbar_item-${i}`);
							$(el).siblings('.js-adminbar_dropdown-item-icon').attr('id', `adminbar_item-${i}`);
						});

						
						// Set local storage value to be the Id of the clicked admin item
						$('.js-adminbar_item-link, .js-adminbar_dropdown-item-icon').on('click', function(){
							
							const clickedItem = $(this).attr('id');
							localStorage.setItem("adminbar_active-item", clickedItem);
						});
						
						
						//  Add active highlight class to clicked admin nav item
						$('.js-adminbar_item-link').each(function(i, el){

							$(el).removeClass('adminbar_active-item');

							// Check which admin items Id matches the local storage value
							if(localStorage.getItem("adminbar_active-item") === $(el).attr('id')) {

								$(el).addClass('adminbar_active-item');
							}
						});


						// Keep inner dropdown open for item selected and change chevron to face down
						$('.adminbar_active-item').parents('.adminbar_inner-dropdown-container').toggleClass('adminbar_show-el');
						$('.adminbar_dropdown-item a').each(function(i, el){
							
							if($(el).hasClass('adminbar_active-item')) {
								$(this).parents('.adminbar_inner-dropdown-container').siblings('a').children().removeClass('fa-chevron-right').addClass('fa-chevron-down');
							};
						});

					
						// Mobile/Tablet
						if ($(window).width() <= 1023){	
							
							// When on a main CMS section page, load the dropdown items
							$('.adminbar_dropdown-items-container .adminbar_dropdown-item-link').on('click', function(){
								
								localStorage.setItem("adminbar", "closed");
							})
						}
				
					} else {

						return null;
					}

				});
			}
		}
	
		function scanForm(){
	
			console.log('Scan form is initiated');
	
			waitForElem(`.form-main__questions-container`).then(() => {

				// Show form header
				$('.s4s-pathway-header-container').show();
	
				// form-main
				if ( $('.navigation-bar__container').length ) {
	
					$('.navigation-bar__container').closest('.section').next().addClass('form-main');
				} else {
					$('.formContainer').find('.span_12_of_12').parent().addClass('form-main');
				}

				// For Skip to content link
				$('.form-main').attr('id', 'maincontent');
	
				// Contrast stuff
				$('.form-main').addClass('pcg-contrast__bg-alt pcg-contrast__bg-alt pcg-contrast__color-alt');
				$('h1').addClass('pcg-contrast__color-alt');
				$('label').addClass('pcg-contrast__color-extra');
				$('p').addClass('pcg-contrast__color-extra');
				$('legend').addClass('pcg-contrast__color-extra');

				// Make nav form bar tabbable
				$('.navigation-bar__item_clickable').attr('tabindex','0');
			});

			// This is a hack to get the calendar controls to render
			waitForElem(`.form-date__control`).then(() => {
				$('.form-date__control').parent().addClass('pcgf-default');
			});

		}
	
	
		
	
		function mobileTableLabels() {
	
			$('table').each(function() {
				$(this).find('th').each(function(i){
					var text = $(this).text();
					//console.log('This text is: ' + text);
		
					if ( text !== 'Available actions' && text !== 'Detail') {
						$(this).parent().parent().parent().find('td:nth-child(' + (i + 1) +')').prepend('<small class="mobile-table-header">' + text + ': </small>');
					}
				});
			})
		}

		// VW Lite - Creates mobile nav item with a quesiton mark icon
		function createMobileLinkwLite(text, link) {
			return `
				<li class="header-nav_sub-item-container-mobile">
					<a class="" href="${link}">
						<p class="header-nav_sub-item-title-mobile">${text}</p>
						<i class="header-nav_item-icon-right fas fa-chevron-right"></i>
					</a>
				</li>
			`
		}
	
		// VW Lite - Creates desktop main nav tab
		function createDesktopNavTabVwLite(name, link) {
			return `
			<a href="${link}" class="header-nav_bottom-item-container-desktop">${name}</a>
			`
		}
		
		// Creates mobile nav item with a quesiton mark icon
		function createMobileLink(text, link) {
			return `
				<li class="header-nav_sub-item-container-mobile">
					<a class="" href="${link}">
						<p class="header-nav_sub-item-title-mobile">${text}</p>
						<i class="header-nav_item-icon-right fas fa-chevron-right"></i>
					</a>
				</li>
			`
		}
	
		// Creates mobile nav item with an info icon
		function createMobileLinkInfo(text, link) {
			return `
				<li class="header-nav_sub-item-container-mobile">
					<a class="" href="${link}">
						<p class="header-nav_sub-item-title-mobile">${text}</p>
						<i class="header-nav_item-icon-right fas fa-chevron-right"></i>
					</a>
				</li>
			`
		}
	
		// Creates mobile nav section tab and container
		function createMobileNavTab(data, name) {
			return `
			<div class="header-nav_main-item-container-mobile">
				<h4 class="header-nav_main-item-title">${name}</h4>
				<ul class="js-header-nav-${data}-mobile"></ul>
			</div>
			`
		}
	
		// Creates desktop main nav tab
		function createDesktopNavTab(data, name, selected) {
			return `
			<li class="header-nav_bottom-item-container-desktop ${selected}" data-dropdown="${data}" role="menuitem" aria-haspopup="true" aria-expanded="false" aria-label="${name}" tabindex="0">
				<div class="">
					<i class="header-nav_bottom-nav-item-icon fas fa-chevron-down"></i>
					<p class="header-nav_main-item-title">${name}</p>
				</div>
			</li>
			`
		}
	
		// Creates desktop nav item with question mark icon
		function createDesktopLink(text, link, selected) {
			return `
			<li class="header-nav_bottom-nav-dropdown-item">
				<a class="header-nav_sub-item-title-desktop ${selected}" href="${link}">${text}</a>
			</li>
			`
		}
	
		// Creates desktop nav item with info icon
		function createDesktopLinkInfo(text, link, selected) {
			return `
			<li class="header-nav_bottom-nav-dropdown-item">
				<a class="header-nav_sub-item-title-desktop ${selected}" href="${link}">${text}</a>
			</li>
			`
		}
	
	
		// Displays the desktop navigation dropdowns and items depending on the page
		function selectedDesktopNavItem(navItem, noitem){
	
			var bottomItemsContainer = $(navItem).closest('.header-nav_bottom-dropdown-container');
	
			// Check if the selected dropdown item container has the same data as any of the main nav tabs, if so, add background colour to selected main nav tab
			$('.header-nav_bottom-item-container-desktop').each(function(j, tab){
				if($(bottomItemsContainer).data('dropdown') === $(tab).data('dropdown')) {
					$(tab).addClass('header-active-tab');
					$(tab).attr('aria-expanded', 'true');
				}
			})
			
			// Removes the bottom nav border
			$('.header-nav_bottom-section').addClass('header-active-dropdown-border');
			// Sets bottom dark nav bar to display
			$('.header-nav_bottom-dropdown-section').addClass('header-active-dropdown-section');
			// Sets selected nav item parent container to display
			$(bottomItemsContainer).addClass('header-active-dropdown-container');

			if ( noitem === undefined) {
				// Add blue text to active item
				$(navItem).css('color', '#b2e4f6');
			}
		}
	
	
	
		function virtualWalletNav() {
			
			let securityGuids = [];

			// Push securityGroups guids into array
			$(authSettings.securityGroups).each(function(i, el){

				securityGuids.push(el);
			});


			// Desktop
			let vwLiteDesktopDashboard_link = createDesktopNavTabVwLite('Dashboard', '/s4s/CustomPage/Index/' + Urls.vwProductOne);
			let vwLiteMyStatementDashboard_link = createDesktopNavTabVwLite('My statement', '/s4s/CustomPage/Index/' + Urls.vwProductTwo + '?query=');
			let vwLiteMyOrdersDashboard_link = createDesktopNavTabVwLite('My orders', '/s4s/MyOrders');
			let vwLiteMarkeplaceDashboard_link = createDesktopNavTabVwLite('Marketplaces', '/s4s/CustomPage/Index/' + Urls.searchShopServices + '?Page=Services&Search=');
			let vwLiteMyDocumentsDashboard_link = createDesktopNavTabVwLite('My documents' , '/s4s/CustomPage/Index/' + Urls.myDocuments);
			let vwLiteMyProfileDashboard_link = createDesktopNavTabVwLite('My profile' , '/s4s/MyProfile/MyProfileTab');
			//let vwLiteFundingDueDashboard_link = createDesktopNavTabVwLite('Funding due', '/s4s/CustomPage/Index/' + Urls.fundingDue);

			// Mobile
			let vwLiteMobileDashboard_link = createMobileLinkwLite('Dashboard', '/s4s/CustomPage/Index/' + Urls.vwProductOne);
			let vwLiteMobileMyStatementDashboard_link = createMobileLinkwLite('My statement', '/s4s/CustomPage/Index/' + Urls.vwProductTwo + '?query=');
			let vwLiteMobileMyOrdersDashboard_link = createMobileLinkwLite('My orders', '/s4s/MyOrders');
			let vwLiteMobileMarkeplaceDashboard_link = createMobileLinkwLite('Marketplaces', '/s4s/CustomPage/Index/' + Urls.searchShopServices + '?Page=Services&Search=');
			let vwLiteMobileMyDocumentsDashboard_link = createMobileLinkwLite('My documents' , '/s4s/CustomPage/Index/' + Urls.myDocuments);
			let vwLiteMobileMyProfileDashboard_link = createMobileLinkwLite('My profile' , '/s4s/MyProfile/MyProfileTab');
			//let vwLiteMobileFundingDueDashboard_link = createMobileLinkwLite('Funding due' , '/s4s/CustomPage/Index/' + Urls.fundingDue);

			// VW Lite header
			// If array contains any of these guids then display VW Lite header or else display standard VW (also change logic in 93 - homepage)

			if(securityGuids.includes(Urls.pdfSecurityGroup)) {
				$('.js-pcg-booklet').show();
			}

			if(securityGuids.includes(Urls.virtualWalletLiteSecurityGroup)) {

				// Add vw lite class to body tag
				$('body').addClass('vw-lite');

				// Desktop
				// Adds the nav tabs to the nav bar
				$('.js-header-nav_bottom-container-desktop').html(
					`
						${vwLiteDesktopDashboard_link}
						${vwLiteMyStatementDashboard_link}
						${vwLiteMyOrdersDashboard_link}
						${vwLiteMarkeplaceDashboard_link}
						${vwLiteMyDocumentsDashboard_link}
						${vwLiteMyProfileDashboard_link}
					`
				);
	
				// Mobile
				// Adds the nav section containers to the mobile nav container
				$('.js-header-nav_bottom-container-mobile').prepend(
					`
						${vwLiteMobileDashboard_link}
						${vwLiteMobileMyStatementDashboard_link}
						${vwLiteMobileMyOrdersDashboard_link}
						${vwLiteMobileMarkeplaceDashboard_link}
						${vwLiteMobileMyDocumentsDashboard_link}
						${vwLiteMobileMyProfileDashboard_link}
					`
				);

			// Croydon managed accounts (LA staff Managed accounts) - IF LA BO type = LA AND default BV = LA AND isCaseManager= True default BV = BM AND iOrgAdmin= True && Croydon
			} else if ( authSettings.defaultBusinessView === '23513fee-e77e-4a25-bf26-e84f1825f17b' && authSettings.isOrgAdmin === true && $.sc.authSettings.organisationId === '324f8196-c77d-4f80-aac3-a99e00adb2a8' ) {

				const mobileProviderDetailsTab = createMobileLink('Provider details', '/s4s/CustomPage/Index/' + Urls.providerDetails);
				const desktopProviderDetailsTab = createDesktopLink('Provider details', '/s4s/CustomPage/Index/' + Urls.providerDetails, 'provider-details');

				let mobReportsTab = '';
				let deskReportsTab = '';
				if ($.sc.authSettings.permissions.includes('4a7ce900-b1e1-474c-a836-db8038809bb9')){
					mobReportsTab = createMobileLink('Reports', '/s4s/CustomPage/Index/' + Urls.reportsPage);;
					deskReportsTab = createDesktopLink('Reports', '/s4s/CustomPage/Index/' + Urls.reportsPage, 'reports');;
				}

				// Look to see if user is a Approver
				let manual_transactions_link = '';
				let desktopManual_transactions_link = '';

				if( securityGuids.includes(Urls.approverSecurityGroup)) {

					$.sc.authSettings.permissions.forEach(function(item){

						// Look for Payment approvals guid
						if ( Urls.permission.manualTransactionPayments === item ) {
							manual_transactions_link = createMobileLinkInfo('Payment approvals', '/s4s/CustomPage/Index/' + Urls.manualTransactionPayments)
							desktopManual_transactions_link = createDesktopLinkInfo('Payment approvals', '/s4s/CustomPage/Index/' + Urls.manualTransactionPayments, 'manual-transactions-payments-page')
						}
					});
				}

				// Adds the nav tabs to the nav bar
				$('.js-header-nav_bottom-container-desktop').html(
						`
						${vwLiteMyProfileDashboard_link}
						${desktopProviderDetailsTab}
						${deskReportsTab}
						${desktopManual_transactions_link}
					`
				);
	
				// Mobile
				// Adds the nav section containers to the mobile nav container
				$('.js-header-nav_bottom-container-mobile').prepend(
					`
						${vwLiteMobileMyProfileDashboard_link}
						${mobileProviderDetailsTab}		
						${mobReportsTab}
						${manual_transactions_link}
					`
				);
				

			// Provider links
			} else if ( authSettings.pplRole === '112c3cc7-2c81-4702-a988-ec2c1bb03cb9') {

				// Adds the nav tabs to the nav bar
				$('.js-header-nav_bottom-container-desktop').html(
					`
						${createDesktopLinkInfo('Dashboard', '/s4s/CustomPage/Index/' + Urls.vwProductOne, 'dashboard-page')}
						${$.sc.authSettings.permissions.includes('d01ddba4-0507-4ff4-a252-80a53bb020d3') ? createDesktopLink('PPL Connect' , '/s4s/CustomPage/Index/' + Urls.pplConnectPage, 'ppl-connect'): ``}
						${vwLiteMyProfileDashboard_link}
						${$.sc.authSettings.permissions.includes('4a7ce900-b1e1-474c-a836-db8038809bb9') &&  ( 
							$.sc.authSettings.securityGroups.includes('67882e19-5129-475e-a6ae-b2a300a3b1d8') ||
							$.sc.authSettings.securityGroups.includes('71c73fe8-d352-4d17-aa93-b2a40108c250')
						) ? createDesktopLink('Reports', '/s4s/CustomPage/Index/' + Urls.reportsPage, 'reports-page'): ``}
						`

						// ${$.sc.authSettings.permissions.includes('d01ddba4-0507-4ff4-a252-80a53bb020d3') ? createDesktopLink('Find a vacancy', '/s4s/CustomPage/Index/' + Urls.pa_vacancySearchPage, 'pa-search'): ``}
				);
	
				// Mobile
				// Adds the nav section containers to the mobile nav container
				$('.js-header-nav_bottom-container-mobile').prepend(
					`
						${createMobileLinkInfo('Dashboard', '/s4s/CustomPage/Index/' + Urls.vwProductOne)}
						${$.sc.authSettings.permissions.includes('d01ddba4-0507-4ff4-a252-80a53bb020d3') ? createMobileLink('PPL Connect' , '/s4s/CustomPage/Index/' + Urls.pplConnectPage): ``}
						${vwLiteMobileMyProfileDashboard_link}
						${$.sc.authSettings.permissions.includes('4a7ce900-b1e1-474c-a836-db8038809bb9') &&  ( 
							$.sc.authSettings.securityGroups.includes('67882e19-5129-475e-a6ae-b2a300a3b1d8') ||
							$.sc.authSettings.securityGroups.includes('71c73fe8-d352-4d17-aa93-b2a40108c250')
						) ? createDesktopLink('Reports', '/s4s/CustomPage/Index/' + Urls.reportsPage): ``}
						`
						// ${$.sc.authSettings.permissions.includes('d01ddba4-0507-4ff4-a252-80a53bb020d3') ? createDesktopLink('Find a vacancy', '/s4s/CustomPage/Index/' + Urls.pa_vacancySearchPage): ``}
				);

			} else {

				// VW header

				// Mobile
				let my_profile_link = '';
				let calendar_link = '';
				let support_package_link = '';
				let messages_link = '';
				let personal_assistants_link = '';
				let my_typical_week_link = '';
				let my_assessments_link = '';
				let provider_management_administration_link = '';
				let reports_link = '';
				let bm_site_link = '';
				let manual_transactions_link = '';
				
				let support_summary_link = '';
				let dashboard_link = '';
				let my_statement_link = '';
				let marketplaces_link = '';
				let enrolmentDashboard_link = '';
				let my_payments_link = '';
				let manage_payees_link = '';
				let my_payment_transfers_link = '';
				let funding_due_link = '';
				let pplConnect_link = '';
				let findPA_link = '';
		
				// Desktop
				let desktopMy_profile_link = '';
				let desktopCalendar_link = '';
				let desktopSupport_package_link = '';
				let desktopMessages_link = '';
				let desktopPersonal_assistants_link = '';
				let desktopMy_typical_week_link = '';
				let desktopMy_assessments_link = '';
				let desktopProvider_management_administration_link = '';
				let desktopReports_link = '';
				let desktopBm_site_link = '';
				let desktopManual_transactions_link = '';
				
				let desktopSupport_summary_link = '';
				let desktopDashboard_link = '';
				let desktopMy_statement_link = '';
				let desktopMarketplaces_link = '';
				let desktopPPLConnect_link = '';

				let desktopFindPA_link = '';

				let desktopEnrolmentDashboard_link = '';
				let desktopMy_payments_link = '';
				let desktopManage_payees_link = '';
				let desktopMy_payment_transfers_link = '';
				let desktopFunding_due_link = '';

				//////////////////////// THIS MAY BE CONFUSING FOR USERS AS THEY WILL NEED TO SEE THEIR DETAILS ////////////////////////
				// let myprofilehref = '';
				// if ($.sc.authSettings.pplId === null) {
				// 	myprofilehref = '/s4s/MyProfile/MyProfileTab';
				// } else {
				// 	myprofilehref = '/s4s/CustomPage/Index/148';
				// }
				let myprofilehref = '/s4s/MyProfile/MyProfileTab';
		
				if(authSettings.login !== null){
					if ( currentUser.availableModules ) {
						currentUser.availableModules.map((module) => {
				

							if ( module === 'my_profile' ) {
								my_profile_link = createMobileLinkInfo('My profile' , myprofilehref)
								desktopMy_profile_link = createDesktopLinkInfo('My profile' , myprofilehref, 'profile-page')
							}
							if ( module === 'my_calendar' ) {
								calendar_link = createMobileLink('My calendar' , '/s4s/MyCalendar?query=&vw=1')
								desktopCalendar_link = createDesktopLink('My calendar' , '/s4s/MyCalendar?query=&vw=1', 'calendar-page')
							}

							// Do not show these for Read only individuals
							if (userInfo.readonly === false ) {
								if ( module === 'my_support_packages' ) {
									support_package_link = createMobileLink('My quotes' , '/s4s/MySupportPackages?hideCompleted=false')
									desktopSupport_package_link = createDesktopLink('My quotes' , '/s4s/MySupportPackages?hideCompleted=false', 'support-package-page')
								}
								if ( module === 'my_messages' ) {
									messages_link = createMobileLink('Messages' , '/s4s/CustomPage/Index/' + Urls.pplChat)
									desktopMessages_link = createDesktopLink('Messages' , '/s4s/CustomPage/Index/' + Urls.pplChat, 'messages-page')
								}
								if ( module === 'my_typical_week' ) {
									my_typical_week_link = createMobileLink('My typical week' , '/s4s/MyTypicalWeekSpa')
									desktopMy_typical_week_link = createDesktopLink('My typical week' , '/s4s/MyTypicalWeekSpa', 'typical-week-page')
								}
								if ( module === 'provider_management_administration' ) {
									if ($.sc.authSettings.isSag === false && $.sc.authSettings.isOrgAdmin === false ) {
										provider_management_administration_link = createMobileLink('My timesheets' , '/s4s/CustomPage/Index/' + Urls.providerTimesheetsAdmin)
										desktopProvider_management_administration_link = createDesktopLink('My timesheets' , '/s4s/CustomPage/Index/' + Urls.providerTimesheetsAdmin, 'provider-manage-admin-page')
									}
								}
							}

							if ( module === 'personal_assistants' || module === 'personal_assistance' ) {
								personal_assistants_link = createMobileLink('Personal assistants' , '/s4s/CustomPage/Index/' + Urls.personalTimesheets)
								desktopPersonal_assistants_link = createDesktopLink('Personal assistants' , '/s4s/CustomPage/Index/' + Urls.personalTimesheets, 'personal-assist-page')
							}
							if ( module === 'my_assessments' ) {
								my_assessments_link = createMobileLink('My documents' , '/s4s/CustomPage/Index/' + Urls.myDocuments)
								desktopMy_assessments_link = createDesktopLink('My documents' , '/s4s/CustomPage/Index/' + Urls.myDocuments, 'my-assessments-page')
							}
							
							if ( module === 'bm_site' ) {
								bm_site_link = createMobileLink('Open Budget Manager', '/s4s/BMSite');
								desktopBm_site_link = createDesktopLink('Open Budget Manager', '/s4s/BMSite', 'budget-manager-page');
							}
							// if ( module === 'funding_due' ) {
							// 	funding_due_link = createMobileLink('Funding due' , '/s4s/CustomPage/Index/' + Urls.fundingDue)
							// 	desktopFunding_due_link = createDesktopLink('Funding due' , '/s4s/CustomPage/Index/' + Urls.fundingDue, 'funding-due-page')
							// }

						})
					}
				}

				// Look at permissions
				$.sc.authSettings.permissions.forEach(function(item, index){

					// Look for Payment approvals guid
					if ( Urls.permission.manualTransactionPayments === item ) {
						manual_transactions_link = createMobileLinkInfo('Payment approvals', '/s4s/CustomPage/Index/' + Urls.manualTransactionPayments)
						desktopManual_transactions_link = createDesktopLinkInfo('Payment approvals', '/s4s/CustomPage/Index/' + Urls.manualTransactionPayments, 'manual-transactions-payments-page')
					}

					// Funding due
					if ( 'ec2aa69b-db69-4a3e-a0c4-7a65401e64d5' === item && $.sc.authSettings.isOriginalPrincipalSag === true) {
						funding_due_link = createMobileLink('Funding due' , '/s4s/CustomPage/Index/' + Urls.fundingDue)
						desktopFunding_due_link = createDesktopLink('Funding due' , '/s4s/CustomPage/Index/' + Urls.fundingDue, 'funding-due-page')
					}

					// Reports
					if ( '4a7ce900-b1e1-474c-a836-db8038809bb9' === item  && ( 
						$.sc.authSettings.securityGroups.includes('67882e19-5129-475e-a6ae-b2a300a3b1d8') || 	// PBI_ISF_Providers
						// $.sc.authSettings.securityGroups.includes('71c73fe8-d352-4d17-aa93-b2a40108c250') || // PBI_Providers
						$.sc.authSettings.securityGroups.includes('aa5df9a7-b8e1-450c-b8ab-b2a40103d31d') ||	// PBI_BudgetManager
						$.sc.authSettings.securityGroups.includes('d31d72b8-c219-4a5a-9c1d-b29101503e66') ||	// PBI_PPL_Staff
						$.sc.authSettings.securityGroups.includes('8b3b0101-c355-4e6d-8571-b2910151bb1f')		// PBI_LA_Staff

					)) {
						reports_link = createMobileLink('Reports', '/s4s/CustomPage/Index/' + Urls.reportsPage);
						desktopReports_link = createDesktopLink('Reports', '/s4s/CustomPage/Index/' + Urls.reportsPage, 'reports-page');
					}
				});

				// Look through MTP security groups
				if( authSettings.securityGroups.includes(Urls.manualTransactionSecurityGroups.mt_Payment) || authSettings.isOriginalPrincipalSag === true ) {

					my_payments_link = createMobileLink('Payments', '/s4s/CustomPage/Index/' + Urls.manualPayment)
					desktopMy_payments_link = createDesktopLink('Payments', '/s4s/CustomPage/Index/' + Urls.manualPayment, 'my-payments-page')
	
					manage_payees_link = createMobileLink('Manage payees', '/s4s/CustomPage/Index/' + Urls.managePayee)
					desktopManage_payees_link = createDesktopLink('Manage payees', '/s4s/CustomPage/Index/' + Urls.managePayee, 'manage-payees-page')
				}

				// Create nav items that do not have modules in the GetUserInfo API
				dashboard_link = createMobileLinkInfo('Dashboard', '/s4s/CustomPage/Index/' + Urls.vwProductOne)
				desktopDashboard_link = createDesktopLinkInfo('Dashboard', '/s4s/CustomPage/Index/' + Urls.vwProductOne, 'dashboard-page')
		
				support_summary_link = createMobileLinkInfo('Support summary', '/s4s/CustomPage/Index/' + Urls.vwProductThree + '?query=&vw=1')
				desktopSupport_summary_link = createDesktopLinkInfo('Support summary', '/s4s/CustomPage/Index/' + Urls.vwProductThree + '?query=&vw=1', 'support-summary-page')
		
				my_statement_link = createMobileLink('My statement', '/s4s/CustomPage/Index/' + Urls.vwProductTwo + '?query=')
				desktopMy_statement_link = createDesktopLink('My statement', '/s4s/CustomPage/Index/' + Urls.vwProductTwo + '?query=', 'my-statement-page')
				
				my_payment_transfers_link = createMobileLink('Payment transfers', '/s4s/CustomPage/Index/' + Urls.paymentTransfer)
				desktopMy_payment_transfers_link = createDesktopLink('Payment transfers', '/s4s/CustomPage/Index/' + Urls.paymentTransfer, 'payment-transfers-page')

				marketplaces_link = createMobileLink('Marketplaces', '/s4s/CustomPage/Index/' + Urls.searchShopServices + '?Page=Services&Search=')
				desktopMarketplaces_link = createDesktopLink('Marketplaces', '/s4s/CustomPage/Index/' + Urls.searchShopServices + '?Page=Services&Search=', 'marketplace-page')
				
				enrolmentDashboard_link = createMobileLink('Enrolment dashboard', '/s4s/CustomPage/Index/' + Urls.vwSagDash)
				desktopEnrolmentDashboard_link = createDesktopLink('Enrolment dashboard', '/s4s/CustomPage/Index/' + Urls.vwSagDash, 'enrolment-dashboard-page')

				
				// PPL Connect
				if ($.sc.authSettings.permissions.includes('d01ddba4-0507-4ff4-a252-80a53bb020d3') ) {

					pplConnect_link = createMobileLink('PPL Connect', '/s4s/CustomPage/Index/' + Urls.pplConnectPage)
					desktopPPLConnect_link = createDesktopLink('PPL Connect', '/s4s/CustomPage/Index/' + Urls.pplConnectPage, 'pplconnect-page');

					// findPA_link = createMobileLink('Find a PA', '/s4s/CustomPage/Index/' + Urls.pa_vacancySearchPage)
					// desktopFindPA_link = createDesktopLink('Find a PA', '/s4s/CustomPage/Index/' + Urls.pa_vacancySearchPage, 'find-a-pa');
				}

				
				// Creates desktop main nav tabs
				const desktopSummaryTab = createDesktopNavTab("my-summary", "Account Summary", "account-summary-tab");
				const desktopSupportTab = createDesktopNavTab("my-support", "My Support", "my-support-tab");
				const desktopWalletTab = createDesktopNavTab("my-wallet", "Wallet Administration", "my-wallet-tab");
				const desktopDetailsTab = createDesktopNavTab("details", "Details", "details-tab");

				// Creates mobile main nav section containers
				const mobileSummaryTab = createMobileNavTab("account-summary", "Account Summary");
				const mobileSupportTab = createMobileNavTab("my-support", "My Support");
				const mobileWalletTab = createMobileNavTab("my-wallet", "Wallet Administration");
				const mobileDetailsTab = createMobileNavTab("details", "Details");


				// If logged in then show the header options
				// if(authSettings.login !== null){

					// Desktop header nav
		
					// Adds the nav tabs to the nav bar					
					// postOrganisationType();

				let securityGuids = [];

				// Push securityGroups guids into array
				$(authSettings.securityGroups).each(function(i, el){

					securityGuids.push(el);

				});
				
				$('.js-header-nav_bottom-container-desktop').html(
					`
					${desktopSummaryTab}
					${desktopSupportTab}
					${desktopWalletTab}
					${desktopDetailsTab}
					`
				);

		
				// Adds the nav items in seperate containers under the main nav tabs
				$('.js-nav_bottom-dropdown-container').html(
					`
					<div class="header-nav_bottom-dropdown-container" data-dropdown="my-summary">
						${authSettings.isSag === false && authSettings.isIndividual === true || authSettings.isAuthorizedRepresentative === true
							?
							`
								${desktopDashboard_link}
							`
							:
							``
						}
						${authSettings.hasPba === true
							?
							`${desktopMy_statement_link}`
							:
							``
						}
						${authSettings.isIndividual === true
							?
							`
								${securityGuids.includes(Urls.manualTransactionSecurityGroups.mt_Payment) || $.sc.authSettings.isOriginalPrincipalSag === true ? desktopMy_payments_link : ''} 
								${securityGuids.includes(Urls.manualTransactionSecurityGroups.mt_Payment) || $.sc.authSettings.isOriginalPrincipalSag === true ? desktopManage_payees_link : ''} 
							`
							:
							``
						}

					</div>
	
					<div class="header-nav_bottom-dropdown-container" data-dropdown="my-support">
						${authSettings.hasPba === true
							?
							`${desktopSupport_summary_link}`
							:
							``
						}
						${desktopPersonal_assistants_link}
						${desktopMy_typical_week_link}
						${desktopCalendar_link}
						${desktopSupport_package_link}
						${desktopPPLConnect_link}
						${desktopFindPA_link}

						${authSettings.isIndividual === true
							?
							`${desktopMarketplaces_link}`
							:
							``
						}
					</div>

					<div class="header-nav_bottom-dropdown-container" data-dropdown="my-wallet">
						${desktopFunding_due_link}
					</div>
					
					<div class="header-nav_bottom-dropdown-container" data-dropdown="details">
						${authSettings.isIndividual === false && authSettings.isEmployee === true && authSettings.pplId !== null
							?
							`${desktopDashboard_link}`
							:
							``
						}
						${desktopMy_profile_link}
						${authSettings.isSag === true || authSettings.isOrgAdmin === true
							?
							`
								${desktopEnrolmentDashboard_link}
							`
							:
							``
						}
						${authSettings.isSag === true
							?
							`
								${desktopMy_payment_transfers_link}
							`
							:
							``
						}
						${desktopProvider_management_administration_link}
						${desktopMessages_link}
						${desktopMy_assessments_link}
						${desktopManual_transactions_link}
						${desktopReports_link}
						${desktopBm_site_link}
					</div>
					`
				);

	
				// Mobile header nav
				// Adds the nav section containers to the mobile nav container
				$('.js-header-nav_bottom-container-mobile').append(
					`
					${mobileSummaryTab}
					${mobileSupportTab}
					${mobileWalletTab}
					${mobileDetailsTab}
					`
				);
				
	
				// Adds the nav items to the section created for it
				$('.js-header-nav-account-summary-mobile').html(
					`
					${authSettings.isSag === false && authSettings.isIndividual === true
						?
						`${dashboard_link}`
						:
						``
					}
					${authSettings.isIndividual === true
						?
						`
							${my_statement_link} 
							${securityGuids.includes(Urls.manualTransactionSecurityGroups.mt_Payment) || $.sc.authSettings.isOriginalPrincipalSag === true ? my_payments_link : ''} 
							${securityGuids.includes(Urls.manualTransactionSecurityGroups.mt_Payment) || $.sc.authSettings.isOriginalPrincipalSag === true ? manage_payees_link : ''} 
						`
						:
						``
					}
					`
				);
				
				// Adds the nav items to the section created for it
				$('.js-header-nav-my-support-mobile').html(
					`
					${authSettings.isIndividual === true
						?
						`${support_summary_link}`
						:
						``
					}
					${personal_assistants_link}
					${my_typical_week_link}
					${calendar_link}
					${support_package_link}
					${pplConnect_link}
					${findPA_link}

					${authSettings.isIndividual === true
						?
						`${marketplaces_link}`
						:
						``
					}
					`
				)
				
				// Adds the nav items to the section created for it
				$('.js-header-nav-details-mobile').html(
					`
					${authSettings.isIndividual === false && authSettings.isEmployee === true && authSettings.pplId !== null
						?
						`${dashboard_link}`
						:
						``
					}
					${my_profile_link}
					${authSettings.isSag === true || authSettings.isOrgAdmin === true
						?
						`
							${enrolmentDashboard_link}
						`
						:
						``
					}
					${authSettings.isSag === true
						?
						`
							${my_payment_transfers_link}
						`
						:
						``
					}
					${provider_management_administration_link}
					${messages_link}
					${my_assessments_link}
					${manual_transactions_link}
					${reports_link}
					${bm_site_link}
					`
				);


				// Adds the nav items to the section created for it
				$('.js-header-nav-my-wallet-mobile').html(
					`
						${funding_due_link}
					`
				);
				



				// NAV CLICK FUNCTIONALITY ///////////////////////////////////////////////

				// Desktop navigation dropdown toggling functionality
				$(".header-nav_bottom-item-container-desktop").on('click', function(){

					$(".header-nav_bottom-item-container-desktop").removeClass('header-active-tab')
					$(".header-nav_bottom-item-container-desktop").attr('aria-expanded', 'false');
					$(this).addClass('header-active-tab');
					$(this).attr('aria-expanded', 'true');

					$('.header-nav_bottom-dropdown-section').css({ 'display': 'flex' });
					$('.header-nav_bottom-section').css('border-bottom', 'unset');

					$('.header-nav_bottom-dropdown-container').css({ 'display': 'none' });
					$('.header-nav_bottom-dropdown-container').removeClass('header-active-dropdown-container');
		
					if ($(this).data('dropdown') === 'my-summary') {
						$('div.header-nav_bottom-dropdown-section').find('.header-nav_bottom-dropdown-container[data-dropdown="my-summary"]').css({ 'display': 'flex' });
					}
					if ($(this).data('dropdown') === 'my-support') {
						$('div.header-nav_bottom-dropdown-section').find('.header-nav_bottom-dropdown-container[data-dropdown="my-support"]').css({ 'display': 'flex' });
					}
					if ($(this).data('dropdown') === 'my-wallet') {
						$('div.header-nav_bottom-dropdown-section').find('.header-nav_bottom-dropdown-container[data-dropdown="my-wallet"]').css({ 'display': 'flex' });
					}
					if ($(this).data('dropdown') === 'details') {
						$('div.header-nav_bottom-dropdown-section').find('.header-nav_bottom-dropdown-container[data-dropdown="details"]').css({ 'display': 'flex' });
					}

					const headerHeight = $('.js-header-nav').height();
					$('header').outerHeight(headerHeight);
				});

				$('.header-nav_bottom-item-container-desktop').on("keydown", function(event) {
					if (event.key === "Enter") {
						$(this).click();
					}
				});

				////////////////////////////////////////////////////////////////////
				
				// Hide empty nav items from header
				$('.header-nav_bottom-dropdown-container').each(function(i, el){
					if($(el).children().length === 0){
						let bottomAttr = $(this).attr('data-dropdown');
						$('.header-nav_bottom-item-container-desktop').each(function(ind, elem){
							if(bottomAttr === $(elem).attr('data-dropdown')) {
								$(elem).remove();
							};
						});
					};
				});

				$('.header-nav_main-item-container-mobile').each(function(i, el){
					if($(el).find('ul').children().length === 0){
						$(this).remove();
					};
				});
		
				//// Account Summary nav
				// Dashboard page but for items without a page in sub menu so we need to default opening the sub
				if(
					pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.myPrograms ||
					pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.myParticipants ||
					pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.mySignatures + '#/signatures'
				){
					selectedDesktopNavItem('.dashboard-page', 'no-item');
				}


				// Dashboard page
				if(pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.vwProductOne 	
				){
					selectedDesktopNavItem('.dashboard-page');
				}
				
				// My Statement page
				if(pageUrl.includes('/CustomPage/Index/' + Urls.vwProductTwo + '?query=') || pagePath.includes('/OrdersDetails/InvoiceDetails')) {
					selectedDesktopNavItem('.my-statement-page');
				}

				// Payments page
				if(pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.manualPayment){
					selectedDesktopNavItem('.my-payments-page');
				}

				// Manage payees page
				if(pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.managePayee){
					selectedDesktopNavItem('.manage-payees-page');
				}
				
				// Payment transfers page
				if(pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.paymentTransfer){
					selectedDesktopNavItem('.payment-transfers-page');
				}
		
				//// My Support nav
				// My Summary page
				if(pageUrl.includes('/CustomPage/Index/' + Urls.vwProductThree + '?query=')) {
					selectedDesktopNavItem('.support-summary-page');
				}
				
				// My Personal assistants
				if(pageUrl.includes('/CustomPage/Index/' + Urls.personalTimesheets) || pageUrl.includes('/PersonalTimesheet') || pageUrl.includes('/PersonalAssistance/Category') || pageUrl.includes('/ContractDetails') || pageUrl.includes('/PrincipalTimesheetSettingsDetails')) {
					selectedDesktopNavItem('.personal-assist-page');
				}
				
				// My Typical Week page
				if(pageUrl.includes('/MyTypicalWeekSpa')) {
					selectedDesktopNavItem('.typical-week-page');
				}
				
				// My Calendar page
				if(pageUrl.includes('/MyCalendar')) {
					selectedDesktopNavItem('.calendar-page');
				}
				
				// My Quotes page
				if(pageUrl.includes('/MySupportPackages') || pageUrl.includes('/SupportPackageDetails') || pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.vwMicroCommisioning){
					selectedDesktopNavItem('.support-package-page');
				}
				
				// Marketplaces page
				if(pageUrl.includes('/CustomPage/Index/' + Urls.searchShopServices + '?Page=') || pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.searchShopEquipment || pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.searchShopStores || pageUrl === Urls.Domain + '/s4s/CustomPage/Index/' + Urls.searchMyCatalogue){
					selectedDesktopNavItem('.marketplace-page');
				}
		
				// Payment approvals
				if(pageUrl.includes('/CustomPage/Index/' + Urls.manualTransactionPaymentApproval)) {
					selectedDesktopNavItem('.manual-transactions-payments-page');
				}

				//// Details nav
				// My Profile page
				if(pageUrl.includes('/MyProfile')) {
					selectedDesktopNavItem('.profile-page');
				}
				
				// My Messages page
				if(pageUrl.includes('/CustomPage/Index/' + Urls.pplChat)) {
					selectedDesktopNavItem('.messages-page');
				}
				
				// My Documents page
				if(pageUrl.includes('/MyAssessments/Forms') || pageUrl.includes('/CustomPage/Index/' + Urls.myDocuments) ){
					selectedDesktopNavItem('.my-assessments-page');
				}
				
				// Enrolment Dashboard page
				if(pageUrl.includes('/CustomPage/Index/' + Urls.vwSagDash)) {
					selectedDesktopNavItem('.enrolment-dashboard-page');
				}

				// Funding due page
				if(pageUrl.includes('/CustomPage/Index/' + Urls.fundingDue)) {
					selectedDesktopNavItem('.funding-due-page');
				}

				// PPL Connect page
				if(pageUrl.includes('/CustomPage/Index/' + Urls.pplConnectPage)) {
					selectedDesktopNavItem('.pplconnect-page');
				}

				// Find pa page
				if(pageUrl.includes('/CustomPage/Index/' + Urls.pa_vacancySearchPage)) {
					selectedDesktopNavItem('.find-a-pa');
				}


				// SAG users have a peristant shown submenu on Desktop view
				if ( $.sc.authSettings.pplRole === '22a21fd3-9b01-4c07-a8a9-e70d17fbb4da') {

					const isVisible = isElementVisibleByClassName('header-nav_top-nav-container-desktop');
					var $detailsDropdown = $('li[data-dropdown="details"]');

					if ( isVisible === true) {
						$($detailsDropdown).addClass('header-active-tab')
						$($detailsDropdown).attr('aria-expanded', 'true');
						$($detailsDropdown).click()
					}
				}
	
				//////////////////////////////////////////////////////////////////
			}; 

			// Append logged in user info
			displayLoggedInUser();

		};

		function isElementVisibleByClassName(className) {
			const elements = document.getElementsByClassName(className);
		
			if (elements.length === 0) {
				console.log("Element with the specified class not found");
				return false;
			}
		
			// Checking the first element with the specified class name
			const elem = elements[0];
		
			// Check using computed style
			const style = window.getComputedStyle(elem);
			if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0' || elem.offsetWidth === 0 || elem.offsetHeight === 0) {
				return false; // Element is not visible due to CSS or dimensions
			}
		
			return true; // Element is visible
		}

		function displayLoggedInUser() {

			const reference = $.sc.authSettings.laReferenceValue === null || $.sc.authSettings.laReferenceValue === undefined ? '' : `<small>Reference: ${$.sc.authSettings.laReferenceValue}</small>`;
			// console.log(reference)
			$('.js-header-nav_bottom-container-desktop').append(
				`
					<li class="js-notification-icon user-info">${$.sc.authSettings.name} ${reference}</li>
				`
			);

			// Mobile
			// Adds the nav section containers to the mobile nav container
			$('.js-header-nav_bottom-container-mobile__credentials').prepend(
				`
					<span class="js-notification-icon user-info">${$.sc.authSettings.name} ${reference}</span>
				`
			);
		}

		function createUploadDocLink(form) {
			$('#myAccountExcerpt').after(
				'<p class="rhs"><a href="/s4s/FormDetails/FillForm?formId=' + form + '"><i class="fa fa-file" aria-hidden="true"></i> Upload a document</a></p>'
			);
		}


		// CORE-7 
		// Expires at token
		// function createTimeoutModel(obj) {
		
		// 	let windowHeight = $(window).height();
		// 	windowHeight = windowHeight - 150;
		// 	// Create overlay
		// 	$('.js-timeout-container').html(
		// 		`
		// 			<div class="js-overlay-timeout" style="z-index: 10000000; text-align: center; width: 100%; height: 100%; top: 0; position: fixed; background-color: rgba(0,0,0,0.6)">
		// 				<div class="modelBox" role="alertdialog" aria-labelledby="modalTimeOutTitle" aria-describedby="modalTimeOutDesc" aria-modal="true" tabindex="-1">
		// 					<section style="border-bottom: 5px solid #e0e0e0;">
		// 						<div class="js-model-header modelHeader">
		// 							<h1 id="modalTimeOutTitle">${obj.modelTitle}</h1>
		// 						</div>
		// 					</section>
		// 					<div class="model-body" style="max-height: ${windowHeight}px">
		// 						<section class="">
		// 							<div class="form_container">
		// 								<p id="modalTimeOutDesc" style="margin-bottom: 1.5rem; margin-top: 1rem;">${obj.modelText} <br><strong class="js-logout-timer"></strong></p>
		// 								<button class="${obj.buttonClass} blue-btn">${obj.button}</button>
		// 								<a href="/s4s/auth/logout" style="display: block; margin: 0 0 1rem 0; text-decoration: underline;">${obj.buttonAlt}</a>
		// 							</div>
		// 						</section>

		// 					</div>
		// 				</div>
		// 			</div>		
		// 		`
		// 	);
		// 	startCountdown(obj.timeout);

		// 	function startCountdown(duration) {
		// 		let timer = duration; // Timer in milliseconds
			
		// 		const interval = setInterval(function () {
		// 			// Calculate seconds from timer
		// 			let seconds = parseInt(timer / 1000, 10);
					
		// 			// Format seconds for display, check if singular or plural
		// 			let secondsText = seconds === 1 ? "1 second" : (seconds < 10 ? "0" + seconds + " seconds" : seconds + " seconds");
					
		// 			// Update the DOM with the formatted countdown time
		// 			$('.js-logout-timer').text(secondsText);
					
		// 			// Decrement the timer by one second in milliseconds
		// 			timer -= 1000;
					
		// 			// Stop the interval when the timer reaches zero or goes below
		// 			if (timer < 0) {
		// 				clearInterval(interval);
		// 				$('.js-logout-timer').text("Preparing to logout...");
		// 				// Optional actions after countdown ends
		// 				// console.log("Session timed out");
		// 				// pageUrl = '/s4s/auth/logout';
		// 			}
		// 		}, 1000); // Run the function every 1000 milliseconds (1 second)
		// 	}
		// }

		// function checkTimeout() {
		// 	$('.js-timeout-container').remove();
		// 	$('body').prepend('<div class="js-timeout-container"></div>');
		// 	const expiresAt = moment.utc($.sc.authSettings.expiresAt).local();
		// 	const timeNow = moment.utc();
	
		// 	const diff = expiresAt - timeNow;
		// 	console.log(' ')
		// 	console.log('Expires difference: ' + diff)
	
		// 	const timer = {
		// 		mouseMoveListener: diff - 140000, // 150 seconds (2m 20s)
		// 		popupTime: diff - 90000, // 90 seconds (1m 30s)
		// 		logoutTime: diff - 1000,  // Logout 1 second before expiresAt
		// 		countdown: 80000 // Same as popupTime but converted into actual seconds from milliseconds
		// 	}

		// 	// Mouse listener
		// 	var mouseListener = setTimeout(function() {
		// 		console.log('Mouse listener is active');

		// 		let hasMoved = false;

		// 		function removeMovementListeners() {
		// 			document.removeEventListener('mousemove', handleMouseMove);
		// 			document.removeEventListener('touchmove', handleTouchMove);
		// 			document.removeEventListener('keypress', handleKeypress);
		// 			window.removeEventListener('scroll', handleScroll);
		// 		}	

		// 		function addMovementListeners() {
		// 			document.addEventListener('mousemove', handleMouseMove);
		// 			document.addEventListener('touchmove', handleTouchMove);
		// 			document.addEventListener('keypress', handleKeypress);
		// 			window.addEventListener('scroll', handleScroll);
		// 		}
		// 		addMovementListeners();
		
		// 		// Handle mouse movement
		// 		function handleMouseMove() {
		// 			if (!hasMoved) {
		// 				console.log('Mouse movement detected!');
		// 				clearTimeoutandPost();
		// 				hasMoved = true;
		// 			}
		// 		}
			
		// 		// Handle touch movement
		// 		function handleTouchMove() {
		// 			if (!hasMoved) {
		// 				console.log('Touch movement detected!');
		// 				clearTimeoutandPost();
		// 				hasMoved = true;
		// 			}
		// 		}

		// 		// Handle keypress movement
		// 		function handleKeypress(event) {
		// 			if (!hasMoved) {
		// 				console.log('Keypress detected! Key:', event.key);
		// 				clearTimeoutandPost();
		// 				hasMoved = true;
		// 			}
		// 		}

		// 		// Handle keypress movement
		// 		function handleScroll() {
		// 			if (!hasMoved) {
		// 				console.log('Scrolling detected!');
		// 				clearTimeoutandPost();
		// 				hasMoved = true;
		// 			}
		// 		}

		// 		function clearTimeoutandPost() {
		// 			clearTimeout(mouseListener);
		// 			clearTimeout(popupTimer);
		// 			clearTimeout(logoutTimer);
		// 			clearTimeout(resetListeners);

		// 			postOrganisationType(function(){
		// 				console.log('API posted');
		// 				cancelLogout();
		// 				checkTimeout();
		// 			});
		// 		}

		// 		// Remove the event listeners when the pop up shows
		// 		const timeBetweenListenerandPop = timer.popupTime - timer.mouseMoveListener;
		// 		var resetListeners = setTimeout(function() {
		// 			console.log('Pop up should appear now')
		// 			removeMovementListeners();
		// 		}, timeBetweenListenerandPop); 
				

		// 	}, timer.mouseMoveListener); 


		// 	// Pop up
		// 	var popupTimer = setTimeout(function() {
		// 		createTimeoutPopup(timer.countdown);
		// 	}, timer.popupTime); 


		// 	// Log out
		// 	var logoutTimer = setTimeout(function() {
		// 		location.href = '/s4s/Auth/Logout';
		// 	}, timer.logoutTime); 
	

		// 	// Function to clear the timeout
		// 	function cancelLogout() {
		// 		$('.js-overlay-timeout').remove();
		// 		clearTimeout(logoutTimer);
		// 		console.log("Logout has been canceled");
		// 	}
		
		// 	function createTimeoutPopup(timer) {

		// 		console.log('timer is: ' + timer)

		// 		var formBuilder = {
		// 			button: "Stay logged in",
		// 			buttonClass: "js-reset-timeout-btn",
		// 			buttonAlt: "Log out",
		// 			buttonAltClass: "js-logout-btn",
		// 			modelTitle: "Your session is about to timeout",
		// 			modelText: "Your session is about to timeout and you will be logged out in: ",
		// 			timeout: timer
		// 		};
		// 		createTimeoutModel(formBuilder);
		
		// 		const resetBtn = document.querySelector('.js-reset-timeout-btn');
		// 		resetBtn.addEventListener("click", ()=> {
		// 			console.log('Button clicked');
		// 			postOrganisationType(function(){
		// 				console.log('API posted');
		// 				cancelLogout();
		// 				checkTimeout();
		// 			});
		// 		});
		
		// 	}
		// }


		

		function removeTimesheetsWrapping(selector, callback) {
			// If selector is empty or undefined, unwrap the main wrappers instead
			if (!selector) {
				unwrapElementsByClassName('date-and-time-wrapper');
				unwrapElementsByClassName('overall-date-and-time-wrapper');
			} else {
				// Select child elements of .date-and-time-wrapper with the given selector
				document.querySelectorAll(`.date-and-time-wrapper ${selector}`).forEach(element => {
					unwrapElement(element);
				});
		
				// Select child elements of .overall-date-and-time-wrapper with the given selector
				document.querySelectorAll(`.overall-date-and-time-wrapper ${selector}`).forEach(element => {
					unwrapElement(element);
				});
			}
		
			if (callback !== undefined) {
				callback();
			}
		}
		
		// Helper function to unwrap an element (similar to jQuery's unwrap)
		function unwrapElement(element) {
			let parent = element.parentNode;
			while (element.firstChild) {
				parent.insertBefore(element.firstChild, element);
			}
			parent.removeChild(element);
		}
		
		// Helper function to unwrap elements by class name
		function unwrapElementsByClassName(className) {
			document.querySelectorAll(`.${className}`).forEach(element => unwrapElement(element));
		}
		

		function unwrapElement(element) {
			let parent = element.parentNode;
			while (element.firstChild) {
				parent.insertBefore(element.firstChild, element);
			}
			parent.removeChild(element);
		}

		// function unwrapElementsByClassName(className) {
		// 	// Select all elements with the specified class name
		// 	const elements = document.getElementsByClassName(className);
		
		// 	// Convert the HTMLCollection to an array to manipulate it during iteration
		// 	Array.from(elements).forEach(element => {
		// 		// Use the parent node to replace the element with its children
		// 		const parent = element.parentNode;
		
		// 		// Move all children out of the element, directly into the parent
		// 		while (element.firstChild) {
		// 			parent.insertBefore(element.firstChild, element);
		// 		}
		
		// 		// Remove the empty element from the document
		// 		parent.removeChild(element);
		// 	});
		// }

		function updateCopyrightYear() {
			const currentYear = new Date().getFullYear();
			const copyrightElement = document.getElementById('copyrightYear');
	
			if (copyrightElement) {
				// Use the current year or fallback to 2025 if something goes wrong
				const displayYear = isNaN(currentYear) ? 2025 : currentYear;
				copyrightElement.innerHTML = `&copy ${displayYear} <a href="https://www.peopleplaceslives.co.uk/" target="_blank">People Places Lives Limited</a>, which is regulated by the Financial Conduct Authority as a Small Electronic Money Institution (FRN: 953987). Funds held are not protected under the Financial Services Compensation Scheme, but are safeguarded within segregated bank accounts in accordance with the provisions of the Electronic Money Regulations 2011.`
			}
		}

		async function getUser() {
			const userId = $.sc.authSettings.id;
			return await getUserEndpoint(userId);
		}


		var Init = {
			init: function() {
				this.adjustDom();
				this.bindUIActions();
				checkAuth();

				if ( $.sc.authSettings.login !== null ) {

					// https://ppl.atlassian.net/browse/CORE-2363
					// Notification bell
					 $('.js-notification-icon').after('<li class="notification-icon"><sc-actionable-notifications-bell></sc-actionable-notifications-bell></li>')
	
					//checkTimeout();

					// https://ppl.atlassian.net/browse/WBC-128
					// Hide Hero menu
					if ( $.sc.authSettings.pplId !== null) {
						if ( $.sc.authSettings.isOriginalPrincipalSag === false ) {
	
							summaryParameters(async function(response){
			
								currentState.summaryParameters = response;

								// Employer
								if ( $.sc.authSettings.isSag === false && $.sc.authSettings.isOrgAdmin === false && $.sc.authSettings.isCaseManager === false ) {
									//if ( params.MyPrograms.CompletedCount > 0 && params.MyPrograms.InProgressCount === 0 && params.MyEmployees.CompletedCount > 0) {
									if ( currentState.summaryParameters.Data.MyPrograms.CompletedCount === 0) {
										currentState.displayHeroMenu = false;
									}
								}

								// https://ppl.atlassian.net/browse/INT-56 Need to show the menu for Lincolnshire users
								if ( $.sc.authSettings.organisationId !== '4904d5d2-482a-41a9-9153-9e360154daa2') {

									if ( currentState.displayHeroMenu === false) {

										$('.header-nav_bottom-section').hide();
										$('.header-nav_bottom-dropdown-section').hide();
										$('.header-nav_basket-btn-desktop').hide();
										$('.js-nav_bottom-dropdown-container').hide();
										// $('#maincontent').css('margin-top', '0');
										$('.js-workas-btn').hide();
			
										// Mobile
										$('.header-nav_main-item-container-mobile').hide();
										$('.header-nav_basket-btn-mobile basket').hide();

										// https://ppl.atlassian.net/browse/CORE-2271 Need to show the menu for non electronic users
										const thisUser = await getUser();
										if ( thisUser !== null) {
											if ( thisUser.Data.IsNonElectronic === true) {
												$('.header-nav_bottom-section').show();
												$('.header-nav_bottom-dropdown-section').show();
												$('.header-nav_basket-btn-desktop').show();
												$('.js-nav_bottom-dropdown-container').show();
												// $('#maincontent').css('margin-top', '50px');
												$('.js-workas-btn').show();
			
												// Mobile
												$('.header-nav_main-item-container-mobile').show();
												$('.header-nav_basket-btn-mobile basket').show();
											}
										}
										
										

										
									}
								}


							});
	
						}
					}
				}	

				const headerHeight = $('.js-header-nav').height();
				$('header').outerHeight(headerHeight);

				waitForElem(`#loading-overlay`).then(() => {
					hideLoadingScreen();
				});
			},
	
			adjustDom: function() {

				// Fix issue with strapline being overlapped by header
				// var checkExistApp = setInterval(function() {
				
				// 	if ($('.header-active-dropdown-container').length > 0) {
				
				// 		clearInterval(checkExistApp);
				
				// 		if($('.header-nav_section').css('position') === 'fixed'){
				// 			$('.sc-strapline').css('margin-top', '50px')
				// 		} 
				// 	}
				
				// }, 200); // check every 200ms

				// Sets height of scrolling div in mobile/tablet full screen nav
				const displayHeight = window.innerHeight;
				const section = document.querySelector('.header-nav_top-section');
				const bottomContainer = document.querySelector('.header-nav_bottom-container-mobile');

				if (section && bottomContainer) {
					const sectionHeight = section.offsetHeight;
					const heightAdjustment = 78; // Modify this if needed
					bottomContainer.style.height = `${displayHeight - sectionHeight - heightAdjustment}px`;
				}


				// Copyright notice
				updateCopyrightYear();

				// Clear support Packages session storage if user navigates to another page
				if($('.support-package-page').length < 1){
					sessionStorage.removeItem("supportPackages");
				};
	
	
				$('.adminBox').closest('html').addClass('pcg-admin');


				function heroWrapper() {
					$('.hero-container').wrap('<div class="display-size-container container site-container"></div>');
				}

				function mainSectionWrap(className){
					$('.main-section').wrapAll(`<div class="pcg-page-wrapper container site-container ${className}</div>`);
				}

				function myLifeWrapper() {
					$('#myLifeExcerpt').wrapAll('<div class="hero-container"></div>');
				}

				function myAccountWrapper() {
					$('#myAccountExcerpt').wrapAll('<div class="hero-container"></div>');
				}

				function adminWrapperAll() {
					$('#administrationExcerpt').wrapAll('<div class="hero-container"></div>');
					heroWrapper();
					displaySizeWrap();
					adminExceprtRm();
				}

				function adminExceprtRm() {
					$('#administrationExcerpt').removeClass('tint4 round');
				}

				function padAddClass(){
					$('.pad').addClass('action-btns-section');
				}

				function bottomRibbonRm() {
					$('.bottomRibbon').remove();
				}

				function displaySizeWrap() {
					$('.display-size-container').wrap('<div class="hero-section"></div>')
				}

				function contentWrapFull() {
					$('.contentWrapper div').removeClass('full-columnAlt');
				}

				function liquidRemoveId() {
					$('.content-holder #liquid-round').removeAttr('id');
				}

				function articleFullRmClass() {
					$('.articleFull').removeClass();
				}

				function contentWrapRmDiv() {
					$('.contentWrapper div').removeClass('right-columnAlt');
				}

				function fullColAltRmClass() {
					$('.full-columnAlt').removeClass();
					$('.right-columnAlt').removeClass();	
				}

				function liquidReset() {
					$('#liquid-round').removeAttr('id');
					$('.center-content-no-top').removeClass();
					$('.liquid-round').removeClass();
					$('.top').remove();
					$('.topAlt').remove();
					$('.bottom').remove();
				}


				function mainSectionRmClass() {
					$('.main-section').removeClass('section');
				}

				function backBtnAddClass() {
					$('.actionButtons.tabs').addClass('back-btn-section');
					$('.back-btn-section').removeClass('actionButtons tabs');
					$('.back-btn-section li').addClass('back-btn-container');
					$('.back-btn-section a').addClass('blue-btn');
				}

				function supportPackageCommonDOM() {
					myLifeWrapper();
					heroWrapper();
					displaySizeWrap();
					$('#myLifeExcerpt img').remove();
				}

				function formHelpers() {
					$('.js-document-helper').remove();
					$('.js-whatsThisBtn').remove();
					$('.js-moreHelpBtn').remove();
					$('.js-reload-remove').remove();
				}

	
				// Redirect Personal Timesheets to Custom page
				if ( pageUrl ===  Urls.Domain + '/s4s/PersonalTimesheet') {
					window.location.href = `/s4s/CustomPage/Index/${Urls.personalTimesheets}`;
				}


				if ( pageUrl.includes('/ServiceProviderOrganisationWizard/CompanyDetails')) {
					$('#myLifeExcerpt h1').text('Add an employee');
					$('#myLifeExcerpt p').text('Please specify employee details');
	
					$('label[for=Name]').html('Employee name:<span class="required-asterisk">*</span>');
					$('label[for=VatNumber]').parent().hide();
				}
				
				// Forms
				if ( pageUrl.includes('/FormDetails') || pageUrl.includes('/AppFormDetails')) {
	
				//    console.log('scanForm activated');
					scanForm();
					if ( $('.js-container').length === 0 ) {
						$('sc-fill-form-app').wrap('<div class="container js-container"></div>')
					}
				}
	
				// Create user
				if ( pageUrl.includes('/SignUp/PersonalDetails')) {
	
					function scanSignUpForm() {
						$('label').each(function(){
		
							var thisText = $(this).attr('for');
							var thisName = $(this).find('input').attr('name');
			
							if ( thisText === 'OrganisationIdString') {
								$(this).text('Organisation: ')
							}
							if ( thisText === 'Forename') {
								$(this).html('First name:<span class="required-asterisk">*</span>')
							}
							if ( thisText === 'Surname') {
								$(this).html('Last name:<span class="required-asterisk">*</span>')
							}
			
			
			
							if (  thisName == 'IsReadOnlyIndividual') {
								$(this).hide();
							}
							if (  thisName == 'IsPbmForAnotherUser') {
								$(this).parent().hide();
							}
			
						});
					}
		
					scanSignUpForm();
					$('select').change(function(){
						scanSignUpForm();
					});
		
				}			
	
				// App forms   
				if ( pageUrl.includes('/AppFormDetails/') || pageUrl.includes('/Referrals/AddReferral') || pageUrl.includes('/AppFormDetails/FillForm') || pageUrl.includes('/PPLSignUp/PPLRegister') || pageUrl.includes('/CustomPage/Index/') || pageUrl.includes('/UserManagement/ToPreRegistration')) {
					
					
					// Clear so we dont get dupes
					formHelpers();
					
					var checkExistApp = setInterval(function() {
					
						// If forms has loaded then this div will be created
						if ($('.form-main-content').length > 0) {
	
							clearInterval(checkExistApp);
	
							$('.pcgf-app').parent().removeClass('pcgf-default');
							$('.form-date__control').parent().addClass('pcgf-default');
							$('.navigation-bar__item_clickable').attr('tabindex','0');
						}
	
					}, 200); // check every 100ms
				}
	
				if ( pageUrl.includes('/MyInvoices')) {
					$('html').addClass('pcg-admin').addClass('pcg-account');
					$('.dropDownBox label').each(function(){
						if ( $(this).text() === 'Till:') {
							$(this).text('To:');
						}
					})
				}
	
				if ( pageUrl.includes('/ProviderInvoices/Details/')) {
					$('.right-columnAlt h1').text('Invoice');
				}
			
				if ( pageUrl.includes('/ProviderInvoices/Import')) {
					$('.right-columnAlt > #administrationExcerpt > p').remove();
					$('.right-columnAlt > #administrationExcerpt > h1').after(
						'<p style="margin: 1rem 0 2rem 0">Here you can create your invoices which will be saved in one place for future reference. If you provide services for many different individuals you can upload a file to carry out a batch submission of invoices.</p>'
					);
					
				}
	
				if ( pageUrl.includes('/ProviderInvoices/Details')) {
					var guid = uuidv4();
					$('.right-columnAlt > h1').after(
						'<p style="margin: 1rem 0 2rem 0">Here you can edit your invoice. </p>'
					);
				}

				if ( pageUrl.includes('/UserManagement')) {
					$('#actionButtons a').each(function(){
						if ( $(this).attr('href') === '/s4s/UserManagement/ToPreRegistration') {
							$(this).parent().hide();
						}
					});
				}
	
				if ( pageUrl.includes('/')) {
					$('.pcg-menu-modal').parent().parent().hide();
				} else {
					$('.pcg-menu-modal').parent().parent().show();
				}
	
				if ( pageUrl.includes('/PurchaseOrderDetails/Main/')) {
	
					$('#liquid-round .grid th:nth-child(3)').remove();
					$('#liquid-round .grid td:nth-child(3)').remove();
					$('#liquid-round .grid col:nth-child(3)').remove();

					// https://jira.pcgprojects.co.uk/browse/CTS-37278
					$('#SupplierInvoiceNo').closest('dl').addClass('hide');
				}
	
				if ( pageUrl.includes('/MyAssessments/')) {
	
					var checkExistC = setInterval(function() {
	
						// If forms has loaded then this div will be created
						if ($('.s4s-pathway-header-container').length > 0) {
				
						setTimeout(function(){
							
							$('.answer-btns button').each(function(){
								if ( $(this).html() === 'Save' ) {
									$(this).hide();
								}
								if ( $(this).html() === 'Close (without saving)' ) {
									$(this).hide();
								}
							});
				
							clearInterval(checkExistC);
						}, 30);
						}
					}, 20); // check every 100ms
				}
	
				if ( pageUrl.includes('/ServiceOrderDetails/Appointments/')) {
					$('.js-accordion-body tbody tr').each(function(){
						// $(this).find('td:nth-child(1)').prepend('<small class="mobile-table-header">Action: </small>');
						$(this).find('td:nth-child(2)').prepend('<small class="mobile-table-header">Appointment date: </small>');
						$(this).find('td:nth-child(3)').prepend('<small class="mobile-table-header">Anytime?: </small>');
						$(this).find('td:nth-child(4)').prepend('<small class="mobile-table-header">Number of hours: </small>');
						$(this).find('td:nth-child(5)').prepend('<small class="mobile-table-header">Start and end time: </small>');
						$(this).find('td:nth-child(6)').prepend('<small class="mobile-table-header">Order cost: </small>');
						$(this).find('td:nth-child(1)').addClass('cta-button');
					});
				}
				
				if ( pageUrl.includes('/OrdersDetails/')) {
					mobileTableLabels();
				}
	
				if ( pageUrl.includes('/ProductDetails/') || pageUrl.includes('/StoreProductDetails/')) {
					$('#tabs').addClass('four-buttons');
				}
	
				if ( pageUrl.includes('/SupportPackageDetails/')) {
					mobileTableLabels();
				}
				
				if(pagePath.includes('/BulkUpdateProductPrice')) {

					// Unhide date picker
					$('.js-update-date-field-container').removeClass('invisible');
					$('.js-update-date-field-container').css('display', 'block');
				}
	
				// My typical week page styling
				if(pagePath.includes('/MyTypicalWeekSpa')) {
	
					// Add class to the page
					$('body').addClass('my-typical-week');
					$('sc-my-typical-week div').removeClass('mar-left1');
				}
	
				// My typical week template Details styling
				if(pagePath.includes('/MyTypicalWeekSpa/templateDetails')) {
					$('.actionButtons').first().addClass('back-btn-container');
					$('.back-btn-container').removeClass('actionButtons alt action_bar--left action_bar--medium');
				}
							
				// Calendar page styling
				if(pagePath.includes('/MyCalendar')) {
	
					// Add class to the page
					$('body').addClass('calendar');

						// Add hero section
						$('.contentPaddingAppointments').before(
							`
							<div class="hero-section">
								<div class="display-size-container pcg-page-wrapper container site-container">
									<div class="hero-container">
										<div id="myAccountExcerpt">
											<h1>My Calendar</h1>
											<p>Use the calendar to view your appointments. If you click an appointment you can see more information and even edit or cancel future appointments.</p>
										</div>
									</div>
								</div>
							</div>
							`
						);
		
					}

					if ( userInfo.readonly === true ) {
						$('body').addClass('readOnlyIndividual');
					}

					// Hide SSN
					if(pagePath.includes('/MyProfile/MyProfileTab')) {
						$('#SocialSecurityNumber').closest('.ValidateAltNorm').hide();
					}
				

				// Calendar styling
				if($('.dhx_cal_container').length > 0){

					// Edit calendar option
					$('.dhx_cal_navline').addClass('calendar-filter-container');
					$('.calendar-filter-container div').each(function(i, el){
	
						if(i <= 2){
							$(el).addClass(`day-filter day-filter-${i}`);
						};
						
						if(i == 3){
							$(el).addClass(`current-date-text current-date-text-${i}`);
						};
						
						if(i >= 4){
							$(el).addClass(`specific-filter specific-filter-${i}`);
						};
						
					});
	
					// Wraps the top selector filters
					$('.day-filter').wrapAll(`<div class="filter-container day-filter-container"></div>`);
					$('.current-date-text').wrapAll(`<div class="filter-container current-date-text-container"></div>`);
					$('.specific-filter').wrapAll(`<div class="filter-container specific-filter-container"></div>`);
	
					// DHTMLX calendar function calls to refresh the calendar size after page load
					setTimeout(function(){
						scheduler.updateView();
						scheduler.setCurrentView( scheduler.getState().date,'week' );

					}, 200)
				}
	
				// Invoice page styling
				if(pagePath.includes('/OrdersDetails/InvoiceDetails')) {
					
					// Add class the page
					$('body').addClass('invoice-details');

					contentWrapFull();
					myAccountWrapper();
					heroWrapper();
					displaySizeWrap();

					$('.display-size-container').addClass('pcg-page-wrapper container site-container');
					$('.pad-right').first().addClass('invoice-transaction-detail');
					$('.invoice-transaction-detail').removeClass('pad-right');
					$('.content-holder').first().addClass('invoice-one-off-items-section');
					$('.invoice-one-off-items-section').removeClass('content-holder');
					$('.pad-right').addClass('invoice-amount-section');
					$('.invoice-amount-section').removeClass('pad-right');
					$('.content-holder').last().addClass('invoice-payments-received-section');
					$('.invoice-payments-received').removeClass('content-holder');
					$('.invoice-transaction-detail, .invoice-one-off-items-section, .invoice-amount-section, .invoice-payments-received-section').addClass('invoice-detail-section');
					$('.invoice-one-off-items-section, .invoice-payments-received-section').addClass('invoice-full-table');
					$('.invoice-transaction-detail, .invoice-amount-section').addClass('invoice-summary-table-container');
					$('.invoice-detail-section').wrapAll('<div class="invoice-overview-container"></div>');
					$('.invoice-overview-container').wrapAll('<div class="pcg-page-wrapper container site-container invoice-s"></div>');
					$('.invoice-s').wrapAll('<div class="invoice-overview-section"></div>');
					$('.invoice-summary-table-container .span_12_of_12').addClass('invoice-summary-container');
					$('.invoice-summary-container').removeClass('col span_12_of_12');
					$('.invoice-summary-container .span_6_of_12').addClass('invoice-summary-table');
					$('.invoice-summary-table').removeClass('col span_6_of_12');
					$('.invoice-summary-container dl').removeClass();

					$('dt').addClass('table-heading');

					liquidReset();

					$('.invoice-full-table .center-content').addClass('invoice-one-off-items-container');
					$('.invoice-one-off-items-container').removeClass('center-content');
					$('.invoice-full-table #liquid-round').addClass('table-width');
					$('.table-width').removeAttr('id');
					$('.content-holder').removeClass('margin10');

					$('.invoice-full-table h2').addClass('heading-4');
					$('.actionButtons').addClass('main-action-btn-container');
					$('.main-action-btn-container').removeClass('actionButtons tabs');
					editButtons('.main-action-btn-container');
					$('.main-action-btn-container a').first().html('Back to order details');
					$(".main-action-btn-container").insertBefore(".invoice-transaction-detail");
	
					$('#myAccountExcerpt').append(`<li class="show-more-toggle js-show-more-toggle">Show more...</li>`);
	
					// Edit hero text first para
					$('#myAccountExcerpt p').first().html(
						`
						This is the list of all items that make up your invoice for this period and the dates/times you should have received the service. If you have any queries then please contact the provider before paying the invoice.
						`
					);
					
					// Edit hero text second para
					$('#myAccountExcerpt p').last().html(
						`
						If you wish to print this page for your records please use the print button in your web browser. You can also view a summary invoice by using the 'Print summary invoice' button. This will require the <a href="http://get.adobe.com/uk/reader/" target="_blank">Adobe Reader software</a> which you may need to install on your computer, this software is free.
						`
					);
	
					// Add class to bottom text container in hero
					$('#myAccountExcerpt p').last().addClass('hide-text js-hide-text');
	
					// Change the text of the toggle when clicked
					$('.js-show-more-toggle').on('click', function(){
	
						$('.js-hide-text').slideToggle();
						
						if($('.js-show-more-toggle').html() === "Show more..."){
							console.log($('.js-show-more-toggle').html())
							$('.js-show-more-toggle').html('Show less');
						} else {
							$('.js-show-more-toggle').html('Show more...');
						}
	
					});
	
	
	
				}
	
				// Payment details styling (general)
				if(pagePath.includes('/OrdersDetails/PaymentDetails/') || pagePath.includes('/OrdersDetails/PaymentConfirmation')) {
					
					// Add class the page
					$('body').addClass('payment-details');
					contentWrapFull();
	
					// Add classes/divs to hero text
					myAccountWrapper();
					heroWrapper();
					displaySizeWrap();
	
					// Add class to payment summary section and remove old class
					$('.pad-right').first().addClass('payment-transaction-detail payment-summary-table-container');
					$('.payment-transaction-detail').removeClass('pad-right');
	
					// Add class to payments received section and remove old class
					$('.content-holder').last().addClass('payment-form-section');
					$('.payment-payments-received').removeClass('content-holder');
	
					// Add a class to invoce sections
					$('.payment-transaction-detail, .payment-form-section').addClass('payment-detail-section');
	
					// Add class to payment form section and rmeove class/Id
					$('.payment-detail-section #liquid-round').removeAttr('id');
					$('.payment-detail-section .center-content').removeClass();
					$('.payment-detail-section .content-half').addClass('payment-form-container');
					$('.payment-form-container').removeClass('content-half borderedRight');
	
					// Edit for header container
					$('.payment-form-container .contentPadding').addClass('payment-form-heading-container');
					$('.payment-form-heading-container').removeClass('contentPadding tint2');
					$('.payment-form-heading-container h2').removeClass('center payTitle').addClass('heading-3');
					$('.payment-form-heading-container p').removeClass();
	
					// Remove class from form input
					$('fieldset').removeClass();
	
					// Add class to date filter and remove old class
					$('.appointmentDateFilter').addClass('date-filter');
					$('.date-filter').removeClass('appointmentDateFilter datesPicker roundb');
	
					// Add class and remove class from payment submit btn section
					$('form .center').addClass('payment-btn-section');
					$('.payment-btn-section').removeClass('center');
					$('.payment-btn-section ul').removeClass();
					$('.payment-btn-section li').addClass('payment-btn-container').removeClass('left');
					$('.payment-btn-section a').addClass('blue-btn');
					
					// Wrap all payment sections in a div
					$('.payment-detail-section').wrapAll('<div class="payment-overview-container"></div>');
					$('.payment-overview-container').wrapAll('<div class="pcg-page-wrapper container site-container payment-s"></div>');
					$('.payment-s').wrapAll('<div class="payment-overview-section"></div>');
	
					// Add classes to payment-summary-table-container divs and remove old classes
					$('.payment-summary-table-container .span_12_of_12').addClass('payment-summary-container');
					$('.payment-summary-container').removeClass('col span_12_of_12');
					$('.payment-summary-container .span_6_of_12').addClass('payment-summary-table');
					$('.payment-summary-table').removeClass('col span_6_of_12');
	
					// Remove classes from payment summary tables
					$('.payment-summary-container dl').removeClass();
	
					// Add class to table headings
					$('dt').addClass('table-heading');
	
					liquidReset();
					
				}
	
				// Order details payment styling
				if(pagePath.includes('/OrdersDetails/PaymentDetails/')) {
	
					// Add class the page
					$('body').addClass('order-details-payment');
	
					// Add classes to buttons section and remove old classes
					$('.actionButtons').addClass('main-action-btn-container');
					$('.main-action-btn-container').removeClass('actionButtons tabs');
					editButtons('.main-action-btn-container')
	
					// Move main buttons to main bottom section
					$(".main-action-btn-container").insertBefore(".payment-transaction-detail");
	
					// Edit back button text
					$('.main-action-btn-container a').html(`Back to order details`);
	
				}				
				
				// order details confirmation styling
				if(pagePath.includes('/OrdersDetails/PaymentConfirmation')) {
	
					// Add class the page
					$('body').addClass('order-details-confirmation');
	
					// Add classes to buttons section and remove old classes
					$('.actionButtons').addClass('main-action-btn-container');
					$('.main-action-btn-container').removeClass('actionButtons tabs');
					editButtons('.main-action-btn-container');
	
					// Move main buttons to main bottom section
					$(".main-action-btn-container").appendTo("#myAccountExcerpt");
					$('.main-action-btn-container a').html(`Back to order details`);
	
				}
				
				// Profile page styling
				if(pagePath.includes('/MyProfile')) {
					
					// Add class the page
					$('body').addClass('profile');
	
					// Remove right margin from page
					$('form div').removeClass('full-columnAlt');
	
					// Add form section class and remove old class
					$('.center-content-no-top').addClass('form-section');
					$('.form-section').removeClass('center-content-no-top').append('<div class="action-btns-container"></div>');
	
					// Append close button to new div
					$('#actionButtons a').addClass('form-submit-close-btn blue-btn close-btn');
					$('#actionButtons').first().appendTo('.action-btns-container').removeClass();
					
					// Append save button to new div and remove arrow img
					$('.orangeButtons').addClass('save-btn-section');
					$('.save-btn-section').removeClass('orangeButtons');
					$('.save-btn-section .right').removeClass();
					$('.save-btn-section a').addClass('blue-btn');
					$('.save-btn-section').appendTo('.action-btns-container');
					$('.myprofile-save-button img').remove();
	
					// Remove classes from form
					$('.account ul').removeClass();
					$('.account li').removeClass('blocks');
	
					// Remove old Id
					liquidReset();
	
					// Add new class and remove old from PA ref section
					$('.account .width420.col').addClass('pa-ref-section');
					$('.pa-ref-section').removeClass('width420 col');
					$('.pa-ref-section .center-content').removeClass();
					$('.pa-ref-section .initial-color').removeClass();
	
					// Add classes to tabs
					$('#tabs li').each(function(i, el){
						$(el).addClass(`tab-${i}`);
					});

					$('.tab-2').hide();
					$('.tab-3 a').html(`Exported Documents`);

				}
							
				// Profile page styling
				if(pagePath.includes('/MyProfile/DocumentsTab')) {
					
					// Add class the page
					$('body').addClass('profile-exported-docs');

					$('.action-btns-container').hide();
				}
								
				// Profile Additional information page page styling
				if(pagePath.includes('/MyProfile/AdditionalInformationTab')) {	
					// Change the hero text
					$('#myAccountExcerpt p').html(`You can tell us more about you and let us know if you want to receive a news letter or other information we send out sometimes.`);
									
				}
		
			
				// Provider timesheet
				if ( pagePath.includes('/ProviderTimesheetAdministration/Details/')) {

					// Add class the page
					$('body').addClass('timesheet-details');

					// Add in Previous markup CORE-887
					$('.contentWrapper > div').prepend(
						`
						<div class="hero-section">
							<div class="display-size-container pcg-page-wrapper container site-container">
								<div class="hero-container">
									<div id="myAccountExcerpt" class="tint4 round">
										<h1>Timesheet details</h1>
										<p></p>
									</div>
								</div>
							</div>
						</div>
						`
					);

					// Remove margin class from page
					fullColAltRmClass();
					adminExceprtRm();

					waitForElem(`sc-timesheet-details form`).then(() => {

						liquidReset();
	
						// Add class to main section div
						$('.form').addClass('main-section');
						$('.timesheet-participants-details__container').removeClass('timesheet-participants-details__container tint3 round');

						$('.form.main-section').css('margin', 'auto');

						// Remove hr
						$('hr').remove();

						// Edit close Timesheet button
						$('.actionButtons').addClass('close-btn-container');
						$('.close-btn-container').removeClass('actionButtons alt action_bar--left action_bar--medium');
						$('.close-btn-container button').hide();
					});

					waitForElem(`sc-fill-form-app .form-control--valid`).then(() => {
						$('[data-integration-timesheet-integration-id="start_date"]').hide().addClass('hide');
						createTimesheetFormAdjustDOM()
					})

					// Validation
					// waitForElem(`.form-validation-summary`).then(() => {
					// 	createTimesheetFormAdjustDOM()
					// })

					const observer = observeCreationOfElement('sc-fill-form-app', createTimesheetFormAdjustDOM);
				}


				// Personal timesheets
				if ( pagePath.includes('/PersonalTimesheet/Details/')) {

					//$('sc-timesheet-details').addClass('box-container');
					$('body').addClass('individual-view');

					if ( userInfo.readonly === true ) {
						waitForElem(`.action-bar`).then(() => {
							$('.form-btn.primary').hide()
						});
					}
				}

				// Provider & Personal timesheets
				if ( pagePath.includes('/ProviderTimesheetAdministration/Details/') || pagePath.includes('/PersonalTimesheet/Details/')) {
				
					// Add class the page
					$('body').addClass('timesheet-details');
	
					// Check if certain elements have loaded
					var checkExistApp = setInterval(function() {
					
						if ($('sc-timesheet-details').length > 0 && $('sc-fill-form-app').length > 0) {
							
							clearInterval(checkExistApp);
							
							// Add new class and remove class from timesheet number container
							$('.timesheet-common-info__container').addClass('timesheet-number-section timesheet-detail');
							$('.timesheet-number-section').removeClass('timesheet-common-info__container tint3 round');
							
							// Add new class and remove class from timesheet participaants container
							$('.timesheet-participants-details__container').addClass('timesheet-participants-section timesheet-detail');
							$('.timesheet-participants-section').removeClass('timesheet-participants-details__container tint3 round');

							// Remove bold class from labels
							$('.timesheet-detail label').removeClass();

							// Add class to timesheet section
							$('.pcgf-app').addClass('timesheet-section timesheet-detail');

							// Add class ot timesheet header
							$('.form-header__title').addClass('heading-3');

							// Remove class to timesheet section
							$('.timesheet-section .form-body').removeClass();
							$('.timesheet-section .form-main-content').removeClass();
	
							// Edit close button section
							$('.actionButtons').first().addClass('close-btn-container');
							$('.close-btn-container').removeClass('actionButtons alt action_bar--left action_bar--medium');
							$('.close-btn-container button').addClass('blue-btn');
							$('.close-btn-container button').removeClass('form-btn');

							if($('.main-section').length === 0){

								// Wrap main div in holding containers and display size containers
								$('sc-timesheet-details').wrapAll(`<div class="main-section"></div>`);
								$('.main-section').wrapAll(`<div class="pcg-page-wrapper timesheet-d"></div>`);
								$('.timesheet-d > div').removeClass('main-section')
							}

							// Provider timesheets
							if(pagePath.includes('/ProviderTimesheetAdministration/Details/')) {
								$('.close-btn-container button').hide();
								$('.close-btn-container').append(`<a class="blue-btn" href="/s4s/CustomPage/Index/${Urls.providerTimesheetsAdmin}">Close</a>`);
							}

						}
	
					}, 200); // check every 100ms


					waitForElem(`.craig_timesheet`).then(() => {

						$('.craig_timesheet .craig_timesheet tr').addClass('timesheet-date-row')

						var rows = document.querySelectorAll('.timesheet-date-row');
		
						// Iterate over each row
						rows.forEach(function(row) {

							// Populate the Hours
							var hoursDiv = row.querySelector('td:nth-child(2) > div > p > div');
							// Check if the div is found and log its text content
							if (hoursDiv) {
								var hours = hoursDiv.textContent.trim();
								// const hoursPlural = hours === '1' ? 'hour' : 'hours';
								// $(hoursDiv).html( hours + ' <small>' + hoursPlural + '</small>' )
								$(hoursDiv).html( hours + '<small>hr</small>' )

							}

							// Populate the Minutes
							var minutesDiv = row.querySelector('td:nth-child(3) > div > p > div');
							// Check if the div is found and log its text content
							if (minutesDiv) {
								var minutes = minutesDiv.textContent.trim();
								$(minutesDiv).html( minutes + '<small>min</small>')

							}
						});

					});

				}

		
				// Category page styling (personal assistants)
				if( pagePath.includes('/PersonalAssistants/Category')) {
	
					// Add class the page
					$('body').addClass('category');

					contentWrapRmDiv();
					myAccountWrapper();
					heroWrapper();
					displaySizeWrap();
	
					// Add site display sizes to hero
					$('.display-size-container').addClass('pcg-page-wrapper container site-container');
	
					// Check if certain elements have loaded
					var checkExistApp = setInterval(function() {
					
						if ($('sc-timesheet-category-list .actionButtons').length > 0) {
	
							clearInterval(checkExistApp);
							
							// Add class to filters and list section
							$('sc-timesheet-category-list').addClass('category-section');
	
							// Add class to approve button
							$('sc-timesheet-category-list .actionButtons').addClass('main-action-btn-container');
	
							// Remove classes from Add btn
							$('.main-action-btn-container').removeClass('actionButtons alt action_bar--left action_bar--medium');
							$('.main-action-btn-container button').removeClass();
							$('.main-action-btn-container button').addClass('blue-btn');
	
							// Add and update category tab link depending on module spelling
							$(currentUser.availableModules).each(function(i, el){

								if(el === 'personal_assistants' || el === 'personal_assistance'){
									// Prepend tab section above list section
									$('.main-action-btn-container').after(
										`
										<div class="category-selector-section">
											<ul class="category-selector-container">
												<li class="category_tab js-category_tab"><a href="/s4s/CustomPage/Index/${Urls.personalTimesheets}">Timesheets</a></li>
												${ el === 'personal_assistants' ? `<li class="category_tab js-category_tab active-tab"><a href="/s4s/PersonalAssistants/Category">Category</a></li>` : `<li class="category_tab js-category_tab active-tab"><a href="/s4s/PersonalAssistance/Category">Category</a></li>`}
												<li class="category_tab js-category_tab"><a href="/s4s/ContractDetails">Contract details</a></li>
												<li class="category_tab js-category_tab"><a href="/s4s/PrincipalTimesheetSettingsDetails">Timesheet periods</a></li>
											</ul>
										</div>
										`
									);
								};

							});
	
							// Add site container to timesheets section
							$('sc-timesheet-category-list').addClass('pcg-page-wrapper container site-container');
	
							// Add class to filters section
							$('.timesheet-list-page div.section.pad20').addClass('filters-section')
	
							// Adds filters toggle button
							$('#content-holder').before(
								`
								<button type="button" class="js-filter-toggle-btn filter-toggle-btn">
									Filters<i class="filter-icon fas fa-filter"></i>
								</button>
								`
							);
	
							// Toggles the filters section
							$('.js-filter-toggle-btn').on('click', function(){
								$('.filters-section').slideToggle()
							});     
							
							// // Remove old class from main section
							$('#content-holder .liquid-round').removeClass('liquid-round');
							$('.site-container .top, .site-container .bottom').remove();
	
							// Remove class from filters/list container
							$('.timesheet-list-page').removeClass('center-content');
	
							// Add class to select input elements
							$('.col.span_1_of_5').addClass('select-el');
	
							// Add classes to searchbar section
							$('.filters-section').next().addClass('searchbar-section');
							$('.searchbar-section div').first().addClass('searchbar-container');
							$('.searchbar-container input').addClass('searchbar');
	
							// Remove old class from searchbar container
							$('.searchbar-container').removeClass('border pad10 mar-left1 mar-right1 mar-bot1 tint7');
	
							// Edit search button icon
							$('.search-button').html(`<i class="documents-search-icon fas fa-search"></i>`);
	
							// And add new class to list item buttons
							$('.headButtons li a').addClass('list-item-btn');


							// Readonly
							if ( userInfo.readonly === true) {
								$('.action-bar').hide();
								$('.timesheet-list-page table thead th:first-child').hide();
								$('.timesheet-list-page table tbody td:first-child').hide();
							} 
							
	
							
						}
	
					}, 200); // check every 100ms
				}
	
				// Contract page styling (personal assistants)
				if(pagePath.includes('/ContractDetails')) {
	
					// Add class the page
					$('body').addClass('contract');
	
					contentWrapRmDiv();
					$('.pad20-no-bot').removeClass();
					$('#administrationExcerpt').attr('id', 'myAccountExcerpt');
	
					// Add classes/divs to hero text
					myAccountWrapper();
					heroWrapper();
					displaySizeWrap();
	
					$('.display-size-container').addClass('pcg-page-wrapper container site-container');
					$('.actionButtons, .content-holder').addClass('contract-section-item');
					$('.contract-section-item').wrapAll(`<div class="contract-section"></div>`);
					$('.contract-section').addClass('pcg-page-wrapper container site-container');
					$('.contract-section .actionButtons').addClass('main-action-btn-container');
					$('.main-action-btn-container li').removeClass();
					$('.main-action-btn-container a').addClass('blue-btn');
	
					// Add and update category tab link depending on module spelling
					$(currentUser.availableModules).each(function(i, el){

						if(el === 'personal_assistants' || el === 'personal_assistance'){
							// Prepend tab section above list section
							$('.main-action-btn-container').after(
								`
								<div class="category-selector-section">
									<ul class="category-selector-container">
										<li class="category_tab"><a href="/s4s/CustomPage/Index/${Urls.personalTimesheets}">Timesheets</a></li>
										${ el === 'personal_assistants' ? `<li class="category_tab"><a href="/s4s/PersonalAssistants/Category">Category</a></li>` : `<li class="category_tab"><a href="/s4s/PersonalAssistance/Category">Category</a></li>`}
										<li class="category_tab active-tab"><a href="/s4s/ContractDetails">Contract details</a></li>
										<li class="category_tab"><a href="/s4s/PrincipalTimesheetSettingsDetails">Timesheet periods</a></li>
									</ul>
								</div>
								`
							);
						};
					});
	
					// Remove class from filters/list container
					$('.content-holder .center-content').removeClass('center-content');
					
					liquidRemoveId();
					
					// Remove old divs
					$('.content-holder .top').remove();
					$('.content-holder .bottom').remove();
					
					// Remove old class from filters section
					$('.summary').removeClass('pad20').removeClass('round').addClass('filters-section');
	
					// Adds filters toggle button
					$('.content-holder').before(
						`
						<button type="button" class="js-filter-toggle-btn filter-toggle-btn">
							Filters<i class="filter-icon fas fa-filter"></i>
						</button>
						`
					);
	
					// Toggles the filters section
					$('.js-filter-toggle-btn').on('click', function(){
						$('.filters-section').slideToggle()
					}); 
	
					// Add class to select input elements
					$('.col.span_1_of_5 .dropDownBox').addClass('select-el');

					// Re-insert hero section at the top of the page
					$('.hero-section').insertBefore('.contract-section');


					// Read only
					if ( userInfo.readonly === true ) {
						$('.actionButtons.contract-section-item').hide();
						$('.content-holder.contract-section-item table thead th:first-child').hide();
						$('.content-holder.contract-section-item table tbody td:first-child').hide();
					}
				}

				// Timesheet period page styling (personal assistants)
				// https://ppl.atlassian.net/browse/CORE-1327
				if(pagePath.includes('/PrincipalTimesheetSettingsDetails')) {
	
					// Add and update category tab link depending on module spelling
					$(currentUser.availableModules).each(function(i, el){

						if(el === 'personal_assistants' || el === 'personal_assistance'){
							// Prepend tab section above list section
							$('.summary-page-layout__section').before(
								`
								<div class="contract category-selector-section" style="margin-top: 4rem;">
									<ul class="category-selector-container">
										<li class="category_tab"><a href="/s4s/CustomPage/Index/${Urls.personalTimesheets}">Timesheets</a></li>
										${ el === 'personal_assistants' ? `<li class="category_tab"><a href="/s4s/PersonalAssistants/Category">Category</a></li>` : `<li class="category_tab"><a href="/s4s/PersonalAssistance/Category">Category</a></li>`}
										<li class="category_tab"><a href="/s4s/ContractDetails">Contract details</a></li>
										<li class="category_tab active-tab"><a href="/s4s/PrincipalTimesheetSettingsDetails">Timesheet periods</a></li>
									</ul>
								</div>
								`
							);
						};
					});
	

				}
	
				// Support package section styling (general)
				if(pagePath.includes('/MySupportPackages') || pagePath.includes('/SupportPackageDetails')) {
	
					// Add class the page
					$('body').addClass('support-packages');
					contentWrapFull();
					$('.contentWrapper .articleLeft').addClass('hero-section');
					$('.hero-section').removeClass('articleLeft');
					$('#myAccountExcerpt').wrap(`<div class="pcg-page-wrapper container site-container hero-container"></div>`);
				}

				// Edit support package styling (Support package)
				if(pagePath.includes('/SupportPackage/MySupportNeeds')) {
	
					// Add class the page
					$('body').addClass('my-support-needs');

					supportPackageCommonDOM();
					$('.articleParent, .width-100percent, .articleWrapper, .articleFull, .articleLeft, .tint3 ').removeClass();
					$('.ValidateAltNorm br').remove();
					$('.asideRight').remove();
					$('.section.mar-bot1').addClass('attr-dropdown-section');
					$('.attr-dropdown-section').removeClass('section mar-bot1');
					$('.attr-dropdown-section .col.span_4_of_12.mar-top1').addClass('attr-dropdown-container')
					$('.twoCol').first().addClass('package-start-input');
					$('#TenderDaysDurationStr').parents('.ValidateAltNorm').addClass('reply-duration-input');
					$('.reply-duration-input').insertAfter('.package-start-input');

					$('#content-holder').wrapAll(`<div class="form-section-container"></div>`);
					$('.form-section-container').wrapAll(`<div class="pcg-page-wrapper container site-container form-s"></div>`);
					$('.form-s').wrapAll('<div class="form-section"></div>');
					
					$('.supportSteps').prependTo('.form-section-container');

					padAddClass();
					bottomRibbonRm();
					createBlueBtns();

					$('.action-btns-section').appendTo('.form-section-container');

					$('.ValidateAltNorm').each(function(i, el){
						$(el).addClass(`input-section-${i}`);
					})

					$('.input-section-5, .input-section-6, .input-section-7, .input-section-8, .input-section-9').hide();

					var showMore = $(`<p class="js-show-more show-more">Show more options...</p>`)
					$(showMore).insertAfter('.input-section-4');

					// Click show more to display the hidden fields
					$('.js-show-more').on('click', function(){
						$('.input-section-5').toggle(500);
						$('.input-section-6').toggle(500);
						$('.input-section-7').toggle(500);
						$('.input-section-8').toggle(500);
						$('.input-section-9').toggle(500);

						if($('.js-show-more').html() === 'Show more options...'){
							$('.js-show-more').html('Show less options...');
						} else {
							$('.js-show-more').html('Show more options...');
						}
					})
	
				}

				// Edit support package styling (Support package)
				if(pagePath.includes('/SupportPackage/ChooseProviders')) {
	
					// Add class the page
					$('body').addClass('choose-providers');
					// Add classes/divs to hero text
					supportPackageCommonDOM();

					$('.articleParent, .width-100percent, .articleWrapper, .articleFull, .articleLeft').removeClass();

					// Remove class from choose providers section
					$('.chooseProvidersContainer').removeClass('tint5 round');

					// Add/remove class from number of selected providers container
					$('.chooseProvidersContainer').addClass('number-of-selected-container');
					$('.number-of-selected-container').removeClass('chooseProvidersContainer');

					// Add/remove class from add/remove providers btns
					$('.addProviders a').addClass('add-remove-btn');
					$('.add-remove-btn').addClass('blue-btn');
					$('.add-remove-btn').removeClass('blockBtns green small');
					$('.add-remove-btn img').remove();

					// Wrap add/remove btns in container
					$('.add-remove-btn').wrapAll(`<div class="add-remove-btn-container"></div>`);

					// Move add.remove buttons before provier number text
					$('.add-remove-btn-container').appendTo('.addProviders');

					// Add class to provider list items section container
					$('#onlineStores').addClass('provider-list-items-container');

					// Add class to provider item container
					$('.provider-list-items-container li').addClass('provider-items-container');

					// Remove image container form provider item (image currently not pulling through)
					$('.store-proportions').remove();

					// Add class to item prover name and remove old class
					$('.itemBody').addClass('provider-name');
					$('.provider-name').removeClass('itemBody');

					// Add class to item prover button and remove old class
					$('.itemFooter').addClass('provier-item-btn-container');
					$('.provier-item-btn-container').removeClass('itemFooter');
					$('.provier-item-btn-container a').addClass('provier-item-btn').removeClass('blockBtns small');

					// Wrap main div in holding containers and display size containers
					$('#content-holder').wrapAll(`<div class="providers-section-container"></div>`);
					$('.providers-section-container').wrapAll(`<div class="pcg-page-wrapper container site-container providers-s"></div>`);
					$('.providers-s').wrapAll('<div class="providers-section"></div>');
					
					// Move support steps section into main form section
					$('.supportSteps').prependTo('.providers-section-container');
					
					padAddClass();
					bottomRibbonRm();
					createBlueBtns();
					$('.action-btns-section').appendTo('.providers-section-container');
	
				}

				// Add support package styling (Support package)
				if(pagePath.includes('/SupportPackage/AddProviders')) {
	
					// Add class the page
					$('body').addClass('add-providers');

					myAccountWrapper();
					heroWrapper();
					displaySizeWrap();

					$('#myAccountExcerpt img').remove();
					$('.articleParent, .width-100percent, .articleWrapper, .articleFull, .articleLeft').removeClass();
					$('.hero_micro-searchbar-container').appendTo('.hero-container')
					$('.supportSteps').prependTo('.support-package_list-section');
					
					padAddClass();
					bottomRibbonRm();
					createBlueBtns();
					$('.action-btns-section').appendTo('.support-package_list-section');
				}
	
				// My quotes page styling (Support package)
				if(pagePath.includes('/MySupportPackages')) {
	
					// Add class the page
					$('body').addClass('my-support-packages');
	

					$('#myAccountExcerpt h1').html(`My quotes`);
					$('#myAccountExcerpt').append(`<a class="create-package-btn blue-btn" href="/s4s/CustomPage/Index/${Urls.vwMicroCommisioning}?query=&Search=">Create new quote</a>`);
					$('#myAccountExcerpt p').html(
						`
						You can tell service providers about you and how you need supporting they can then provide a quote for their services. Select the 'Create a new quote' button to get started or select the 'View details' button to manage an existing request.
						`
					);

					$('.supportPackageCreate').remove();
					$('.itemSort').addClass('filter-item').removeClass('itemSort tint3 orders');
					$('.filter-item').each(function(i, el){
						$(el).addClass(`filter-item-${i}`);
					})
	
					$('.filterBox').addClass('filters-section')
					$('.filters-section').before(
						`
						<button type="button" class="js-filter-toggle-btn filter-toggle-btn">
							Filters<i class="filter-icon fas fa-filter"></i>
						</button>
						`
					);
	
					// Toggles the filters section
					$('.js-filter-toggle-btn').on('click', function(){
						$('.filters-section').slideToggle()
					});
	
					// Add classes to searchbar section and remove old class
					$('.contentWrapper .section').addClass('searchbar-section');
					$('.searchbar-section').removeClass('section');
					$('.searchbar-section div').first().removeClass('border pad10 tint7 mar-top10px mar-left10px mar-right20px');
					$('.searchbar-section div').first().addClass('search-query-filter');
					$('.searchbar-section span').addClass('searchbar-container');
	
					// Add class to search button
					$('.js-search-button').addClass('search-button');
	
					// Edit search button icon
					$('.search-button').html(`<i class="documents-search-icon fas fa-search"></i>`);
	
					// Add classes to list item buttons and remove old classes
					$('.yellowBtn').addClass('list-item-btn list-item-btn-blue');
					$('.greenBtn').addClass('list-item-btn list-item-btn-white');
					$('.list-item-btn').removeClass('yellowBtn greenBtn');
	
					// Remove old divs from table section
					$('#liquid-round .top').remove();
					$('#liquid-round .bottom').remove();
	
					// Add class to list item cell that hold buttons
					$('.gridrow a, .gridrow_alternate a').parent().addClass('list-item-btn-container');
	
					// Add class to divs within supprot package main section
					$('.filter-item-0, .filter-toggle-btn, .filters-section, .searchbar-section, .content-holder').addClass('support-packages-main');
	
					$('.support-packages-main').wrapAll('<div class="support-packages-container"></div>');
					$('.support-packages-container').wrapAll('<div class="pcg-page-wrapper container site-container support-p"></div>');
					$('.support-p').wrapAll('<div class="support-packages-section"></div>');

					// Add class to no package message container and append to support packages container
					$('.contentPadding').addClass('no-package-message');
					$('.no-package-message').appendTo('.support-packages-container');
				}
		
				// Support package details styling (general)
				if(pagePath.includes('/SupportPackageDetails')) {  
	
					// Add class the page
					$('body').addClass('support-package-details');

					$('.detailsRibbon, #tabs-holder, .content-holder, .liquid-round').addClass('main-section');
					$('.main-section').wrapAll(`<div class="package-details-container"></div>`);
					$('.package-details-container').wrapAll(`<div class="pcg-page-wrapper container site-container support-p"></div>`);
					$('.support-p').wrapAll('<div class="package-details-section"></div>');
					$('.detailsRibbon tr').first().addClass('desktop-details-headings-row');
					$('.detailsRibbon tr').last().addClass('desktop-details-row');
					$('.mobile-table-header').each(function(i, el){
						$(el).addClass(`mobile-table-header-${i}`);
					})
	
					$('.mobile-table-header-0').html('Service start date: ');
					$('.mobile-table-header-1').html('How much you can spend: ');
					$('.mobile-table-header-2').html('Start date: ');
					$('.mobile-table-header-3').html('End date: ');
					$('.mobile-table-header-4').html('Location: ');

					$('.detailsRibbon').clone().insertAfter('#tabs-holder');
					$('.detailsRibbon').first().remove();
	
					$('#tabs').removeClass('Alt');
					$('#tabs li').addClass('tab-item');
					$('#tabs li a').addClass('tab-item-anchor');
	
					liquidRemoveId();

					$('.content-holder .center-content-no-top').removeClass();
					$('.myStatement').removeClass('contentPadding');
					$('.myStatement li.blocks').removeClass();
					$('.bottom').remove();
					$('.bottomRibbon').addClass('bottom-btns-container');
					$('.bottom-btns-container').removeClass('bottomRibbon');
					$('.bottom-btns-container div').removeClass();
					$('.bottom-btns-container a').removeClass().addClass('blue-btn');
					$('.bottom-btns-container a img').remove();
					$('.bottom-btns-container').clone().appendTo('.package-details-container');
					$('.bottom-btns-container').last().remove();
				}
	
				// Support package Extend deadline styling 
				if(pagePath.includes('/SupportPackageDetails/ExtendDeadline')) {
	
					// Add class the page
					$('body').addClass('extend-deadline');

					$('.main-section').removeClass('liquid-round');
					$('.main-section .top').remove();
					$('.main-section .center-content').addClass('form-section');
					$('.form-section').removeClass('visible-overflow center-content');
					$('.main-section .account.supportPackage.section').removeClass();
					$('.main-section .blocks').removeClass();
					$('.ValidateAltNorm').first().addClass('days-hours-input');
					$('.ValidateAltNorm textarea').attr('rows', '5');
				}
		
				// Support package Manage Responses Tab styling 
				if(pagePath.includes('/SupportPackageDetails/ManageResponsesTab')) {
	
					// Add class the page
					$('body').addClass('manage-responses');

					liquidRemoveId();
					$('.content-holder div').removeClass('center-content-no-top');
					$('.myStatement').addClass('responses-container');
					$('.myStatement').removeClass('contentPadding');

					$('.section .col').addClass('individual-filter-container');
					$('.individual-filter-container').removeClass('col span_3_of_12');
					$('.individual-filter-container div').removeClass();
					
					$('.section').addClass('filters-container');
					$('.filters-container').removeClass('section');

					$('.chooseProvidersContainer').removeClass('tint4 round');
					$('.chooseProvidersContainer ul').removeAttr('id');
	
					$('.parent').addClass('response-item-container');
					$('.response-item-container').removeClass('parent');

					$('.itemBody h2').addClass('heading-3');
					$('.content-holder .bottom').remove();
	
					$('.itemFooter a').removeClass().addClass('blue-btn');
	
					$('.responses-container').prepend(
						`
						<button type="button" class="js-filter-toggle-btn filter-toggle-btn">
							Filters<i class="filter-icon fas fa-filter"></i>
						</button>
						`
					);
	
					// Toggles the filters section
					$('.js-filter-toggle-btn').on('click', function(){
						$('.responses-container form').slideToggle()
					});
	
				}
	
				// Support package Attachments Tab styling 
				if(pagePath.includes('/SupportPackageDetails/AttachmentsTab')) {  
	
					// Add class the page
					$('body').addClass('attachments');
	
					$('.supportPackageCreate').removeClass('left');
					$('#addAttachment').removeClass();
					$('#addAttachment').addClass('blue-btn');
					$('.myStatement .tint3').removeClass();
					$('table.attachments').addClass('attachments-table');
				}
	
				// Support package History Tab styling 
				if(pagePath.includes('/SupportPackageDetails/HistoryTab')) {  
	
					// Add class the page
					$('body').addClass('history');
				}
								
				// My Basket Tab styling 
				if(pagePath.includes('/MyBasket/MyBasket')) {  

					// Add class the page
					$('body').addClass('my-basket');

					if ( userInfo.readonly === true) {
						$('body').addClass('readOnlyIndividual');
					}
	
					// Add classes/divs to hero text
					$('#searchShopExcerpt').wrapAll('<div class="hero-container"></div>');
					heroWrapper();
					displaySizeWrap();
	
					// Add class to remove provider button section
					$('.basketTitle').parent().parent().addClass('remove-provider-items-container');
	
					// Add class to remove provider button
					$('.remove-provider-items-container a').addClass('remove-provider-btn');
					
					// Remove margin class from page
					fullColAltRmClass();
	
					// Add class to provider item table section and remove old classes/Id
					$('.remove-provider-items-container').next('div.section').addClass('provider-item-table-section');
					$('.provider-item-table-section').removeClass('section border pad10 roundb mar-right20px mar-bot1');
					$('.provider-item-table-section .liquid-round').removeClass();
					$('.provider-item-table-section #liquid-round').removeAttr('id');
					
					// Remove old divs item table section
					$('.provider-item-table-section .top').remove();
					$('.provider-item-table-section .bottom').remove();
					
					// Add class to provider item table container and remove old class
					$('.provider-item-table-section .center-content').addClass('provider-item-table-container');
					$('.provider-item-table-container').removeClass('center-content');
					$('.provider-item-table-container tr').removeClass();
	
					// Add class to oder now buttons and remove old class
					$('.purpleButtons').addClass('order-now-btn-container');
					$('.order-now-btn-container').removeClass('purpleButtons');
					$('.order-now-btn-container a').addClass('blue-btn');
					
					// Remove image from order now buttons
					$('.order-now-btn-container img').remove();
	
					// Add classes to update cost buttons section and remove old class
					$('table .basketButtons').addClass('update-cost-btn-section');
					$('.update-cost-btn-section').removeClass('basketButtons right primary');
					$('.update-cost-btn-section a').addClass('update-cost-btn');
					
					// Add classes to basketTotals section and remove old class
					$('.basketTotals').addClass('basket-total');
					$('.basket-total').removeClass('basketTotals');
	
					// Add class to basketTotals/update section
					$('.basket-total').parent().addClass('basket-total-update-container');
					$('.basket-total-update-container').parents('.grid').addClass('basket-total-update-section');
	
					// Wrap main div in holding containers and display size containers
					$('#content-holder').wrapAll(`<div class="basket-section-container"></div>`);
					$('.basket-section-container').wrapAll(`<div class="pcg-page-wrapper container site-container basket-s"></div>`);
					$('.basket-s').wrapAll('<div class="basket-section"></div>');
	
					// Add and remove classes from main action buttons section
					$('.actionButtons').parent().addClass('main-action-btn-section');
					$('.main-action-btn-section ul').addClass('main-action-btn-container');
					$('.main-action-btn-container').removeClass('actionButtons alt');
					$('.main-action-btn-section a').addClass('blue-btn');
	
					// Add class to first main action buttons section
					$('.remove-provider-items-container').first().addClass('first-remove-provider-items-container');
	
					// Edit url of add to basket button to go to the marketplaces page
					$('#addMoreItemsButtonId').attr('href', `/s4s/CustomPage/Index/${Urls.searchShopServices}?Page=Services&Search=`);
	
					var mainActionBtnSection = $('.main-action-btn-section');
	
	
					if($('.first-remove-provider-items-container').length > 0){
	
						$('.main-action-btn-section').insertBefore('.first-remove-provider-items-container');
	
					} else {
	
						$('#content-holder').append(mainActionBtnSection)
					}
				}
	
				// Basket Tab styling (appointment dates and times)
				if(pagePath.includes('/Basket/AppointmentDatesAndTimes') || pagePath.includes('/Basket/DeliveryAndBilling') || pagePath.includes('/Basket/OverviewAndPay')) {  
	
					// Add class the page
					$('body').addClass('basket-appointment-dates');
	
					// Add classes/divs to hero text
					myLifeWrapper();
					heroWrapper();
					displaySizeWrap();
					articleFullRmClass();
	
					// Add class and wrap main section containers
					$('.supportSteps, #content-holder').addClass('lower-section-item');
					$('.lower-section-item').wrapAll(`<div class="main-section-container"></div>`);
					$('.main-section-container').wrapAll(`<div class="pcg-page-wrapper container site-container appointment-s"></div>`);
					$('.appointment-s').wrapAll('<div class="main-section"></div>');
	
					// Add class and remove old class from add items button section
					$('.actionButtons.alt').first().addClass('add-items-btn-section');
					$('.add-items-btn-section').removeClass('actionButtons alt');
					$('.add-items-btn-section li').addClass('add-items-btn-container').removeClass('primary');
					$('.add-items-btn-section a').addClass('blue-btn');
					
					// Move Add items button into main section
					$('.add-items-btn-section').insertBefore('.supportSteps');
	
					// Edit choose dates and times button
					$('.basketButtons').addClass('choose-dates-btn-section');
					$('.choose-dates-btn-section').removeClass('basketButtons primary');
					$('.choose-dates-btn-section p').addClass('choose-dates-btn-container');
					$('.choose-dates-btn-section a').addClass('blue-btn');
					$('.choose-dates-btn-section img').remove();
	
					// Edit main basket button section
					$('.bottomRibbon .pad').addClass('basket-btns-section');
					$('.basket-btns-section').removeClass('pad');
					$('.basket-btns-section a').removeClass('blockBtns small green');
					$('.basket-btns-section img').remove();
					$('.basket-btns-section i').remove();

					// Add blue button class to next button and white button class to other options
					$('.basket-btns-section a').each(function(i, el){

						if($(el).hasClass('js-next-step-button')) {
							$(el).addClass('blue-btn');
						};
						
						if(!$(el).hasClass('js-next-step-button')) {
							$(el).addClass('white-btn');
						};

					});
	
					// Insert main basket button into main section
					$('.basket-btns-section').appendTo('.main-section-container');
	
					liquidReset();
					bottomRibbonRm();
	
					// Remove images from address headings
					$('.basketBoxes th img').remove();
	
					// Remove class from address table header
					$('.gridAltHeader').removeClass();
	
					// Edit buttons within tables
					$('.basket-appointment-dates .basketBoxes button').removeClass('form-btn primary');
					$('.basket-appointment-dates .basketBoxes button').addClass('blue-btn');
	
					// Remove class from textarea
					$('.basketBoxes').removeClass('contentPadding Alt');

					// Remove class from manual payment button
					$('#manualPaymentButtonId').removeClass('round mar-bot1');

					// Remove classes from online payment/manual payment buttons
					$('#paypalPaymentButtonId').removeClass('round mar-bot1');
				}
	
				// Basket Tab styling (choose dates and times)
				if(pagePath.includes('/Basket/ChooseDatesAndTimes') || pagePath.includes('/Basket/SelectRepeatingOptions') || pagePath.includes('/Basket/ReviewAppointments')) {  
	
					// Add class the page
					$('body').addClass('basket-choose-dates');
	
					// Add classes/divs to hero text
					myLifeWrapper();
					heroWrapper();
					displaySizeWrap();
					articleFullRmClass();
	
					// Remove class from fixed shortlist container
					$('.shortlist-container div').removeClass();
	
					// Add class to appointment section
					$('.js-first-appointment').addClass('appointment-section');
	
					// Remove class from main section
					$('.js-first-appointment .col').removeClass();
					
					// Add class to appointment container and remove old class
					$('.js-first-appointment .pad20.mar-top2.mar-bot1.center').addClass('appointment-container');
					$('.appointment-container').removeClass('pad20 mar-top2 mar-bot1 center');
	
					// Edit time duration section
					$('#durationSectionContainer .pad20.section.tint5').addClass('appointment-duration');
					$('.appointment-duration').removeClass('tint5');
					$('.appointment-duration .tint3.pad20.section.mar-bot1').addClass('hours-minutes-section');
					$('.appointment-duration .hours-minutes-section').removeClass('tint3 pad20 section mar-bot1');
	
					// Add class and wrap main section containers
					$('.supportSteps, #content-holder').addClass('lower-section-item');
					$('.lower-section-item').wrapAll(`<div class="main-section-container"></div>`);
					$('.main-section-container').wrapAll(`<div class="pcg-page-wrapper container site-container appointment-s"></div>`);
					$('.appointment-s').wrapAll('<div class="main-section"></div>');
	
					// Add class to repeat appointments tick box on repeating options page
					$('#isRepeatAppointments').parent().addClass('repeatAppointmentsInputSection');
	
					// Edit main basket button section
					$('.bottomRibbon .pad').addClass('basket-btns-section');
					$('.basket-btns-section').removeClass('pad');
					$('.basket-btns-section a').removeClass('blockBtns small green');
					$('.basket-btns-section img').remove();
					$('.basket-btns-section i').remove();

					// Add blue button class to next button and white button class to other options
					$('.basket-btns-section a').each(function(i, el){

						if($(el).hasClass('js-next-step-button')) {
							$(el).addClass('blue-btn');
						};
						
						if(!$(el).hasClass('js-next-step-button')) {
							$(el).addClass('white-btn');
						};

					});
	
					// Insert main basket button into main section
					$('.basket-btns-section').appendTo('.main-section-container')
					
					bottomRibbonRm();

					// Make time selector visible as soon as a calendar date is selected
					var checkExistApp = setInterval(function() {
				
						if ($('#appointmentDaysOfWeekContainer div').length > 0) {
					
							clearInterval(checkExistApp);
							$('.js-appointment-hours, .js-service-availability-container').removeClass('invisible');
							$('.js-service-availability-container').insertBefore('.js-appointment-hours');
							$('.js-appointment-hours').parent().addClass('time-section');
						}
					
					}, 200); // check every 200ms

					// Make date picker 'past date' warning appear when a past data is selected
					$('.js-warning-section').removeClass('invisible');
					$('.js-warning-section').css('display', 'none');

					// Add class to 'past date' warning section
					$('.js-warning-section').addClass('past-date-warning-container');
	
				}

				// Basket choose dates and times stlying
				if(pagePath === '/s4s/Basket/ChooseDatesAndTimes'){

					// Add class the page
					$('body').addClass('choose-dates-and-times');
	
					// Remove white button class from 'Add appointments' button and add blue button class
					$('.js-add-times').removeClass('white-btn');
					$('.js-add-times').addClass('blue-btn');
	
				}
			
				// Basket select repeating appointments stlying
				if(pagePath === '/s4s/Basket/SelectRepeatingOptions'){

					// Add class the page
					$('body').addClass('select-repeating-options');
	
					// Add class to each of the bottom action buttons
					$('.basket-btns-section a').each(function(i, el){
						$(el).addClass(`basket-btn-${i}`)
					});
	
				}
							
				// Basket delivery and billing stlying
				if(pagePath === '/s4s/Basket/DeliveryAndBilling'){

					// Add class the page
					$('body').addClass('delivery-billing');
	
				}
							
				// Basket overview and pay stlying
				if(pagePath === '/s4s/Basket/OverviewAndPay'){

					// Add class the page
					$('body').addClass('overview-pay');
	
				}

				// Basket order confirmation page styling
				if(pagePath.includes('/Basket/SubmittedOrder')) {  

					// Add class the page
					$('body').addClass('order-confirmation');
	
					// Remove old classes from page containers
					$('form div').removeClass('contentFixed full-columnAlt');
	
					// Add class to hero text container and remove old id/class
					$('#HelperBox').addClass('hero-text-container');
					$('.hero-text-container').removeClass('searchShop round tint4');
					$('.hero-text-container').removeAttr('id');
	
					// Add classes/divs to hero text
					$('.hero-text-container').wrapAll('<div class="hero-container"></div>');
					heroWrapper();
					displaySizeWrap();
	
					// Edit main bottom section
					$('#searchShopExcerpt').addClass('main-section-container');
					$('#searchShopExcerpt').removeAttr('id');
					$('hgroup').removeClass();
	
					$('.main-section-container h1').addClass('heading-2');
					$('.main-section-container').wrapAll(`<div class="pcg-page-wrapper container site-container order-c"></div>`);
					$('.order-c').wrapAll('<div class="main-section"></div>');

					$('.actionButtons.inline').addClass('main-action-btn-container');
					$('.main-action-btn-container').removeClass('actionButtons inline');
					$('.actionButtons.alt li').removeClass().appendTo('.main-action-btn-container');
					$('.main-action-btn-container a').addClass('blue-btn');
					
					$('.main-action-btn-container').insertBefore('hgroup h1');
					$('hgroup p').each(function(i, el){

						if(i === 2){
							$(el).html(
								`
								To follow the status of this order, please visit the <a href="/s4s/CustomPage/Index/${Urls.vwProductThree}?query=&vw=1">'Support summary'</a> area of this website which can be found under 'My Support'.
								`
							);
						};
	
					});

					// Remove class from items in basket message container
					$('.purpleButtons').removeClass();
					
				}
	
				// Product details styling (general)
				if(pagePath.includes('/ProductDetails') || pagePath.includes('/StoreProductDetails')) {
	
					// Add class the page
					$('body').addClass('product-details');
	
					fullColAltRmClass();
	
					// Add class to product item and remove old class
					$('.content-holder').first().addClass('product-item-container');
					$('.product-item-container').removeClass('content-holder');
	
					// Add classes/divs to hero
					$('.product-item-container').wrapAll('<div class="hero-container"></div>');
					heroWrapper();
					displaySizeWrap();
	
					// Add class to product item image section and remove Id
					$('#productLeft').addClass('product-item-image-section');
					$('.product-item-image-section').removeAttr('id');
					
					// Add class to product item details section and remove Id
					$('#productRight').addClass('product-item-details-section');
					$('.product-item-details-section').removeAttr('id');
	
					// Add class to product details heading and remove old class
					$('.product-item-details-section h1').addClass('heading-3').removeClass('inline-caption');
	
					// Remove tick image from product item details section
					$('.product-item-details-section p img').remove();
	
					// Add class to product item buttons section and remove Id/class
					$('#productOrder').addClass('product-item-btns-section');
					$('.product-item-btns-section').removeAttr('id').removeClass('roundb');
					$('#addToBasket').removeClass();
	
					editButtons('#addToBasket')

					// Remove class from tabs section tab
					$('#tabs a').removeClass('infoRequests')
	
					// Add class to main content section and remove old class
					$('.content-holder').addClass('main-content-section');
					$('.main-content-section').removeClass('content-holder');
	
					liquidReset();
	
					// Add class to main content container and remove old class
					$('.productDescription').addClass('main-content-container');
					$('.main-content-container').removeClass('contentPadding productDescription');
	
					// Add class to main content heading
					$('.main-content-container h2').addClass('main-content-heading heading-3');
	
					// Add class to input container and remove old class
					$('.requestService').addClass('input-container');
					$('.input-container').removeClass('requestService');
	
					// Edit submit request button section
					$('.purpleButtons').addClass('submit-request-btn-section');
					$('.submit-request-btn-section').removeClass('purpleButtons request');
					$('.submit-request-btn-section li').addClass('submit-request-btn-container');
					$('.submit-request-btn-container').removeClass('left mar-left1');
					$('.submit-request-btn-section a').addClass('blue-btn');
					$('.submit-request-btn-section img').remove();
	
					// Wrap main div in holding containers and display size containers
					$('#content-holder').wrapAll(`<div class="product-section-container"></div>`);
					$('.product-section-container').wrapAll(`<div class="pcg-page-wrapper container site-container product-d"></div>`);
					$('.product-d').wrapAll('<div class="product-section"></div>');
	
					// Add class to hero store banner section and remove old class
					$('.storeHeader').addClass('hero-banner');
					$('.hero-banner').removeClass('storeHeader');
					$('.hero-banner').removeAttr('style');
					$('.hero-banner .storeContainer').addClass('store-banner-image-container');
					$('.store-banner-image-container').removeClass('storeContainer');
	
					// Insert hero banner into hero section
					$('.hero-banner').insertBefore('.product-item-container');
	

				};

				// redirect the 'My Typical Week' 'Find products' button
				if(pagePath === "/s4s/Catalogue" || pagePath === "/s4s/Catalogue/"){

					$('#maincontent').html(
						'<div class="js-overlay" style="width: 100%; height: 100%; position: fixed; z-index: 10000000; top: 0; display: flex; justify-content: center; background-color: rgba(0, 0, 0, 0.2)">' +
						'<svg style="width: 80px;" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-spinner fa-w-16 fa-spin fa-lg"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" class=""></path></svg>' +
						'</div>'
					);

					window.location.href = "/s4s/CustomPage/Index/" + Urls.searchShopServices + "?Page=Services&Search="; 

				};

				if(pagePath.includes('/ProductDetails/')) {
					if ( userInfo.readonly === true) {
						$('body').addClass('readOnlyIndividual');
					}
				}

				// Insert add to list button to service detail page if navigated from My tpyical week page
				if(pagePath.includes('/ProductDetails/ProductDescriptionTab')) {

					//if(localStorage.getItem("myTypicalWeek") === 'true'){

						// Add class the page
						$('body').addClass('product-description');
	
						var url = pageUrl;

						// Remove built in add to list button
						$('.add-product-to-favourites').remove();
	
						// Product Id
						var prodId = url.split('ProductDescriptionTab/');
						prodId = prodId[1].split('?supId=').shift();
						
						// Supplier Id
						var supId = url.split('?supId=');
						supId = supId[1].split('&bcgId=').shift();
						
						// BCG Id
						var bcgId = url.split('&bcgId=');
						bcgId = bcgId[1];
	
						// Call api to check if item is a product, if false then its a service and do this
						$.getJSON(`/s4s/api/Products/GetProductDetails?productId=${prodId}&supplierId=${supId}&bcgId=${bcgId}`).done(function(data){
							
							if(data.IsProduct === false){
	
								// If 'my_typical_week' module is availabe then add buttons
								$(currentUser.availableModules).each(function(i, el){
			
									// Add add/remove to list button and back to my typical week button
									if(el === "my_typical_week"){
									
										$('.product-section-container').prepend(
										`
										<div class="add-to-list-btn-container">
											<a href="#" action="/s4s/MyTypicalWeek/AddProductToFavourites" class="blue-btn add-to-list-btn submitWithChangingAction">Add to list</a>
											<a href="#" action="/s4s/MyTypicalWeek/RemoveProductFromFavourites" class="blue-btn remove-from-list-btn hide-btn submitWithChangingAction">Remove from list</a>
											<a href="/s4s/MyTypicalWeekSpa" class="blue-btn">Back to My typical week</a>
										</div>
										`
										);
										
									};
									
								});
								
								// Call api from my typical week page that lists the favourited items
								$.getJSON('/s4s/api/MyTypicalWeekApi/GetFavouriteProducts').done(function(data){
			
									$(data).each(function(i, el){
										
										// Check if any of favourited items productId is the same as the the id in the product detail page url. If so, show remove from list button
										if(pagePath.includes(el.ProductId)) {
			
											$('.remove-from-list-btn').removeClass('hide-btn');
											$('.add-to-list-btn').addClass('hide-btn');
			
										};
			
									});
									
								});
			
								// Qulix function call to add/remove item from list
								var htmlEl = $('body');
								initializeSubmitWithChangingActionLinks(htmlEl);
	
							}
	
						});

					//};

				};	
	
				// Service order details styling 
				if(pagePath.includes('/ServiceOrderDetails')) {
	
					// Add class the page
					$('body').addClass('service-order');
	
					// Remove margin class from page
					fullColAltRmClass();
	
					// Add class to service image container
					$('.mar-top10px').first().addClass('service-item-img-container service-item');
					$('.service-item-img-container').removeClass('left mar-top10px');
	
					// Add class to service details container and remove old Id
					$('#productRight').addClass('service-item-details-container service-item');
					$('.service-item-details-container').removeAttr('id');
	
					// Add classes/divs to hero
					$('.service-item').wrapAll('<div class="service-item-container"></div>')
					$('.service-item-container').wrapAll('<div class="hero-container"></div>');
					heroWrapper();
					displaySizeWrap();
	
					// Add class to service item heading
					$('.service-item-details-container h1').addClass('heading-3');
	
					// Add class to service order summary tables
					$('.summary.alt.tint5.round').addClass('service-summary-table');
					$('.service-summary-table').removeClass('summary alt tint5 round');
	
					// Add class to table headings
					$('dt').addClass('table-heading');
	
					// Add class to main buttons container
					$('.actionButtons.inline').addClass('main-btns-container');
					$('.main-btns-container').removeClass('actionButtons inline');
					$('.main-btns-container a').addClass('blue-btn');
					
					// Add class to main buttons section
					$('.main-btns-container').parent().addClass('main-btns-section');
	
					// Remove class from address section
					$('.addressFooter').removeClass('tint3 round');
					
					// Add class to address section heading
					$('.addressFooter h2').addClass('heading-3');
	
					// Add and remove classes from invoice/delivery address
					$('.addressLeft').first().addClass('invoice-address-container');
					$('.addressLeft').last().addClass('delivery-address-container');
					$('.addressLeft').removeClass('addressLeft');
	
					// Add class to main section items
					$('.service-summary-table, .main-btns-section, .addressFooter').addClass('service-order-detail-section');
	
					// Wrap main div in holding containers and display size containers
					$('.service-order-detail-section').wrapAll(`<div class="service-order-section-container"></div>`);
					$('.service-order-section-container').wrapAll(`<div class="pcg-page-wrapper container site-container service-order-d"></div>`);
					$('.service-order-d').wrapAll('<div class="service-order-section"></div>');
	
					// Add class to back button section and remove old class
					backBtnAddClass();
	
					// Move back button section into main section
					const firstTable = $('.service-summary-table').first();
					$('.back-btn-section').insertBefore(firstTable);
	
	
				}

				// Service order details styling 
				if(pagePath.includes('/ServiceOrderDetails/Appointments')) {

					// Add class the page
					$('body').addClass('appointment-list');
	
					
					// Add classes/divs to hero text
					myAccountWrapper();
					heroWrapper();
					displaySizeWrap();
					articleFullRmClass();
					mainSectionRmClass();
	
					// Add class to main section and remove old class
					$('.hero-section').siblings('.section').addClass('main-section');
	
					// Wrap main section in desiplay container
					mainSectionWrap('appointment-l');
					$('.appointment-l').wrapAll('<div class="appointment-list-section"></div>');
	
					$('.main-section .col.span_12_of_12').first().addClass('appointment-month-section');
					$('.appointment-month-section').removeClass('col span_12_of_12');
	
					// Edit back button section
					backBtnAddClass();
					
					// Edit back button text
					$('.back-btn-section a').html(`Back to order details`);
					
					// Insert back button section before tabs section
					$('.back-btn-section').insertBefore('.appointment-month-section');
	
					// Remove class from table element
					$('table').removeClass('border');
					$('thead tr').removeClass('tint7');
	
	
	
	
				}
	
				// Premium stores styling 
				if(pagePath.includes('/PremiumStores')) {
	
					// Add class the page
					$('body').addClass('premium-stores');
	
					// Remove margin class from page
					fullColAltRmClass();
	
					// Add classes/divs to hero
					$('.storeHeader').addClass('hero-container');
					heroWrapper();
					displaySizeWrap();
					$('.hero-container').removeClass('storeHeader CustomPages');
					$('.hero-container').removeAttr('style');
	
					// Edit store Image container
					$('.storeContainer').addClass('store-image-container');
					$('.store-image-container').removeClass('storeContainer image-scale-container');
	
					// Add class to tab navigation container
					$('#storeNavigation ul').addClass('tabs-container');
	
					// Add active class to selected page tab
					$('.tabs-container a').each(function(i, el) {
						if(i === 1){
							$(el).addClass('active');
						};
					});
	
					// Add class to store heading
					$('.wrapperStores h1').addClass('store-heading');
					$('.store-heading').addClass('heading-2');
	
					// Add class to store details section and remove old class
					$('.wrapperStores').addClass('store-details-container');
					$('.store-details-container').removeClass('wrapperStores');
	
					// Add class to store description section and remove old class
					$('.storesLeft').addClass('store-description-container');
					$('.store-description-container').removeClass('storesLeft');
					
					// Add class to store contact details section and remove old class
					$('.storesRight').addClass('store-contact-container');
					$('.store-contact-container').removeClass('storesRight tint3');
	
					// Add classes to Review, Care quality and Find us sections
					$('.threeColumns').each(function(i, el){
	
						if(i === 0){
							$(el).addClass('store-review-section');
						};
						
						if(i === 1){
							$(el).addClass('store-care-section');
						};
						
						if(i === 2){
							$(el).addClass('store-find-section');
						};
	
					});
	
					// Remove old class from Review, Care quality and Find us sections
					$('.store-review-section, .store-care-section, .store-find-section').removeClass('threeColumns');
	
					// Add class to store detail sections
					$('.store-description-container, .store-contact-container, .store-review-section, .store-care-section, .store-find-section').addClass('store-section');
					
					// Add class to store detail section headings
					$('.store-section h2').addClass('heading-3');
	
					// Add class to Store review container and remove old class
					$('.tint3.innercolumns').addClass('store-review-container');
					$('.store-review-container').removeClass('tint3 innercolumns');
	
					// Add class to write review button
					$('.userReviewBtn').addClass('blue-btn');
	
					// Move tabs navigation section in store description section
					$('#storeNavigation').insertBefore('.store-heading');
	
					// Wrap main section in desiplay container
					$('.store-details-container').wrapAll(`<div class="pcg-page-wrapper container site-container premium-s"></div>`);
					$('.premium-s').wrapAll('<div class="service-order-section"></div>');
				}
	
				// Store products styling 
				if(pagePath.includes('/StoreProducts/Index/')) {
	
					var storeUrl = pagePath;
					var splitUrl = storeUrl.split('/s4s/StoreProducts/Index/');
					var providerUrl = splitUrl[1];
	
					// Add class the page
					$('body').addClass('store-products');
	
					fullColAltRmClass();
	
					// Add classes/divs to hero
					$('.storeHeader').addClass('hero-container hero-store-section');
					heroWrapper();
					displaySizeWrap();
					$('.hero-container').removeClass('storeHeader CustomPages').removeAttr('style');
	
					// Edit store Image container
					$('.storeContainer').addClass('store-image-container');
					$('.store-image-container').removeClass('storeContainer image-scale-container');
	
					// Add class to store heading container and remove old Id
					$('#searchShopExcerpt').addClass('store-heading-container');
					$('.store-heading-container').removeAttr('id');
					$('.store-image-container').wrapAll('<div class="hero-store-container"></div>').insertAfter('.store-image-container');
					$('.store-heading-container h1').addClass('store-heading heading-2');
	
					// Add class to searchbar section and remove old class
					$('.content-holderFilters').addClass('stores-searchbar-section');
					$('.stores-searchbar-section').removeClass('content-holderFilters');
					$('.stores-searchbar-section .searchForm').removeClass();
					$('#liquid-roundFilters').addClass('stores-searchbar-width');
	
					// Remove old id and classes from searchbar section
					$('#liquid-roundFilters').removeAttr('id');
					$('.topFilters').removeClass();
					$('.center-contentFilters').removeClass();
	
					// Remove label from searchbar section
					$('.stores-searchbar-section label').remove();
					
					// Remove classes from searchbar and add new class
					$('.stores-searchbar-section input').removeClass('search watermark').addClass('stores-searchbar');
	
					// Add class to searchbar container
					$('#searchForm').addClass('stores-searchbar-container');
	
					// Add class to search button
					$('.stores-searchbar-section a').addClass('stores-search-btn');
					
					// Remove text from search button
					$('.stores-search-btn').html(`<i class="stores-search-icon fas fa-search"></i>`);
	
					$('.stores-searchbar').attr("defaultvalue", "I'm looking for...")
	
					// Move searchbar section into hero section
					$('.stores-searchbar-section').insertAfter('.hero-store-container');
					
					// Add class to sort input container
					$('#content-holder form').addClass('sort-filter-container');
	
					// Wrap sort filter in container. Warp list section and pagination in container
					$('.sort-filter-container').wrap(`<div class="store-filters-section"></div>`);
					$('.store-main-section').wrapAll(`<div class="store-item-list-section"></div>`)
	
					// Remove old classes from filter container
					$('.itemSort').removeClass();
	
					// Insert filters header to filters section
					$('.sort-filter-container').prepend(`<h2 class="stores-filters-section-heading heading-4">Filters</h2>`);
	
					// Prepend filters toggle button to filters section
					$('.store-filters-section').prepend(
						`
						<button type="button" class="js-filter-toggle-btn filter-toggle-btn">
							Filters<i class="filter-icon fas fa-filter"></i>
						</button>
						`
					);
	
					// Toggles the filters section
					$('.js-filter-toggle-btn').on('click', function(){
						$('.store-filters-section form').slideToggle();
					});
	
					// Add class to list item section and remove old Id
					$('#itemList, .pagination-sort').addClass('list-item-section');
					$('.list-item-section').removeAttr('id');
	
					// Wrap list item section in contianer
					$('.list-item-section').wrapAll(`<div class="store-list-item-section"></div>`);
	
					// Add class to list item
					$('.list-item-section .parent').addClass('list-item');
	
					// Add class to list item container
					$('.list-item a').addClass('list-item-container');
	
					// Add class to list item image container and remove old class
					$('.product-proportions').addClass('list-item-image-container');
					$('.list-item-image-container').removeClass('product-proportions');
					
					// Add class to list item image and remove old class
					$('.list-item-image-container img').addClass('list-item-image');
					$('.list-item-image').removeClass('product-proportions');
	
					// Add class to list item product name section and remove old class
					$('.itemBody').addClass('list-item-product-info-container');
					$('.list-item-product-container').removeClass('itemBody');
					$('.list-item-product-info-container h2').addClass('list-item-product-name');
	
					// Add class to item store name container
					$('.itemFooter').addClass('list-item-store-name-container');
					$('.list-item-store-name-container').removeClass('itemFooter tint5');
	
					// Wrap main section in display containers
					$('#content-holder').wrap(`<div class="pcg-page-wrapper container site-container store-p"></div>`);
					$('.store-p').wrap(`<div class="store-products-main-section"></div>`);
	
					// Prepend tab section above list section
					$('.store-list-item-section').prepend(
						`
						<div class="category-selector-section">
							<ul class="category-selector-container">
								<li class="category_tab active-tab"><a href="${storeUrl}?Link=filtered">View our services</a></li>
								<li class="category_tab"><a href="/s4s/PremiumStores/Default/${providerUrl}">About this provider</a></li>
							</ul>
						</div>
						`
					);
	
				
				}
	
				// Orders details styling (general)
				if(pagePath.includes('/OrdersDetails/Orders/') || pagePath.includes('/OrdersDetails/Invoices/') || pagePath.includes('/OrdersDetails/Appointments/')) {
	
					// Add class the page
					$('body').addClass('orders');
	
					// Remove margin class from page
					fullColAltRmClass();
	
					// Add classes/divs to hero text
					myAccountWrapper();
					heroWrapper();
					displaySizeWrap();
	
					// Remove old classes from hero
					$('#myAccountExcerpt').removeClass();

					$('#tabs-holder').first().addClass('main-orders-section');
					$('.main-orders-section').removeAttr('id').removeClass('margin10');

					$('#tabs').removeClass();
					$('#tabs a img').remove();

					$('dl.summary.tint5.round').addClass('order-summary-container');
					$('.order-summary-container').removeClass('summary tint5 round').insertAfter('#tabs-holder');
	
					$('.top, .bottom').remove();
	
					$('.content-holder').first().addClass('main-section');
					$('.main-section .content-holder').removeClass('content-holder');
					
					$('.main-section #liquid-round').addClass('main-section-container').removeAttr('id');
					$('.main-section .center-content-no-top').removeClass();
					$('.main-section .center-content').removeClass();
					$('.main-section table').removeClass('noTabs');
	
					$('tr').removeClass('gridHeader account noTitle');
					$('table a').removeClass();

					mainSectionWrap('order-d');
					$('.order-d').wrapAll('<div class="service-order-section"></div>');

					backBtnAddClass();
					
					$('.back-btn-section a').html(`Back to my orders`);
					$('.back-btn-section').insertBefore('#tabs-holder');	
				}
	
				// Orders details styling (general)
				if(pagePath.includes('/OrdersAndInvoices/')) {
	
					// Add class the page
					$('body').addClass('orders-and-invoices');

					fullColAltRmClass();
					adminWrapperAll();
	
					// Add class to searchbar section and remove old class
					$('.summary .section.mar-bot1').addClass('searchbar-section');
					$('.searchbar-section').removeClass('section mar-bot1').insertAfter('#administrationExcerpt');

					$('.js-search-container').addClass('searchbar-container');
					$('.searchbar-container').removeClass('border pad10 tint7 mar-top10px mar-left10px mar-right20px');
					$('.js-search-button').addClass('searchbar-btn-container')
					$('.js-search-button').html(`<i class="orders-search-icon fas fa-search"></i>`);
	
					$('.itemSort').each(function(i, el){
						$(el).addClass(`filter-input-item filter-input-item-${i}`);
					});
	
					// Add class to each date filter container
					$('.filter-input-item-1 label').each(function(i, el){
						$(el).addClass(`filter-date-container-${i}`);
					});

					$('.filter-date-container-0 input').addClass('filter-date-picker-0');
					$('.filter-date-container-0 img').addClass('filter-date-picker-0');
					$('.filter-date-container-1 input').addClass('filter-date-picker-1');
					$('.filter-date-container-1 img').addClass('filter-date-picker-1');
					$('.filter-date-picker-0').wrapAll(`<div class="filter-date-picker-container"></div>`);
					$('.filter-date-picker-1').wrapAll(`<div class="filter-date-picker-container"></div>`);
					$('.filter-input-item').removeClass('itemSort tint3 orders chosen-width-250 provider-management-filter-box__item');
	
					$('.summary').addClass('filters-section');
					$('.filters-section').removeClass('summary tint5 round mar-right20px');
					$('.filterBox').addClass('filters-toggle-section');
					$('.filters-toggle-section').removeClass('filterBox provider-management-filter-box');
					$('.filters-section').prepend(
						`
						<button type="button" class="js-filter-toggle-btn filter-toggle-btn">
							Filters<i class="filter-icon fas fa-filter"></i>
						</button>
						`
					);
	
					$('.js-filter-toggle-btn').on('click', function(){
						$('.filters-toggle-section').slideToggle();
					});
					
					// Add class to main bottom section and remove old Id/class
					$('#tabs-holder').first().addClass('orders-invoices-section');
					$('.orders-invoices-section').removeAttr('id').removeClass('margin10');
	
					// Remove old div
					$('.top, .bottom').remove();
	
					// Add class to main bottom section and remove old class
					$('.content-holder').first().addClass('orders-list-section');
					$('.orders-list-section .content-holder').removeClass('content-holder');
					$('.orders-list-section #liquid-round').first().addClass('orders-list-container');
					$('.orders-list-section #liquid-round').removeAttr('id');
					$('.orders-list-section .center-content-no-top').removeClass();
					$('.orders-list-section .center-content').removeClass();
					$('.orders-list-section table').removeClass('noTabs');
	
					// Remove class from table header row
					$('tr').removeClass('gridHeader account noTitle');
					$('table a').removeClass();
					$('td a').parent().addClass('col-btn-container');
	
					// Add class to filters section and main section 
					$('.filters-section, .orders-list-section').addClass('main-section-container');
	
					$('.main-section-container').wrapAll(`<div class="main-section"></div>`);
	
					// Wrap main section in desiplay container
					mainSectionWrap('orders-i');
					$('.orders-i').wrapAll('<div class="service-order-section"></div>');
	
					// Edit back button section
					$('#actionButtons').addClass('action-btns-section');
					$('.action-btns-section').removeClass('actionButtons');
					$('.action-btns-section').removeAttr('id');
					$('.action-btns-section sc-export-button, .action-btns-section li').addClass('action-btns-container');
					$('.action-btns-section a').addClass('blue-btn');
					
					// Insert back button section before tabs section
					$('.action-btns-section').insertBefore('#tabs-holder');

					// Add class to table container
					$('table').parent().addClass('table-container');

					// Add mobile table headers
					mobileTableLabels();

					// Remove the bulk action tickbox header
					$('.js-bulk-action-item').siblings('small').hide();
					
				}
				
				// Schedule order details stlying (general)
				if(pagePath.includes('/ScheduleOrderDetails/')) {
	
					// Add class the page
					$('body').addClass('schedule-order');
	
					// Remove margin class from page
					fullColAltRmClass();
	
					// Add classes/divs to hero text
					adminWrapperAll();
	
					// Add class to main bottom section and remove Id
					$('#tabs-holder').first().addClass('schedule-order-section');
					$('.schedule-order-section').removeAttr('id');
	
					liquidReset();
	
					// Remove class from tabs section
					$('#tabs').removeClass('Alt')
	
					// Add class to schedule order container
					$('.center-content-no-top').first().addClass('schedule-order-container');
					$('.schedule-order-container').removeClass('center-content-no-top');
	
					// Add class to order image container and remove old class
					$('.left.mar-top10px.pad20').addClass('order-image-container order-item');
					$('.order-image-container').removeClass('left mar-top10px pad20');
	
					// Add class to order item description container and remove old class
					$('#productRight').addClass('order-description-container order-item');
					$('.order-description-container').removeClass('pad20').removeAttr('id');
	
					// Wrap order image and description in container
					$('.order-item').wrapAll(`<div class="order-item-container"></div>`);
	
					// Add class to order details table and remove old class
					$('.summary.tint5.round').addClass('details-table');
					$('.details-table').removeClass('summary tint5 round');
					
					// Add class to  order details table headings
					$('.details-table dt').addClass('details-table-heading');
	
					// Add class to details grid table
					$('.pad20').first().addClass('details-grid-table');
					$('.details-grid-table').removeClass('pad20');
	
					// Remove old Id/class from details grid table section
					$('.details-grid-table #liquid-round').removeAttr('id');
					$('.details-grid-table .center-content-no-top').removeClass();
					$('.gridHeader').removeClass('gridHeader admin');
	
					// Add class to address section and remove old class
					$('.addressFooter').addClass('details-table address-section');
					$('.details-table').removeClass('addressFooter tint3 round');
					$('.details-table .addressLeft').removeClass();
	
					// Remove header from address section
					$('.details-table h2').remove();
	
					// Add class to show list button section and remove old class
					$('.actionButtons.inline').parent().addClass('show-list-btn-section');
					$('.show-list-btn-section').removeClass('pad20');
					$('.show-list-btn-section .actionButtons').removeClass();
					$('.show-list-btn-section li').addClass('show-list-btn-container');
					$('.show-list-btn-section a').addClass('blue-btn');
	
					// Remove class from notes section
					$('.notes-block').removeClass('blocks tint3 round');
	
					// Edit page button section
					$('.orangeButtons').addClass('page-btn-section');
					$('.page-btn-section').removeClass('orangeButtons payManually');
					$('.page-btn-section li').addClass('page-btn-container');
					$('.page-btn-section a').addClass('blue-btn');
	
					$('.form-btn.note-creation-block__form-button').addClass('blue-btn');
					$('.blue-btn').removeClass('form-btn note-creation-block__form-button');
				
					// Wrap main section in desiplay container
					$('.schedule-order-section').wrapAll(`<div class="pcg-page-wrapper container site-container schedule-o"></div>`);
					$('.schedule-o').wrapAll('<div class="service-order-section"></div>');
	
					
				}

				// Schedule order main tab stlying (general)
				if(pagePath.includes('/ScheduleOrderDetails/Main')) {

					// Add class the page
					$('body').addClass('schedule-order-main');

					// Add class to back button section and remove old class
					$('.contentWrapper .actionButtons.tabs').addClass('btn-section');
					$('.btn-section').removeClass('actionButtons tabs');
					$('.btn-section li').addClass('btn-container');
					$('.btn-section a').addClass('blue-btn');

			
					// Insert back button sectoin before tabs section
					$('.btn-section').insertBefore('#tabs-holder');
				}
							
				// Schedule order main tab stlying (general)
				if(pagePath.includes('/ScheduleOrderDetails/Appointments')) {

					// Add class the page
					$('body').addClass('schedule-order-appointments');

					articleFullRmClass();
					mainSectionRmClass();

					// Add class to main bottom section and remove old class
					$('.section').addClass('main-section');

					// Wrap main section in desiplay container
					mainSectionWrap('schedule-a');
					$('.schedule-a').wrapAll('<div class="appointments-section"></div>');

					backBtnAddClass();
					
					// Insert back button sectoin before tabs section
					$('.btn-section').prependTo('.main-section');



				}
							
				// Purchase order details notes tab stlying
				if(pagePath.includes('/ScheduleOrderDetails/Notes')) {
	
					// Add class the page
					$('body').addClass('schedule-order-notes');

					backBtnAddClass();
					
					// Add class to each back button container
					$('.btn-section').each(function(i, el){
						$(el).addClass(`btn-section-${i}`);
					});

					// Edit text of back button
					$('.btn-section-0 a').html(`Back to orders and invoices`);
					
					// Insert back button sectoin before tabs section
					$('.btn-section-0').insertBefore('#tabs-holder');

				}
	
				// Invoice details stlying (general)
				if(pagePath.includes('/InvoiceDetails/')) {
	
					// Add class the page
					$('body').addClass('provider-invoice-details');
	
					// Remove margin class from page
					fullColAltRmClass();
					adminWrapperAll();
	
					// Add class to main bottom section and remove Id
					$('#tabs-holder').first().addClass('provider-invoice-details-section');
					$('.provider-invoice-details-section').removeAttr('id');
	
					liquidReset();
	
					// Add class to invoice details section
					$('.center-content-no-top').first().addClass('invoice-details');
					$('.invoice-details').removeClass('center-content-no-top');
	
					// Add class to order details table and remove old class
					$('.summary.tint5.round').addClass('details-table');
					$('.details-table').removeClass('summary tint5 round');
					
					// Add class to  order details table headings
					$('.details-table dt').addClass('details-table-heading');
	
					// Add class to details grid table
					$('.pad20').first().addClass('details-grid-table');
					$('.details-grid-table').removeClass('pad20');
	
					// Remove old Id/class from details grid table section
					$('.details-grid-table #liquid-round').removeAttr('id');
					$('.details-grid-table .center-content-no-top').removeClass();
					$('.gridHeader').removeClass('gridHeader admin');
	
					// Remove class from invoice details sections
					$('.invoice-details .pad-right').removeClass();
					$('.invoice-details .col.span_12_of_12').removeClass();
					$('.invoice-details .col.span_6_of_12').removeClass();
	
					// Remove class from recurring items header
					$('p.margin10').addClass('recurring-items-header');
					$('.recurring-items-header').removeClass('margin10');
	
					// Add class to show list button section and remove old class
					$('.actionButtons.inline').parent().addClass('show-list-btn-section');
					$('.show-list-btn-section').removeClass('pad20');
					$('.show-list-btn-section .actionButtons').removeClass();
					$('.show-list-btn-section li').addClass('show-list-btn-container');
					$('.show-list-btn-section a').addClass('blue-btn');
	
					// Add class to back button section and remove old class
					$('.actionButtons.tabs').first().addClass('back-btn-section');
					$('.back-btn-section').removeClass('actionButtons tabs');
					$('.back-btn-section li').addClass('back-btn-container');
					$('.back-btn-section a').addClass('blue-btn');
					$('.back-btn-section a').first().html(`Back to orders and invoices`);

					// Edit save and close button
					$('.note-creation-block__save-button').removeClass('actionButtons tabs');
					$('.note-creation-block__save-button a').addClass('blue-btn');
	
					// Insert back button sectoin before tabs section
					$('.back-btn-section').insertBefore('#tabs-holder');
	
					// Remove save button from back button section
					// $('.back-btn-section a.submit').remove();
	
					// Remove class from notes section
					$('.notes-block').removeClass('blocks tint3 round');
	
					// Edit page button section
					$('.orangeButtons').addClass('page-btn-section');
					$('.page-btn-section').removeClass('orangeButtons payManually');
					$('.page-btn-section li').addClass('page-btn-container');
					$('.page-btn-section a').addClass('blue-btn');
	
					$('.form-btn.note-creation-block__form-button').addClass('blue-btn');
					$('.blue-btn').removeClass('form-btn note-creation-block__form-button');
				
					// Wrap main section in desiplay container
					$('.provider-invoice-details-section').wrapAll(`<div class="pcg-page-wrapper container site-container provider-invoice-d"></div>`);
					$('.provider-invoice-d').wrapAll('<div class="service-order-section"></div>');
	
					
				}

				// Product order details stlying
				if(pagePath.includes('/ProductOrderDetails/Index/')) {

					// Add class the page
					$('body').addClass('product-order');
	
					// Remove margin class from page
					fullColAltRmClass();
	
					// Add classes/divs to hero text
					myAccountWrapper();
					heroWrapper();
					displaySizeWrap();
	
					// Remove old classes from hero
					$('#myAccountExcerpt').removeClass();
	
					// Add class to main bottom section and remove old Id/class
					$('#tabs-holder').first().addClass('main-orders-section');
					$('.main-orders-section').removeAttr('id');
					$('.main-orders-section').removeClass('margin10');
	
					// Remove Id from tabs section
					$('#tabs').removeClass();
	
					// remove image from tab
					$('#tabs a img').remove();
	
					// Add class to order summary section and remove old class
					$('dl.summary.tint5.round').addClass('order-summary-container order-info-container');
					$('.order-summary-container').removeClass('summary tint5 round');

					// Add class to address section and remove old class
					$('.addressParent').addClass('order-address-section order-info-container');
					$('.order-address-section').removeClass('addressParent tint3 round');
					$('.addressLeft').removeClass();
					
					// Add class to address section heading and inner containers
					$('.order-address-section h2').addClass('heading-3');
					$('.order-address-section div').first().addClass('invoice-address-container');
					$('.order-address-section div').last().addClass('delivery-address-container');

					// Move address section below summary section
					$('.order-address-section').insertAfter('.order-summary-container');
	
					// Move order summary section after tabs container
					$('.order-summary-container').insertAfter('#tabs-holder');
	
					// Remove old div
					$('.top, .bottom').remove();
	
					// Add class to main bottom section and remove old class
					$('.content-holder').first().addClass('main-section');
					$('.main-section .content-holder').removeClass('content-holder');
					
					// Remove old Id/classes from main section
					$('.main-section #liquid-round').first().addClass('main-section-container');
					$('.main-section #liquid-round').removeAttr('id');
					$('.main-section .center-content-no-top').removeClass();
					$('.main-section .center-content').removeClass();
					$('.main-section table').removeClass('noTabs');

					// Add/remove class from table section
					$('.main-section-container .margin10').addClass('table-section');
					$('.table-section').removeClass('margin10');
					$('table').parent().addClass('table-container');
	
					// Remove class from table header row
					$('tr').removeClass('gridHeader account noTitle');
	
					// Remove class from table button
					$('table a').removeClass();

					// Add/remove class from cost table section
					$('.summary.right.tint3.round').addClass('order-cost-container order-info-container');
					$('.order-cost-container').removeClass('summary right tint3 round');
	
					// Wrap main section in desiplay container
					mainSectionWrap('order-d');
					$('.order-d').wrapAll('<div class="service-order-section"></div>');
	
					// Edit back button section
					backBtnAddClass();
					
					// Edit back button text
					$('.back-btn-section a').html(`Back to my orders`);
					
					// Insert back button section before tabs section
					$('.back-btn-section').insertBefore('.order-summary-container');

				}
	
				// Purchase order details stlying (general)
				if(pagePath.includes('/PurchaseOrderDetails/')) {
	
					// Add class the page
					$('body').addClass('purchase-order');
	
					fullColAltRmClass();
					adminWrapperAll();

					// Add class to main bottom section and remove Id
					$('#tabs-holder').first().addClass('purchase-order-section');
					$('.purchase-order-section').removeAttr('id');
	
					liquidReset();
	
					// Remove class from tabs section
					$('#tabs').removeClass('Alt');
					$('#tabs-holder').removeClass('margin10');
	
					// Add class to schedule order container
					$('.center-content-no-top').first().addClass('purchase-order-container');
					$('.purchase-order-container').removeClass('center-content-no-top');
	
					// Add class to order image container and remove old class
					$('.left.mar-top10px.pad20').addClass('order-image-container order-item');
					$('.order-image-container').removeClass('left mar-top10px pad20');
	
					// Add class to order item description container and remove old class
					$('#productRight').addClass('order-description-container order-item');
					$('.order-description-container').removeClass('pad20');
					$('.order-description-container').removeAttr('id');
	
					// Wrap order image and description in container
					$('.order-item').wrapAll(`<div class="order-item-container"></div>`);
	
					// Add class to order details table and remove old class
					$('.summary.tint5.round').addClass('details-table');
					$('.summary.right.tint3.round').addClass('details-table');
					$('.details-table').removeClass('summary right tint5 tint3 round');
					
					// Add class to  order details table headings
					$('.details-table dt').addClass('details-table-heading');
	
					// Add class to details grid table
					$('.provider-management-pi-container').addClass('details-grid-table');
					$('.details-grid-table').removeClass('content-holder margin10 provider-management-pi-container');
	
					// Remove old Id/class from details grid table section
					$('.details-grid-table #liquid-round').removeAttr('id');
					$('.details-grid-table .center-content-no-top').removeClass();
					$('.gridHeader').removeClass('gridHeader admin');
	
					// Add class to address section and remove old class
					$('.addressParent').addClass('details-table address-section');
					$('.details-table').removeClass('addressParent tint3 round');
					$('.details-table .addressLeft').removeClass();
	
					// Remove header from address section
					$('.details-table h2').remove();
	
					// Add class to show list button section and remove old class
					$('.actionButtons.inline').parent().addClass('show-list-btn-section');
					$('.show-list-btn-section').removeClass('pad20');
					$('.show-list-btn-section .actionButtons').removeClass();
					$('.show-list-btn-section li').addClass('show-list-btn-container');
					$('.show-list-btn-section a').addClass('blue-btn');
	
					// Remove class from notes section
					$('.notes-block').removeClass('blocks tint3 round');
	
					// Edit page button section
					$('.orangeButtons').addClass('page-btn-section');
					$('.page-btn-section').removeClass('orangeButtons payManually');
					$('.page-btn-section li').addClass('page-btn-container');
					$('.page-btn-section a').addClass('blue-btn');
	
					$('.form-btn.note-creation-block__form-button').addClass('blue-btn');
					$('.blue-btn').removeClass('form-btn note-creation-block__form-button');
					
					// Wrap main section in desiplay container
					$('.purchase-order-section').wrapAll(`<div class="pcg-page-wrapper container site-container schedule-o"></div>`);
					$('.schedule-o').wrapAll('<div class="service-order-section"></div>');
				}

				// Purchase order details main tab stlying
				if(pagePath.includes('/PurchaseOrderDetails/Main')) {
	
					backBtnAddClass();
					
					$('.btn-section').insertBefore('#tabs-holder');
					$('.btn-section').last().remove();

				}
				
				// Purchase order details notes tab stlying
				if(pagePath.includes('/PurchaseOrderDetails/Notes')) {
	
					// Add class the page
					$('body').addClass('purchase-order-notes');

					backBtnAddClass();
					
					// Add class to each back button container
					$('.btn-section').each(function(i, el){
						$(el).addClass(`btn-section-${i}`);
					});

					// Edit text of back button
					$('.btn-section-0 a').html(`Back to orders and invoices`);
					
					// Insert back button sectoin before tabs section
					$('.btn-section-0').insertBefore('#tabs-holder');

				}
	
				// Timesheet list redirect
				if(pagePath === '/s4s/ProviderTimesheetAdministration'){
					window.location.href = `/s4s/CustomPage/Index/${Urls.providerTimesheetsAdmin}`
				}
	
				// Create timesheet styling
				if(pagePath === '/s4s/ProviderTimesheetAdministration/Create'){

					// Add in Previous markup CORE-887
					$('.contentWrapper > div').prepend(
						`
						<div class="hero-section">
							<div class="display-size-container pcg-page-wrapper container site-container">
								<div class="hero-container">
									<div id="myAccountExcerpt" class="tint4 round">
										<h1>Create timesheet</h1>
										<p></p>
									</div>
								</div>
							</div>
						</div>
						`
					);


					// Add class the page
					$('body').addClass('create-timesheet');
	
					// Remove margin class from page
					fullColAltRmClass();
					adminExceprtRm();
	
					waitForElem(`sc-timesheet-details form`).then(() => {

						liquidReset();
		
						// Add class to main section div
						$('.form').addClass('main-section');
						$('.timesheet-participants-details__container').removeClass('timesheet-participants-details__container tint3 round');
						$('.form.main-section').css('margin', 'auto');

						// Remove hr
						$('hr').remove();

						// Edit close Timesheet button
						$('.actionButtons').addClass('close-btn-container');
						$('.close-btn-container').removeClass('actionButtons alt action_bar--left action_bar--medium');
						$('.close-btn-container button').hide();

						// Prepend label
						$('.js-select-pa__label').remove();
						$('.buyer-info__container').prepend(
							`<p class="js-select-pa__label">Select an individual:</p>`
						);
					});

					

					// Listen for changes to DOM
					const observerElement = observeCreationOfElement('sc-fill-form-app', timesheetLoaded);
				}


				if(pagePath.includes('/FinanceManagementAdministration/ManualTransactionPayments')) { 
					$('body').css('overflow-x', 'auto');
					$('.summary-page-layout').css('margin-right', '0');

					$('.table-wrapper').css('overflow-x', 'scroll');

					$(".manual-transactions-payment__table").draggable({ 
						cursor: "move", 
						containment: "parent",
						stop: function() {
						  if(jQuery(".manual-transactions-payment__table").position().left < 1)
							  jQuery(".manual-transactions-payment__table").css("left", "720px");
						}
					});
				}

				function timesheetLoaded() {

					console.log('timesheetLoaded()');

					createTimesheetFormAdjustDOM();

					// Listen for when the Date container comes on
					const className = 'js-date-container';
					const observer = observeCreationOfClass(className, node => {
						//console.log('Action performed on:', node);
						//console.log('observeCreationOfClass');

						createTimesheetFormAdjustDOM();
						observer.disconnect();

						// Stop the Start date from being changed
						$('[data-integration-timesheet-integration-id="start_date"]').addClass('readonlyOverlay');
					});
				}

				function getTimesheetCategoryEndpoint(individualId, categoryType, callback) {
					// Make a GET request using the Fetch API
					fetch('/s4s/api/Timesheet/Categories?supplierId=' + $.sc.authSettings.organisationId + '&individualId=' + individualId + '&categoryType=' + categoryType)
					.then(response => {
					if (!response.ok) {
						throw new Error('Network response was not ok');
					}
					return response.json();
					})
					.then(userData => {
					// Process the retrieved user data
					console.log('User Data:', userData);
					callback(userData)
					})
					.catch(error => {
					console.error('Error:', error);
					});
				}

				function createTimesheetFormAdjustDOM() {
					removeTimesheetsWrapping('', function(){
					
						waitForElem(`sc-fill-form-app .form-control--valid`).then(() => {

							// Remove class/Id
							$('.form-main-content').removeClass();
							$('.form-main__questions-container').removeClass();

							showPTOMileageExpensesChecklists();

							waitForElem(`.question-type-search`).then(() => {
								showFinishButtonAndNotes();
							});

							// Append Fake finish button
							waitForElem(`.form-mongo-search__answer`).then(() => {
								$('.js-mimic-finish').remove();
								$('.form-navigation-btns__container').append('<button type="button" class="js-mimic-finish pcgf-button pcgf-button--primary form-navigation-btns__button">Submit timesheet</button>')
								
								// CTA
								$('.js-mimic-finish').click(function(){
									validateTimesheet(function() {
										removeTimesheetsWrapping('', function(){
											// Check on the Finish buton if it exists otherwise click on next
											if ($('.form-navigation-btns__btn_finish').length > 0) {
												$('.form-navigation-btns__btn_finish').click();
											} else {
												$('.form-navigation-btns__btn_next').click();
											}
										});
									});
								});
							
							});
							
							// Check what type of form
							if ($('.form-app').hasClass('monthly-timesheet')) {

								//console.log('Monthly timesheet')
								rewrapElements('.js-services-date-container'); // Services
								rewrapElements('.js-pto-date-container'); // PTO
								rewrapElements('.js-sleep-date-container', 'single-field'); // Sleep
								rewrapElements('.js-miles-date-container', 'single-field'); // Mileage
								rewrapElements('.js-expenses-date-container', 'single-field'); // Expenses

							} else {
								rewrapElements('.question-type-label');
							}

						});
					});			
				}

				function rewrapElements(selector, type) {

					// Get the start date
					waitForElem(`${selector}`).then(() => {
						const startDate = $('[data-integration-timesheet-integration-id="start_date"]').find('input').val();
						console.log('Start date is: ');
						console.log(startDate);

						setTimeout(function(){	
							
							removeTimesheetsWrapping(selector, function(){
								// Iterate over each '.question-type-label' element
								$(selector).each(function(i) {
									// Start with the current '.question-type-label'
									var $start = $(this);
	
									// Add the next two siblings to the selection
									if (type === 'single-field') {
										var $elementsToWrap = $start;
									} else {
										var $elementsToWrap = $start.add($start.next()).add($start.next().next());
									}
									
									// Wrap these three elements with a new div
									$elementsToWrap.wrapAll(`<div class="date-and-time-wrapper box-${i} ${type === 'single-field' ? `single-field` : ``}"></div>`);
	
									// Append the start date into the container
									if ( startDate !== '') {
										var givenDate = moment(startDate, "DD/MM/YYYY");  // Parse the given start date
										var originalMonth = givenDate.month();  // Store the original month
	
										var newDate = givenDate.clone().add(i, 'days');  // Clone the date and add 'i' days
										var newMonth = newDate.month();  // Get the month of the new date
	
										// Adding the date to the box.
										if (type === 'single-field') {
											$(selector).closest('.date-and-time-wrapper.box-' + i).find('.js-small-date').remove();
											$(selector).closest('.date-and-time-wrapper.box-' + i).find('.question-type-text label').append('<small class="js-small-date">' + formatDate(newDate) + '</small>');
											$(selector).closest('.date-and-time-wrapper.box-' + i).find('.question-type-singlecheckbox label').append('<small class="js-small-date">' + formatDate(newDate) + '</small>');

										} else {
											$(selector).closest('.date-and-time-wrapper.box-' + i).find('.question-type-label p div .js-small-date').remove();
											$(selector).closest('.date-and-time-wrapper.box-' + i).find('.question-type-label p div').append('<small class="js-small-date">' + formatDate(newDate) + '</small>');
										}
									}
								});
	
								$(selector).closest('.date-and-time-wrapper').wrapAll('<div class="overall-date-and-time-wrapper"></div>');
							});

						}, 50);
					});

				}

				function validateTimesheet(callback) {
					const contractedTime = $('.buyer-info__container > div:last-child > span:last-child').text();
					let timeSheetTime = $('.form-calculation__question-value').text();
					// const parsedTotalTimeSheet = Math.ceil(parseFloat(timeSheetTime));
					const parsedTotalTimeSheet = parseFloat(timeSheetTime).toFixed(2);
					const parsedContractedTime = parseFloat(contractedTime);

					const notesText = $('[data-integration-timesheet-integration-id="notes"] textarea').val();

					// console.log('parsedTotalTimeSheet is: ')
					// console.log(parsedTotalTimeSheet);

					if ( notesText.length > 200) {
						createPop('Notes is too long', `<p>You have exceeded the 200 character limit. Please review your not and resubmit.</p>`, 50000)
						return;
					}

					// Check there is data first
					if ( parsedTotalTimeSheet === 0 || isNaN(parsedTotalTimeSheet)) {

						const pto = $('[data-integration-timesheet-integration-id="holidays_amount"] input').val();
						const mileage = $('[data-integration-timesheet-integration-id="miles_amount"] input').val();
						const expenses = $('[data-integration-timesheet-integration-id="expenses_amount"] input').val();
						// console.log('pto')
						// console.log(pto)

						// Guard clauses to prevent no values being sent
						if (   (mileage == 0 || mileage == undefined)   
							&& (pto == 0 || pto == undefined) 
							&& (expenses == 0 || expenses == undefined)
						) {
							//alert(`Your timesheet is empty, please review your timesheet`)
							createPop('Please review', `<p>Your timesheet is empty, please review before resubmitting.</p>`, 50000)
							return;
						}

					}

					if (  parsedTotalTimeSheet > parsedContractedTime ) {
						//alert(`You cannot exceed your hours past your contracted time of ${contractedTime} hours`);
						createPop('Please review', `<p>You cannot submit more than your contracted time of ${contractedTime} hours.</p>`, 50000)
						return;


					} else {

						// // Check on the Finish buton if it exists otherwise click on next
						// if ($('.form-navigation-btns__btn_finish').length > 0) {
						// 	$('.form-navigation-btns__btn_finish').click();
						// } else {
						// 	$('.form-navigation-btns__btn_next').click();
						// }
					}

					// Validate hours input boxes
					const mondayHours = $('[data-integration-timesheet-integration-id="monday_1_hours"] input').val();
					const tuesdayHours = $('[data-integration-timesheet-integration-id="tuesday_1_hours"] input').val();
					const wednesdayHours = $('[data-integration-timesheet-integration-id="wednesday_1_hours"] input').val();
					const thursdayHours = $('[data-integration-timesheet-integration-id="thursday_1_hours"] input').val();
					const fridayHours = $('[data-integration-timesheet-integration-id="friday_1_hours"] input').val();
					const saturdayHours = $('[data-integration-timesheet-integration-id="saturday_1_hours"] input').val();
					const sundayHours = $('[data-integration-timesheet-integration-id="sunday_1_hours"] input').val();

					if ( 
						mondayHours > 24 ||
						tuesdayHours > 24 ||
						wednesdayHours > 24 ||
						thursdayHours > 24 ||
						fridayHours > 24 ||
						saturdayHours > 24 ||
						sundayHours > 24
					) {
						createPop('Please review', `<p>Hours cannot exceed 24 hours</p>`, 50000)
						return;
					}

					// Validate minutes input boxes
					const mondayMinutes = $('[data-integration-timesheet-integration-id="monday_1_minutes"] input').val();
					const tuesdayMinutes = $('[data-integration-timesheet-integration-id="tuesday_1_minutes"] input').val();
					const wednesdayMinutes = $('[data-integration-timesheet-integration-id="wednesday_1_minutes"] input').val();
					const thursdayMinutes = $('[data-integration-timesheet-integration-id="thursday_1_minutes"] input').val();
					const fridayMinutes = $('[data-integration-timesheet-integration-id="friday_1_minutes"] input').val();
					const saturdayMinutes = $('[data-integration-timesheet-integration-id="saturday_1_minutes"] input').val();
					const sundayMinutes = $('[data-integration-timesheet-integration-id="sunday_1_minutes"] input').val();

					if ( 
						mondayMinutes > 59 ||
						tuesdayMinutes > 59 ||
						wednesdayMinutes > 59 ||
						thursdayMinutes > 59 ||
						fridayMinutes > 59 ||
						saturdayMinutes > 59 ||
						sundayMinutes > 59
					) {
						createPop('Please review', `<p>Minutes cannot exceed 59 minutes</p>`, 50000)
						return;
					}

					callback();

					
				}

				function showFinishButtonAndNotes(){
					$('body').addClass('show-finish-btn');
				}

				function showPTOMileageExpensesChecklists() {

					const element = document.querySelector('sc-fill-form-app.js-api-component');

					// Get the 'pipe-values' attribute
					const pipeValues = element.getAttribute('additional-data');

					// Decode HTML entities and parse JSON
					const decodedJson = decodeURIComponent(pipeValues.replace(/&quot;/g, '"'));
					const parsedValues = JSON.parse(decodedJson);

					// Extract the 'individualId' value
					const individualId = parsedValues.individualId;

					let isPTOAvailable;
					let isMileageAvailable;
					let isExpensesAvailable;
					let isSleepInAvailable;

					$('body').removeClass('show-pto');
					$('body').removeClass('show-mileage');
					$('body').removeClass('show-expenses');
					$('body').removeClass('show-sleepin');

					// Get PTO data
					getTimesheetCategoryEndpoint(individualId, '76536913-464b-4988-926b-c6d2c5f8d135', function(ptoData) {
						ptoData.data.list.length === 0 ? isPTOAvailable = false : isPTOAvailable = true;

						// Get Mileage data
						getTimesheetCategoryEndpoint(individualId, '80b13f90-11d4-44dc-a057-d0b379ad685f', function(mileageData) {
							mileageData.data.list.length === 0 ? isMileageAvailable = false : isMileageAvailable = true;

							// Get Expenses data
							getTimesheetCategoryEndpoint(individualId, '24c3e86c-8fa1-49dd-98ea-8eecbadd8358', function(expensesData) {
								expensesData.data.list.length === 0 ? isExpensesAvailable = false : isExpensesAvailable = true;

								// Get Sleep in data
								getTimesheetCategoryEndpoint(individualId, '0c2e85ff-be78-46d1-acfc-f8318fc2d65e', function(expensesData) {
								expensesData.data.list.length === 0 ? isSleepInAvailable = false : isSleepInAvailable = true;

									if ( isPTOAvailable === true ) {
									// 	$('[data-integration-timesheet-integration-id="pto"]').show();
										$('body').addClass('show-pto');
									}
									if ( isMileageAvailable === true ) {
										// $('[data-integration-timesheet-integration-id="mileage"]').show();
										$('body').addClass('show-mileage');
									}
									if ( isExpensesAvailable === true ) {
										// $('[data-integration-timesheet-integration-id="expenses"]').show();
										$('body').addClass('show-expenses');
									}
									if ( isSleepInAvailable === true ) {
										// $('[data-integration-timesheet-integration-id="support"]').show();
										$('body').addClass('show-sleepin');
									}
								 });
							});
						});
					});
				}

				function formatDate(momentDate) {
					// Getting the day as a number
					const day = momentDate.date();
					// Formatting the month name
					const month = momentDate.format('MMMM');
					
					// Function to determine the ordinal suffix
					function getOrdinal(n) {
						const s = ["th", "st", "nd", "rd"],
							  v = n % 100;
						return n + (s[(v - 20) % 10] || s[v] || s[0]);
					}
				
					// Combine day with its ordinal suffix and month name
					return getOrdinal(day) + " " + month;
				}
	
				// Create timesheet styling
				if(pagePath === '/s4s/MyOrders'){
	
					// Add class the page
					$('body').addClass('my-orders');
	
					fullColAltRmClass();
					myAccountWrapper();
					heroWrapper();
					displaySizeWrap();

					$('tr').removeClass();
	
					$('.itemSort').addClass('show-orders-input');
					$('.show-orders-input').removeClass('itemSort tint3 orders');
					$('.show-orders-input').removeAttr('style');
	
					// Add class to main section items
					$('.show-orders-input, .grid.noTabs, .pagination-sort').addClass('main-section-item');
	
					// Wrap main sections items in container
					$('.main-section-item').wrapAll(`<div class="main-section container"></div>`);
	
					// Wrap main section in desiplay container
					mainSectionWrap('orders-s');
					$('.orders-s').wrapAll('<div class="orders-list-section"></div>');
	
					// Remove class from table buttons
					$('td a').removeClass();
				}

				// Login page styling
				if(pagePath === '/s4s/Auth'){
	
					// Add class the page
					$('body').addClass('Auth');
	
					$('.contentWrapper.loginBackground').removeClass('loginBackground');
					
				}

				// Catalogue products - Live page styling
				if(pagePath === '/s4s/CatalogueProductsAdministration/Live'){
	
					// Add class the page
					$('body').addClass('catalogue-products-live');	
				}

				// Fill form styling
				if(pagePath.includes('/FormDetails/FillForm') || pagePath.includes('/MyAssessments/Edit/')) {

					// Add class the page
					$('body').addClass('fill-form');
	
					var checkExistApp = setInterval(function() {
						
						if ($('sc-fill-form-app .mainheader').length > 0) {
							
							clearInterval(checkExistApp);
	
							// Edit hero section and add hero container
							$('.mainheader').addClass('hero-text-container');
							$('.hero-text-container').removeClass('mainheader tint3');
							$('.s4s-pathway-header-container').addClass('hero-container');
							$('.hero-container').removeClass('s4s-pathway-header-container');
							heroWrapper();
							displaySizeWrap();

							$('.hero-section + .section').addClass('main-section');
							$('.main-section .pad20').addClass('main-section-container');
							$('.main-section-container').removeClass('pad20');
							$('.main-section-continer .section').removeClass('section');
							$('h3').parent('.fill-form-question-label').addClass('flex-label')

							// Edit buttons section
							$('.answer-btns button').removeClass();
							$('.answer-btns button').addClass('blue-btn');
						}

					}, 200);
				}


				if ( pageUrl.includes('/FormDetails/FillForm')) {
					var checkExistC = setInterval(function() {
						if ($('.s4s-pathway-header-container').length > 0) {
				
							setTimeout(function(){	
								$('.answer-btns button').each(function(){
									if ( $(this).html() === 'Save' ) {
										$(this).hide();
									}
								});
								clearInterval(checkExistC);
							}, 30);
						}
					}, 20);
			
					var checkAppForm = setInterval(function() {
						if ($('sc-fill-form-app .form-header').length > 0) {

							clearInterval(checkAppForm);
							$('body').addClass('legacy-forms');

							// Edit hero section and add hero container
							if ( $('.hero-section').length === 0 ) {
								$('.form-header').addClass('hero-text-container');
								$('.hero-text-container').wrap('<div class="hero-container"></div>');
								heroWrapper();
								displaySizeWrap();
							}

							tableLabels();

							$('body').on('change', 'input', function(){
								tableLabels();
							})

							$('body').on('click', '.forms-add-button', function(){
								tableLabels();
							})
						}
					}, 200); // check every 100ms 
				}


				// Purchase order details notes tab stlying
				if(pagePath.includes('/CatalogueLiveProductDetailsAdministration')) {
	
					// Add class the page
					$('body').addClass('catalogue-products-edit');

					// Add class to checkbox/radio inputs
					$('input').each(function(i, el){

						if($(this).attr('type') === 'checkbox' || $(this).attr('type') === 'radio'){
							$(this).parent().addClass('inline-input');
						}

					});

					$('br').remove();
					$('#chageCategoryButtonId').removeClass();
					$('.tiny-mce-overlay').parent().addClass('product-description-container');					
				}


				// Work as page styling
				if ( pageUrl.includes('/WorkAs')) {

					// Added on 20th May 2024 for Lincolnshire as they are not using OE fully 
					// CORE-950 update AR work as settings for Lincolnshire OE
					if ($.sc.authSettings.pplId !== null && $.sc.authSettings.organisationId !== '4904d5d2-482a-41a9-9153-9e360154daa2' && $.sc.authSettings.isAuthorizedRepresentative === true ) {
						window.location.href = "/s4s/CustomPage/Index/" + Urls.myParticipants;
					}

					// Add class the page
					$('body').addClass('work-as');

					// Remove old page container class
					$('.contentFixed').removeClass();
	
					// Add classes/divs to hero text
					myAccountWrapper();
					heroWrapper();
					displaySizeWrap();
					$('#content-holder').addClass('main-section');
					mainSectionWrap('work-a');
					$('.work-a').wrapAll('<div class="work-as-list-section"></div>');

					// Add/remove class to items list container
					$('#onlineStores').addClass('work-as-list-item-container');
					$('#onlineStores').removeClass('actAs');
					$('#onlineStores li').addClass('work-as-list-item');
					$('.store-proportions').hide();
					$('.work-as-list-item a').addClass('item-details-section');
					$('.noneheight').remove();

					$('.main-section .section').addClass('filter-section');
					$('.filter-section .border.pad10.mar-bot1').addClass('filter-container');
					$('.filter-container').removeClass('border pad10 mar-bot1 mar-right20px tint7');
					$('.filter-container').prepend(`<label>Sort by:</label>`);
					$('.js-predictive-search').addClass('searchbar');
					$('.js-search-button').addClass('blue-btn');
				}


				if ( pageUrl.includes('/EventAdministrationDetails/EventDetails/')) {

					// Add class the page
					$('body').addClass('event-admin-details-event-details');
	
					$('.col.span_4_of_12.mar-top1').addClass('attributes-list-container');
					$('.attributes-list-container .section.mar-top1').addClass('attribute-item-container');
				}

			},
	
			bindUIActions: function() {

				// Clear the input box when search button is clicked on the Address component
				$('body').on('click', '.form-address-search__search-input button.search-button', function(){
					console.log('Button clicked');
			
					setTimeout(function(){
						$(this).closest('.form-address-search__search-input').find("input[type=text]").val("");
					//   $("input[type=text]").val("")
					}, 300);
				});
				
				$('body').on('click', '.js-enrollments-btn', function(){
					window.location.href = '/s4s/';
				});
	
				// Hack on field
				$('body').on('keyup', '.social-security input', function(){
				
					var thisText = $(this).val();
					var thisTarget = $(this).next().find('.js-social-security-input');
	
					$(thisTarget).text(thisText);
	
				});
	
	
				$('body').on({
					mouseenter: function () {
						$('.js-messages-toggle').removeClass('hide');
					},
					mouseleave: function () {
						$('.js-messages-toggle').addClass('hide');
					}
				}, '.js-messages-alert'); //pass the element as an argument to .on          
	

				$('body').on('keydown', function(e) {
					var keycode = (window.event) ? event.keyCode : e.keyCode;
						if (keycode == 9){
					// console.log('User is using tab key and could be keyboard only user');
							$('body').addClass('keyboardUser');
				
					}
				});
				
				// Retrigger DOM adjustments on paging
				$('body').on('click', '.form-navigation-btns__button', function(){
					if ( !$('body').hasClass('timesheet-details') && !$('body').hasClass('create-timesheet') ) {
						Init.adjustDom();
					}
					
				});
				$('body').on('click', '.navigation-bar__item', function(){
					Init.adjustDom();
				});
	
				$('body').on('change', '.form-checkbox__option input', function(){
					scanForm();
				});
	
				$('body').on('change', '.form-radio__option input', function(){
					scanForm();
				});
	
	
				$('body').on('click', '.js-pcg-dropdown-menu .trigger, .js-pcg-dropdown-menu .group', function(e) {
					e.preventDefault();
	
					$(this).parent().find('.panel').toggle();
				})


				// Scroll back to top button
				if($('.js-floating-back-to-top-button').length > 0){

					$('.js-floating-back-to-top-button').on({
						
						click: function(e){
							console.log('its lcikced')
							e.preventDefault();
	
							$('.page-content-scroll').animate({
								scrollTop: $('.page-content-scroll').offset().top
							}, 800)
						},
	
						keypress: function(e){
							e.preventDefault();
	
							if(e.which == 13) {
								$('.page-content-scroll').animate({
									scrollTop: $('.page-content-scroll').offset().top
								}, 800);
							};
						},
	
					});

				}

				document.querySelector('.skip-to-content').addEventListener('click', function(e) {
					e.preventDefault();
					scrollToMain();
				});
				
				document.querySelector('.skip-to-content').addEventListener('keypress', function(e) {
					if (e.key === 'Enter') {
						e.preventDefault();
						scrollToMain();
					}
				});


				// Toggles the mobile navbar dropdown and the display behind the navbar scroll
				$('.js-header-nav_top-burger-img').on({
	
					click: function(){
						
						$('.header-nav_bottom-section').slideToggle();
						$('body').toggleClass('no-scroll');
			
						if($('.header-nav_top-burger-img').hasClass('fa-bars')){
							// Changes toggle icon from burger to X when clicked
							$('.header-nav_top-burger-img').removeClass('fa-bars');
							$('.header-nav_top-burger-img').addClass('fa-times');
				
						} else if($('.header-nav_top-burger-img').hasClass('fa-times')){
							// Changes toggle icon from X to burger when clicked
							$('.header-nav_top-burger-img').removeClass('fa-times');
							$('.header-nav_top-burger-img').addClass('fa-bars');
						}
						
					},
			
					keypress: function(e){
			
						if(e.which == 13) {
							
							$('.header-nav_bottom-section').slideToggle();
							$('body').toggleClass('no-scroll');
			
							if($('.header-nav_top-burger-img').hasClass('fa-bars')){
								// Changes toggle icon from burger to X when clicked
								$('.header-nav_top-burger-img').removeClass('fa-bars');
								$('.header-nav_top-burger-img').addClass('fa-times');
					
							} else if($('.header-nav_top-burger-img').hasClass('fa-times')){
								// Changes toggle icon from X to burger when clicked
								$('.header-nav_top-burger-img').removeClass('fa-times');
								$('.header-nav_top-burger-img').addClass('fa-bars');
							}
			
						}
			
					}
			
				});
	
	
				
			},
	
			unload: function() {
	
			}
		};
		Init.init();
	});
})();